var kd = Object.create;
var mn = Object.defineProperty;
var Bd = Object.getOwnPropertyDescriptor;
var Od = Object.getOwnPropertyNames;
var Nd = Object.getPrototypeOf, Dd = Object.prototype.hasOwnProperty;
var o = (e, t) => mn(e, "name", { value: t, configurable: !0 }), Or = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy <
"u" ? new Proxy(e, {
  get: (t, r) => (typeof require < "u" ? require : t)[r]
}) : e)(function(e) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + e + '" is not supported');
});
var S = (e, t) => () => (e && (t = e(e = 0)), t);
var z = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), Nr = (e, t) => {
  for (var r in t)
    mn(e, r, { get: t[r], enumerable: !0 });
}, _d = (e, t, r, n) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of Od(t))
      !Dd.call(e, a) && a !== r && mn(e, a, { get: () => t[a], enumerable: !(n = Bd(t, a)) || n.enumerable });
  return e;
};
var ve = (e, t, r) => (r = e != null ? kd(Nd(e)) : {}, _d(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? mn(r, "default", { value: e, enumerable: !0 }) : r,
  e
));

// ../node_modules/memoizerific/memoizerific.js
var Dr = z((sl, Lo) => {
  (function(e) {
    if (typeof sl == "object" && typeof Lo < "u")
      Lo.exports = e();
    else if (typeof define == "function" && define.amd)
      define([], e);
    else {
      var t;
      typeof window < "u" ? t = window : typeof global < "u" ? t = global : typeof self < "u" ? t = self : t = this, t.memoizerific = e();
    }
  })(function() {
    var e, t, r;
    return (/* @__PURE__ */ o(function n(a, i, c) {
      function l(f, d) {
        if (!i[f]) {
          if (!a[f]) {
            var m = typeof Or == "function" && Or;
            if (!d && m) return m(f, !0);
            if (s) return s(f, !0);
            var g = new Error("Cannot find module '" + f + "'");
            throw g.code = "MODULE_NOT_FOUND", g;
          }
          var x = i[f] = { exports: {} };
          a[f][0].call(x.exports, function(p) {
            var h = a[f][1][p];
            return l(h || p);
          }, x, x.exports, n, a, i, c);
        }
        return i[f].exports;
      }
      o(l, "s");
      for (var s = typeof Or == "function" && Or, u = 0; u < c.length; u++) l(c[u]);
      return l;
    }, "e"))({ 1: [function(n, a, i) {
      a.exports = function(c) {
        if (typeof Map != "function" || c) {
          var l = n("./similar");
          return new l();
        } else
          return /* @__PURE__ */ new Map();
      };
    }, { "./similar": 2 }], 2: [function(n, a, i) {
      function c() {
        return this.list = [], this.lastItem = void 0, this.size = 0, this;
      }
      o(c, "Similar"), c.prototype.get = function(l) {
        var s;
        if (this.lastItem && this.isEqual(this.lastItem.key, l))
          return this.lastItem.val;
        if (s = this.indexOf(l), s >= 0)
          return this.lastItem = this.list[s], this.list[s].val;
      }, c.prototype.set = function(l, s) {
        var u;
        return this.lastItem && this.isEqual(this.lastItem.key, l) ? (this.lastItem.val = s, this) : (u = this.indexOf(l), u >= 0 ? (this.lastItem =
        this.list[u], this.list[u].val = s, this) : (this.lastItem = { key: l, val: s }, this.list.push(this.lastItem), this.size++, this));
      }, c.prototype.delete = function(l) {
        var s;
        if (this.lastItem && this.isEqual(this.lastItem.key, l) && (this.lastItem = void 0), s = this.indexOf(l), s >= 0)
          return this.size--, this.list.splice(s, 1)[0];
      }, c.prototype.has = function(l) {
        var s;
        return this.lastItem && this.isEqual(this.lastItem.key, l) ? !0 : (s = this.indexOf(l), s >= 0 ? (this.lastItem = this.list[s], !0) :
        !1);
      }, c.prototype.forEach = function(l, s) {
        var u;
        for (u = 0; u < this.size; u++)
          l.call(s || this, this.list[u].val, this.list[u].key, this);
      }, c.prototype.indexOf = function(l) {
        var s;
        for (s = 0; s < this.size; s++)
          if (this.isEqual(this.list[s].key, l))
            return s;
        return -1;
      }, c.prototype.isEqual = function(l, s) {
        return l === s || l !== l && s !== s;
      }, a.exports = c;
    }, {}], 3: [function(n, a, i) {
      var c = n("map-or-similar");
      a.exports = function(f) {
        var d = new c(!1), m = [];
        return function(g) {
          var x = /* @__PURE__ */ o(function() {
            var p = d, h, v, w = arguments.length - 1, R = Array(w + 1), y = !0, E;
            if ((x.numArgs || x.numArgs === 0) && x.numArgs !== w + 1)
              throw new Error("Memoizerific functions should always be called with the same number of arguments");
            for (E = 0; E < w; E++) {
              if (R[E] = {
                cacheItem: p,
                arg: arguments[E]
              }, p.has(arguments[E])) {
                p = p.get(arguments[E]);
                continue;
              }
              y = !1, h = new c(!1), p.set(arguments[E], h), p = h;
            }
            return y && (p.has(arguments[w]) ? v = p.get(arguments[w]) : y = !1), y || (v = g.apply(null, arguments), p.set(arguments[w], v)),
            f > 0 && (R[w] = {
              cacheItem: p,
              arg: arguments[w]
            }, y ? l(m, R) : m.push(R), m.length > f && s(m.shift())), x.wasMemoized = y, x.numArgs = w + 1, v;
          }, "memoizerific");
          return x.limit = f, x.wasMemoized = !1, x.cache = d, x.lru = m, x;
        };
      };
      function l(f, d) {
        var m = f.length, g = d.length, x, p, h;
        for (p = 0; p < m; p++) {
          for (x = !0, h = 0; h < g; h++)
            if (!u(f[p][h].arg, d[h].arg)) {
              x = !1;
              break;
            }
          if (x)
            break;
        }
        f.push(f.splice(p, 1)[0]);
      }
      o(l, "moveToMostRecentLru");
      function s(f) {
        var d = f.length, m = f[d - 1], g, x;
        for (m.cacheItem.delete(m.arg), x = d - 2; x >= 0 && (m = f[x], g = m.cacheItem.get(m.arg), !g || !g.size); x--)
          m.cacheItem.delete(m.arg);
      }
      o(s, "removeCachedResult");
      function u(f, d) {
        return f === d || f !== f && d !== d;
      }
      o(u, "isEqual");
    }, { "map-or-similar": 1 }] }, {}, [3])(3);
  });
});

// ../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function Jt(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
var hn = S(() => {
  o(Jt, "_objectWithoutPropertiesLoose");
});

// ../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
function ul(e, t) {
  if (e == null) return {};
  var r, n, a = Jt(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) === -1 && {}.propertyIsEnumerable.call(e, r) && (a[r] = e[r]);
  }
  return a;
}
var fl = S(() => {
  hn();
  o(ul, "_objectWithoutProperties");
});

// ../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _r(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
  return n;
}
var Ao = S(() => {
  o(_r, "_arrayLikeToArray");
});

// ../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function dl(e) {
  if (Array.isArray(e)) return _r(e);
}
var pl = S(() => {
  Ao();
  o(dl, "_arrayWithoutHoles");
});

// ../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function ml(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
var hl = S(() => {
  o(ml, "_iterableToArray");
});

// ../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function vl(e, t) {
  if (e) {
    if (typeof e == "string") return _r(e, t);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.
    test(r) ? _r(e, t) : void 0;
  }
}
var gl = S(() => {
  Ao();
  o(vl, "_unsupportedIterableToArray");
});

// ../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function wl() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Rl = S(() => {
  o(wl, "_nonIterableSpread");
});

// ../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
function xl(e) {
  return dl(e) || ml(e) || vl(e) || wl();
}
var bl = S(() => {
  pl();
  hl();
  gl();
  Rl();
  o(xl, "_toConsumableArray");
});

// ../node_modules/@babel/runtime/helpers/esm/typeof.js
function It(e) {
  "@babel/helpers - typeof";
  return It = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, It(e);
}
var Io = S(() => {
  o(It, "_typeof");
});

// ../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function yl(e, t) {
  if (It(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t || "default");
    if (It(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
var El = S(() => {
  Io();
  o(yl, "toPrimitive");
});

// ../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function Cl(e) {
  var t = yl(e, "string");
  return It(t) == "symbol" ? t : t + "";
}
var Sl = S(() => {
  Io();
  El();
  o(Cl, "toPropertyKey");
});

// ../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function vn(e, t, r) {
  return (t = Cl(t)) in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
var Ho = S(() => {
  Sl();
  o(vn, "_defineProperty");
});

// ../node_modules/@babel/runtime/helpers/esm/extends.js
function Ie() {
  return Ie = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ie.apply(null, arguments);
}
var gn = S(() => {
  o(Ie, "_extends");
});

// ../node_modules/react-syntax-highlighter/dist/esm/create-element.js
import jd from "react";
function Ml(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function Qt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ml(Object(r), !0).forEach(function(n) {
      vn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ml(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Ud(e) {
  var t = e.length;
  if (t === 0 || t === 1) return e;
  if (t === 2)
    return [e[0], e[1], "".concat(e[0], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0])];
  if (t === 3)
    return [e[0], e[1], e[2], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0]), "".concat(
    e[1], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(
    e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(
    e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0])];
  if (t >= 4)
    return [e[0], e[1], e[2], e[3], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3]),
    "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0]),
    "".concat(e[2], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3]), "".concat(e[3], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1]),
    "".concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3]),
    "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[3],
    ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1],
    ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2], ".").concat(
    e[3]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[2], ".").concat(
    e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0]), "".concat(
    e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(
    e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(
    e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(
    e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(
    e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(
    e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(
    e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(
    e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(
    e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(
    e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(
    e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(
    e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(
    e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(
    e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(
    e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(
    e[2], ".").concat(e[1], ".").concat(e[0])];
}
function qd(e) {
  if (e.length === 0 || e.length === 1) return e;
  var t = e.join(".");
  return To[t] || (To[t] = Ud(e)), To[t];
}
function Gd(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0, n = e.filter(
  function(i) {
    return i !== "token";
  }), a = qd(n);
  return a.reduce(function(i, c) {
    return Qt(Qt({}, i), r[c]);
  }, t);
}
function Ll(e) {
  return e.join(" ");
}
function Xd(e, t) {
  var r = 0;
  return function(n) {
    return r += 1, n.map(function(a, i) {
      return Ht({
        node: a,
        stylesheet: e,
        useInlineStyles: t,
        key: "code-segment-".concat(r, "-").concat(i)
      });
    });
  };
}
function Ht(e) {
  var t = e.node, r = e.stylesheet, n = e.style, a = n === void 0 ? {} : n, i = e.useInlineStyles, c = e.key, l = t.properties, s = t.type, u = t.
  tagName, f = t.value;
  if (s === "text")
    return f;
  if (u) {
    var d = Xd(r, i), m;
    if (!i)
      m = Qt(Qt({}, l), {}, {
        className: Ll(l.className)
      });
    else {
      var g = Object.keys(r).reduce(function(v, w) {
        return w.split(".").forEach(function(R) {
          v.includes(R) || v.push(R);
        }), v;
      }, []), x = l.className && l.className.includes("token") ? ["token"] : [], p = l.className && x.concat(l.className.filter(function(v) {
        return !g.includes(v);
      }));
      m = Qt(Qt({}, l), {}, {
        className: Ll(p) || void 0,
        style: Gd(l.className, Object.assign({}, l.style, a), r)
      });
    }
    var h = d(t.children);
    return /* @__PURE__ */ jd.createElement(u, Ie({
      key: c
    }, m), h);
  }
}
var To, zo = S(() => {
  gn();
  Ho();
  o(Ml, "ownKeys");
  o(Qt, "_objectSpread");
  o(Ud, "powerSetPermutations");
  To = {};
  o(qd, "getClassNameCombinations");
  o(Gd, "createStyleObject");
  o(Ll, "createClassNameString");
  o(Xd, "createChildren");
  o(Ht, "createElement");
});

// ../node_modules/react-syntax-highlighter/dist/esm/checkForListedLanguage.js
var Al, Il = S(() => {
  Al = /* @__PURE__ */ o(function(e, t) {
    var r = e.listLanguages();
    return r.indexOf(t) !== -1;
  }, "default");
});

// ../node_modules/react-syntax-highlighter/dist/esm/highlight.js
import Tt from "react";
function Hl(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function rt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Hl(Object(r), !0).forEach(function(n) {
      vn(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Hl(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function Kd(e) {
  return e.match(Yd);
}
function Jd(e) {
  var t = e.lines, r = e.startingLineNumber, n = e.style;
  return t.map(function(a, i) {
    var c = i + r;
    return /* @__PURE__ */ Tt.createElement("span", {
      key: "line-".concat(i),
      className: "react-syntax-highlighter-line-number",
      style: typeof n == "function" ? n(c) : n
    }, "".concat(c, `
`));
  });
}
function Qd(e) {
  var t = e.codeString, r = e.codeStyle, n = e.containerStyle, a = n === void 0 ? {
    float: "left",
    paddingRight: "10px"
  } : n, i = e.numberStyle, c = i === void 0 ? {} : i, l = e.startingLineNumber;
  return /* @__PURE__ */ Tt.createElement("code", {
    style: Object.assign({}, r, a)
  }, Jd({
    lines: t.replace(/\n$/, "").split(`
`),
    style: c,
    startingLineNumber: l
  }));
}
function ep(e) {
  return "".concat(e.toString().length, ".25em");
}
function Tl(e, t) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(e),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: t
    },
    children: [{
      type: "text",
      value: e
    }]
  };
}
function zl(e, t, r) {
  var n = {
    display: "inline-block",
    minWidth: ep(r),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, a = typeof e == "function" ? e(t) : e, i = rt(rt({}, n), a);
  return i;
}
function wn(e) {
  var t = e.children, r = e.lineNumber, n = e.lineNumberStyle, a = e.largestLineNumber, i = e.showInlineLineNumbers, c = e.lineProps, l = c ===
  void 0 ? {} : c, s = e.className, u = s === void 0 ? [] : s, f = e.showLineNumbers, d = e.wrapLongLines, m = typeof l == "function" ? l(r) :
  l;
  if (m.className = u, r && i) {
    var g = zl(n, r, a);
    t.unshift(Tl(r, g));
  }
  return d & f && (m.style = rt(rt({}, m.style), {}, {
    display: "flex"
  })), {
    type: "element",
    tagName: "span",
    properties: m,
    children: t
  };
}
function Pl(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] :
  [], n = 0; n < e.length; n++) {
    var a = e[n];
    if (a.type === "text")
      r.push(wn({
        children: [a],
        className: xl(new Set(t))
      }));
    else if (a.children) {
      var i = t.concat(a.properties.className);
      Pl(a.children, i).forEach(function(c) {
        return r.push(c);
      });
    }
  }
  return r;
}
function tp(e, t, r, n, a, i, c, l, s) {
  var u, f = Pl(e.value), d = [], m = -1, g = 0;
  function x(E, b) {
    var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return wn({
      children: E,
      lineNumber: b,
      lineNumberStyle: l,
      largestLineNumber: c,
      showInlineLineNumbers: a,
      lineProps: r,
      className: C,
      showLineNumbers: n,
      wrapLongLines: s
    });
  }
  o(x, "createWrappedLine");
  function p(E, b) {
    if (n && b && a) {
      var C = zl(l, b, c);
      E.unshift(Tl(b, C));
    }
    return E;
  }
  o(p, "createUnwrappedLine");
  function h(E, b) {
    var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return t || C.length > 0 ? x(E, b, C) : p(E, b);
  }
  o(h, "createLine");
  for (var v = /* @__PURE__ */ o(function() {
    var b = f[g], C = b.children[0].value, L = Kd(C);
    if (L) {
      var M = C.split(`
`);
      M.forEach(function(A, P) {
        var F = n && d.length + i, _ = {
          type: "text",
          value: "".concat(A, `
`)
        };
        if (P === 0) {
          var Y = f.slice(m + 1, g).concat(wn({
            children: [_],
            className: b.properties.className
          })), T = h(Y, F);
          d.push(T);
        } else if (P === M.length - 1) {
          var H = f[g + 1] && f[g + 1].children && f[g + 1].children[0], k = {
            type: "text",
            value: "".concat(A)
          };
          if (H) {
            var W = wn({
              children: [k],
              className: b.properties.className
            });
            f.splice(g + 1, 0, W);
          } else {
            var D = [k], $ = h(D, F, b.properties.className);
            d.push($);
          }
        } else {
          var B = [_], q = h(B, F, b.properties.className);
          d.push(q);
        }
      }), m = g;
    }
    g++;
  }, "_loop"); g < f.length; )
    v();
  if (m !== f.length - 1) {
    var w = f.slice(m + 1, f.length);
    if (w && w.length) {
      var R = n && d.length + i, y = h(w, R);
      d.push(y);
    }
  }
  return t ? d : (u = []).concat.apply(u, d);
}
function rp(e) {
  var t = e.rows, r = e.stylesheet, n = e.useInlineStyles;
  return t.map(function(a, i) {
    return Ht({
      node: a,
      stylesheet: r,
      useInlineStyles: n,
      key: "code-segement".concat(i)
    });
  });
}
function kl(e) {
  return e && typeof e.highlightAuto < "u";
}
function np(e) {
  var t = e.astGenerator, r = e.language, n = e.code, a = e.defaultCodeValue;
  if (kl(t)) {
    var i = Al(t, r);
    return r === "text" ? {
      value: a,
      language: "text"
    } : i ? t.highlight(r, n) : t.highlightAuto(n);
  }
  try {
    return r && r !== "text" ? {
      value: t.highlight(n, r)
    } : {
      value: a
    };
  } catch {
    return {
      value: a
    };
  }
}
function Po(e, t) {
  return /* @__PURE__ */ o(function(n) {
    var a = n.language, i = n.children, c = n.style, l = c === void 0 ? t : c, s = n.customStyle, u = s === void 0 ? {} : s, f = n.codeTagProps,
    d = f === void 0 ? {
      className: a ? "language-".concat(a) : void 0,
      style: rt(rt({}, l['code[class*="language-"]']), l['code[class*="language-'.concat(a, '"]')])
    } : f, m = n.useInlineStyles, g = m === void 0 ? !0 : m, x = n.showLineNumbers, p = x === void 0 ? !1 : x, h = n.showInlineLineNumbers, v = h ===
    void 0 ? !0 : h, w = n.startingLineNumber, R = w === void 0 ? 1 : w, y = n.lineNumberContainerStyle, E = n.lineNumberStyle, b = E === void 0 ?
    {} : E, C = n.wrapLines, L = n.wrapLongLines, M = L === void 0 ? !1 : L, A = n.lineProps, P = A === void 0 ? {} : A, F = n.renderer, _ = n.
    PreTag, Y = _ === void 0 ? "pre" : _, T = n.CodeTag, H = T === void 0 ? "code" : T, k = n.code, W = k === void 0 ? (Array.isArray(i) ? i[0] :
    i) || "" : k, D = n.astGenerator, $ = ul(n, Zd);
    D = D || e;
    var B = p ? /* @__PURE__ */ Tt.createElement(Qd, {
      containerStyle: y,
      codeStyle: d.style || {},
      numberStyle: b,
      startingLineNumber: R,
      codeString: W
    }) : null, q = l.hljs || l['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    }, Se = kl(D) ? "hljs" : "prismjs", he = g ? Object.assign({}, $, {
      style: Object.assign({}, q, u)
    }) : Object.assign({}, $, {
      className: $.className ? "".concat(Se, " ").concat($.className) : Se,
      style: Object.assign({}, u)
    });
    if (M ? d.style = rt(rt({}, d.style), {}, {
      whiteSpace: "pre-wrap"
    }) : d.style = rt(rt({}, d.style), {}, {
      whiteSpace: "pre"
    }), !D)
      return /* @__PURE__ */ Tt.createElement(Y, he, B, /* @__PURE__ */ Tt.createElement(H, d, W));
    (C === void 0 && F || M) && (C = !0), F = F || rp;
    var fe = [{
      type: "text",
      value: W
    }], xe = np({
      astGenerator: D,
      language: a,
      code: W,
      defaultCodeValue: fe
    });
    xe.language === null && (xe.value = fe);
    var Me = xe.value.length + R, Le = tp(xe, C, P, p, v, R, Me, b, M);
    return /* @__PURE__ */ Tt.createElement(Y, he, /* @__PURE__ */ Tt.createElement(H, d, !v && B, F({
      rows: Le,
      stylesheet: l,
      useInlineStyles: g
    })));
  }, "SyntaxHighlighter");
}
var Zd, Yd, Bl = S(() => {
  fl();
  bl();
  Ho();
  zo();
  Il();
  Zd = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "star\
tingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "\
code", "astGenerator"];
  o(Hl, "ownKeys");
  o(rt, "_objectSpread");
  Yd = /\n/g;
  o(Kd, "getNewLines");
  o(Jd, "getAllLineNumbers");
  o(Qd, "AllLineNumbers");
  o(ep, "getEmWidthOfNumber");
  o(Tl, "getInlineLineNumber");
  o(zl, "assembleLineNumberStyles");
  o(wn, "createLineElement");
  o(Pl, "flattenCodeTree");
  o(tp, "processLines");
  o(rp, "defaultRenderer");
  o(kl, "isHighlightJs");
  o(np, "getCodeTree");
  o(Po, "default");
});

// ../node_modules/xtend/immutable.js
var Nl = z((sw, Ol) => {
  Ol.exports = ap;
  var op = Object.prototype.hasOwnProperty;
  function ap() {
    for (var e = {}, t = 0; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        op.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }
  o(ap, "extend");
});

// ../node_modules/hastscript/node_modules/property-information/lib/util/schema.js
var Bo = z((fw, _l) => {
  "use strict";
  _l.exports = Dl;
  var ko = Dl.prototype;
  ko.space = null;
  ko.normal = {};
  ko.property = {};
  function Dl(e, t, r) {
    this.property = e, this.normal = t, r && (this.space = r);
  }
  o(Dl, "Schema");
});

// ../node_modules/hastscript/node_modules/property-information/lib/util/merge.js
var Wl = z((pw, Vl) => {
  "use strict";
  var Fl = Nl(), ip = Bo();
  Vl.exports = lp;
  function lp(e) {
    for (var t = e.length, r = [], n = [], a = -1, i, c; ++a < t; )
      i = e[a], r.push(i.property), n.push(i.normal), c = i.space;
    return new ip(
      Fl.apply(null, r),
      Fl.apply(null, n),
      c
    );
  }
  o(lp, "merge");
});

// ../node_modules/hastscript/node_modules/property-information/normalize.js
var Rn = z((hw, $l) => {
  "use strict";
  $l.exports = cp;
  function cp(e) {
    return e.toLowerCase();
  }
  o(cp, "normalize");
});

// ../node_modules/hastscript/node_modules/property-information/lib/util/info.js
var Oo = z((gw, Ul) => {
  "use strict";
  Ul.exports = jl;
  var _e = jl.prototype;
  _e.space = null;
  _e.attribute = null;
  _e.property = null;
  _e.boolean = !1;
  _e.booleanish = !1;
  _e.overloadedBoolean = !1;
  _e.number = !1;
  _e.commaSeparated = !1;
  _e.spaceSeparated = !1;
  _e.commaOrSpaceSeparated = !1;
  _e.mustUseProperty = !1;
  _e.defined = !1;
  function jl(e, t) {
    this.property = e, this.attribute = t;
  }
  o(jl, "Info");
});

// ../node_modules/hastscript/node_modules/property-information/lib/util/types.js
var xn = z((ht) => {
  "use strict";
  var sp = 0;
  ht.boolean = zt();
  ht.booleanish = zt();
  ht.overloadedBoolean = zt();
  ht.number = zt();
  ht.spaceSeparated = zt();
  ht.commaSeparated = zt();
  ht.commaOrSpaceSeparated = zt();
  function zt() {
    return Math.pow(2, ++sp);
  }
  o(zt, "increment");
});

// ../node_modules/hastscript/node_modules/property-information/lib/util/defined-info.js
var Do = z((bw, Yl) => {
  "use strict";
  var Xl = Oo(), ql = xn();
  Yl.exports = No;
  No.prototype = new Xl();
  No.prototype.defined = !0;
  var Zl = [
    "boolean",
    "booleanish",
    "overloadedBoolean",
    "number",
    "commaSeparated",
    "spaceSeparated",
    "commaOrSpaceSeparated"
  ], up = Zl.length;
  function No(e, t, r, n) {
    var a = -1, i;
    for (Gl(this, "space", n), Xl.call(this, e, t); ++a < up; )
      i = Zl[a], Gl(this, i, (r & ql[i]) === ql[i]);
  }
  o(No, "DefinedInfo");
  function Gl(e, t, r) {
    r && (e[t] = r);
  }
  o(Gl, "mark");
});

// ../node_modules/hastscript/node_modules/property-information/lib/util/create.js
var er = z((Ew, Jl) => {
  "use strict";
  var Kl = Rn(), fp = Bo(), dp = Do();
  Jl.exports = pp;
  function pp(e) {
    var t = e.space, r = e.mustUseProperty || [], n = e.attributes || {}, a = e.properties, i = e.transform, c = {}, l = {}, s, u;
    for (s in a)
      u = new dp(
        s,
        i(n, s),
        a[s],
        t
      ), r.indexOf(s) !== -1 && (u.mustUseProperty = !0), c[s] = u, l[Kl(s)] = s, l[Kl(u.attribute)] = s;
    return new fp(c, l, t);
  }
  o(pp, "create");
});

// ../node_modules/hastscript/node_modules/property-information/lib/xlink.js
var ec = z((Sw, Ql) => {
  "use strict";
  var mp = er();
  Ql.exports = mp({
    space: "xlink",
    transform: hp,
    properties: {
      xLinkActuate: null,
      xLinkArcRole: null,
      xLinkHref: null,
      xLinkRole: null,
      xLinkShow: null,
      xLinkTitle: null,
      xLinkType: null
    }
  });
  function hp(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  }
  o(hp, "xlinkTransform");
});

// ../node_modules/hastscript/node_modules/property-information/lib/xml.js
var rc = z((Lw, tc) => {
  "use strict";
  var vp = er();
  tc.exports = vp({
    space: "xml",
    transform: gp,
    properties: {
      xmlLang: null,
      xmlBase: null,
      xmlSpace: null
    }
  });
  function gp(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  }
  o(gp, "xmlTransform");
});

// ../node_modules/hastscript/node_modules/property-information/lib/util/case-sensitive-transform.js
var oc = z((Iw, nc) => {
  "use strict";
  nc.exports = wp;
  function wp(e, t) {
    return t in e ? e[t] : t;
  }
  o(wp, "caseSensitiveTransform");
});

// ../node_modules/hastscript/node_modules/property-information/lib/util/case-insensitive-transform.js
var _o = z((Tw, ac) => {
  "use strict";
  var Rp = oc();
  ac.exports = xp;
  function xp(e, t) {
    return Rp(e, t.toLowerCase());
  }
  o(xp, "caseInsensitiveTransform");
});

// ../node_modules/hastscript/node_modules/property-information/lib/xmlns.js
var lc = z((Pw, ic) => {
  "use strict";
  var bp = er(), yp = _o();
  ic.exports = bp({
    space: "xmlns",
    attributes: {
      xmlnsxlink: "xmlns:xlink"
    },
    transform: yp,
    properties: {
      xmlns: null,
      xmlnsXLink: null
    }
  });
});

// ../node_modules/hastscript/node_modules/property-information/lib/aria.js
var sc = z((kw, cc) => {
  "use strict";
  var Fo = xn(), Ep = er(), He = Fo.booleanish, Fe = Fo.number, Pt = Fo.spaceSeparated;
  cc.exports = Ep({
    transform: Cp,
    properties: {
      ariaActiveDescendant: null,
      ariaAtomic: He,
      ariaAutoComplete: null,
      ariaBusy: He,
      ariaChecked: He,
      ariaColCount: Fe,
      ariaColIndex: Fe,
      ariaColSpan: Fe,
      ariaControls: Pt,
      ariaCurrent: null,
      ariaDescribedBy: Pt,
      ariaDetails: null,
      ariaDisabled: He,
      ariaDropEffect: Pt,
      ariaErrorMessage: null,
      ariaExpanded: He,
      ariaFlowTo: Pt,
      ariaGrabbed: He,
      ariaHasPopup: null,
      ariaHidden: He,
      ariaInvalid: null,
      ariaKeyShortcuts: null,
      ariaLabel: null,
      ariaLabelledBy: Pt,
      ariaLevel: Fe,
      ariaLive: null,
      ariaModal: He,
      ariaMultiLine: He,
      ariaMultiSelectable: He,
      ariaOrientation: null,
      ariaOwns: Pt,
      ariaPlaceholder: null,
      ariaPosInSet: Fe,
      ariaPressed: He,
      ariaReadOnly: He,
      ariaRelevant: null,
      ariaRequired: He,
      ariaRoleDescription: Pt,
      ariaRowCount: Fe,
      ariaRowIndex: Fe,
      ariaRowSpan: Fe,
      ariaSelected: He,
      ariaSetSize: Fe,
      ariaSort: null,
      ariaValueMax: Fe,
      ariaValueMin: Fe,
      ariaValueNow: Fe,
      ariaValueText: null,
      role: null
    }
  });
  function Cp(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  }
  o(Cp, "ariaTransform");
});

// ../node_modules/hastscript/node_modules/property-information/lib/html.js
var fc = z((Ow, uc) => {
  "use strict";
  var tr = xn(), Sp = er(), Mp = _o(), O = tr.boolean, Lp = tr.overloadedBoolean, Fr = tr.booleanish, G = tr.number, ye = tr.spaceSeparated,
  bn = tr.commaSeparated;
  uc.exports = Sp({
    space: "html",
    attributes: {
      acceptcharset: "accept-charset",
      classname: "class",
      htmlfor: "for",
      httpequiv: "http-equiv"
    },
    transform: Mp,
    mustUseProperty: ["checked", "multiple", "muted", "selected"],
    properties: {
      // Standard Properties.
      abbr: null,
      accept: bn,
      acceptCharset: ye,
      accessKey: ye,
      action: null,
      allow: null,
      allowFullScreen: O,
      allowPaymentRequest: O,
      allowUserMedia: O,
      alt: null,
      as: null,
      async: O,
      autoCapitalize: null,
      autoComplete: ye,
      autoFocus: O,
      autoPlay: O,
      capture: O,
      charSet: null,
      checked: O,
      cite: null,
      className: ye,
      cols: G,
      colSpan: null,
      content: null,
      contentEditable: Fr,
      controls: O,
      controlsList: ye,
      coords: G | bn,
      crossOrigin: null,
      data: null,
      dateTime: null,
      decoding: null,
      default: O,
      defer: O,
      dir: null,
      dirName: null,
      disabled: O,
      download: Lp,
      draggable: Fr,
      encType: null,
      enterKeyHint: null,
      form: null,
      formAction: null,
      formEncType: null,
      formMethod: null,
      formNoValidate: O,
      formTarget: null,
      headers: ye,
      height: G,
      hidden: O,
      high: G,
      href: null,
      hrefLang: null,
      htmlFor: ye,
      httpEquiv: ye,
      id: null,
      imageSizes: null,
      imageSrcSet: bn,
      inputMode: null,
      integrity: null,
      is: null,
      isMap: O,
      itemId: null,
      itemProp: ye,
      itemRef: ye,
      itemScope: O,
      itemType: ye,
      kind: null,
      label: null,
      lang: null,
      language: null,
      list: null,
      loading: null,
      loop: O,
      low: G,
      manifest: null,
      max: null,
      maxLength: G,
      media: null,
      method: null,
      min: null,
      minLength: G,
      multiple: O,
      muted: O,
      name: null,
      nonce: null,
      noModule: O,
      noValidate: O,
      onAbort: null,
      onAfterPrint: null,
      onAuxClick: null,
      onBeforePrint: null,
      onBeforeUnload: null,
      onBlur: null,
      onCancel: null,
      onCanPlay: null,
      onCanPlayThrough: null,
      onChange: null,
      onClick: null,
      onClose: null,
      onContextMenu: null,
      onCopy: null,
      onCueChange: null,
      onCut: null,
      onDblClick: null,
      onDrag: null,
      onDragEnd: null,
      onDragEnter: null,
      onDragExit: null,
      onDragLeave: null,
      onDragOver: null,
      onDragStart: null,
      onDrop: null,
      onDurationChange: null,
      onEmptied: null,
      onEnded: null,
      onError: null,
      onFocus: null,
      onFormData: null,
      onHashChange: null,
      onInput: null,
      onInvalid: null,
      onKeyDown: null,
      onKeyPress: null,
      onKeyUp: null,
      onLanguageChange: null,
      onLoad: null,
      onLoadedData: null,
      onLoadedMetadata: null,
      onLoadEnd: null,
      onLoadStart: null,
      onMessage: null,
      onMessageError: null,
      onMouseDown: null,
      onMouseEnter: null,
      onMouseLeave: null,
      onMouseMove: null,
      onMouseOut: null,
      onMouseOver: null,
      onMouseUp: null,
      onOffline: null,
      onOnline: null,
      onPageHide: null,
      onPageShow: null,
      onPaste: null,
      onPause: null,
      onPlay: null,
      onPlaying: null,
      onPopState: null,
      onProgress: null,
      onRateChange: null,
      onRejectionHandled: null,
      onReset: null,
      onResize: null,
      onScroll: null,
      onSecurityPolicyViolation: null,
      onSeeked: null,
      onSeeking: null,
      onSelect: null,
      onSlotChange: null,
      onStalled: null,
      onStorage: null,
      onSubmit: null,
      onSuspend: null,
      onTimeUpdate: null,
      onToggle: null,
      onUnhandledRejection: null,
      onUnload: null,
      onVolumeChange: null,
      onWaiting: null,
      onWheel: null,
      open: O,
      optimum: G,
      pattern: null,
      ping: ye,
      placeholder: null,
      playsInline: O,
      poster: null,
      preload: null,
      readOnly: O,
      referrerPolicy: null,
      rel: ye,
      required: O,
      reversed: O,
      rows: G,
      rowSpan: G,
      sandbox: ye,
      scope: null,
      scoped: O,
      seamless: O,
      selected: O,
      shape: null,
      size: G,
      sizes: null,
      slot: null,
      span: G,
      spellCheck: Fr,
      src: null,
      srcDoc: null,
      srcLang: null,
      srcSet: bn,
      start: G,
      step: null,
      style: null,
      tabIndex: G,
      target: null,
      title: null,
      translate: null,
      type: null,
      typeMustMatch: O,
      useMap: null,
      value: Fr,
      width: G,
      wrap: null,
      // Legacy.
      // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
      align: null,
      // Several. Use CSS `text-align` instead,
      aLink: null,
      // `<body>`. Use CSS `a:active {color}` instead
      archive: ye,
      // `<object>`. List of URIs to archives
      axis: null,
      // `<td>` and `<th>`. Use `scope` on `<th>`
      background: null,
      // `<body>`. Use CSS `background-image` instead
      bgColor: null,
      // `<body>` and table elements. Use CSS `background-color` instead
      border: G,
      // `<table>`. Use CSS `border-width` instead,
      borderColor: null,
      // `<table>`. Use CSS `border-color` instead,
      bottomMargin: G,
      // `<body>`
      cellPadding: null,
      // `<table>`
      cellSpacing: null,
      // `<table>`
      char: null,
      // Several table elements. When `align=char`, sets the character to align on
      charOff: null,
      // Several table elements. When `char`, offsets the alignment
      classId: null,
      // `<object>`
      clear: null,
      // `<br>`. Use CSS `clear` instead
      code: null,
      // `<object>`
      codeBase: null,
      // `<object>`
      codeType: null,
      // `<object>`
      color: null,
      // `<font>` and `<hr>`. Use CSS instead
      compact: O,
      // Lists. Use CSS to reduce space between items instead
      declare: O,
      // `<object>`
      event: null,
      // `<script>`
      face: null,
      // `<font>`. Use CSS instead
      frame: null,
      // `<table>`
      frameBorder: null,
      // `<iframe>`. Use CSS `border` instead
      hSpace: G,
      // `<img>` and `<object>`
      leftMargin: G,
      // `<body>`
      link: null,
      // `<body>`. Use CSS `a:link {color: *}` instead
      longDesc: null,
      // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
      lowSrc: null,
      // `<img>`. Use a `<picture>`
      marginHeight: G,
      // `<body>`
      marginWidth: G,
      // `<body>`
      noResize: O,
      // `<frame>`
      noHref: O,
      // `<area>`. Use no href instead of an explicit `nohref`
      noShade: O,
      // `<hr>`. Use background-color and height instead of borders
      noWrap: O,
      // `<td>` and `<th>`
      object: null,
      // `<applet>`
      profile: null,
      // `<head>`
      prompt: null,
      // `<isindex>`
      rev: null,
      // `<link>`
      rightMargin: G,
      // `<body>`
      rules: null,
      // `<table>`
      scheme: null,
      // `<meta>`
      scrolling: Fr,
      // `<frame>`. Use overflow in the child context
      standby: null,
      // `<object>`
      summary: null,
      // `<table>`
      text: null,
      // `<body>`. Use CSS `color` instead
      topMargin: G,
      // `<body>`
      valueType: null,
      // `<param>`
      version: null,
      // `<html>`. Use a doctype.
      vAlign: null,
      // Several. Use CSS `vertical-align` instead
      vLink: null,
      // `<body>`. Use CSS `a:visited {color}` instead
      vSpace: G,
      // `<img>` and `<object>`
      // Non-standard Properties.
      allowTransparency: null,
      autoCorrect: null,
      autoSave: null,
      disablePictureInPicture: O,
      disableRemotePlayback: O,
      prefix: null,
      property: null,
      results: G,
      security: null,
      unselectable: null
    }
  });
});

// ../node_modules/hastscript/node_modules/property-information/html.js
var pc = z((Nw, dc) => {
  "use strict";
  var Ap = Wl(), Ip = ec(), Hp = rc(), Tp = lc(), zp = sc(), Pp = fc();
  dc.exports = Ap([Hp, Ip, Tp, zp, Pp]);
});

// ../node_modules/hastscript/node_modules/property-information/find.js
var vc = z((Dw, hc) => {
  "use strict";
  var kp = Rn(), Bp = Do(), Op = Oo(), Vo = "data";
  hc.exports = _p;
  var Np = /^data[-\w.:]+$/i, mc = /-[a-z]/g, Dp = /[A-Z]/g;
  function _p(e, t) {
    var r = kp(t), n = t, a = Op;
    return r in e.normal ? e.property[e.normal[r]] : (r.length > 4 && r.slice(0, 4) === Vo && Np.test(t) && (t.charAt(4) === "-" ? n = Fp(t) :
    t = Vp(t), a = Bp), new a(n, t));
  }
  o(_p, "find");
  function Fp(e) {
    var t = e.slice(5).replace(mc, $p);
    return Vo + t.charAt(0).toUpperCase() + t.slice(1);
  }
  o(Fp, "datasetToProperty");
  function Vp(e) {
    var t = e.slice(4);
    return mc.test(t) ? e : (t = t.replace(Dp, Wp), t.charAt(0) !== "-" && (t = "-" + t), Vo + t);
  }
  o(Vp, "datasetToAttribute");
  function Wp(e) {
    return "-" + e.toLowerCase();
  }
  o(Wp, "kebab");
  function $p(e) {
    return e.charAt(1).toUpperCase();
  }
  o($p, "camelcase");
});

// ../node_modules/hast-util-parse-selector/index.js
var Rc = z((Fw, wc) => {
  "use strict";
  wc.exports = jp;
  var gc = /[#.]/g;
  function jp(e, t) {
    for (var r = e || "", n = t || "div", a = {}, i = 0, c, l, s; i < r.length; )
      gc.lastIndex = i, s = gc.exec(r), c = r.slice(i, s ? s.index : r.length), c && (l ? l === "#" ? a.id = c : a.className ? a.className.push(
      c) : a.className = [c] : n = c, i += c.length), s && (l = s[0], i++);
    return { type: "element", tagName: n, properties: a, children: [] };
  }
  o(jp, "parse");
});

// ../node_modules/hastscript/node_modules/space-separated-tokens/index.js
var bc = z((Wo) => {
  "use strict";
  Wo.parse = Gp;
  Wo.stringify = Xp;
  var xc = "", Up = " ", qp = /[ \t\n\r\f]+/g;
  function Gp(e) {
    var t = String(e || xc).trim();
    return t === xc ? [] : t.split(qp);
  }
  o(Gp, "parse");
  function Xp(e) {
    return e.join(Up).trim();
  }
  o(Xp, "stringify");
});

// ../node_modules/hastscript/node_modules/comma-separated-tokens/index.js
var Ec = z((jo) => {
  "use strict";
  jo.parse = Zp;
  jo.stringify = Yp;
  var $o = ",", yc = " ", Vr = "";
  function Zp(e) {
    for (var t = [], r = String(e || Vr), n = r.indexOf($o), a = 0, i = !1, c; !i; )
      n === -1 && (n = r.length, i = !0), c = r.slice(a, n).trim(), (c || !i) && t.push(c), a = n + 1, n = r.indexOf($o, a);
    return t;
  }
  o(Zp, "parse");
  function Yp(e, t) {
    var r = t || {}, n = r.padLeft === !1 ? Vr : yc, a = r.padRight ? yc : Vr;
    return e[e.length - 1] === Vr && (e = e.concat(Vr)), e.join(a + $o + n).trim();
  }
  o(Yp, "stringify");
});

// ../node_modules/hastscript/factory.js
var Hc = z((qw, Ic) => {
  "use strict";
  var Kp = vc(), Cc = Rn(), Jp = Rc(), Sc = bc().parse, Mc = Ec().parse;
  Ic.exports = e2;
  var Qp = {}.hasOwnProperty;
  function e2(e, t, r) {
    var n = r ? a2(r) : null;
    return a;
    function a(c, l) {
      var s = Jp(c, t), u = Array.prototype.slice.call(arguments, 2), f = s.tagName.toLowerCase(), d;
      if (s.tagName = n && Qp.call(n, f) ? n[f] : f, l && t2(l, s) && (u.unshift(l), l = null), l)
        for (d in l)
          i(s.properties, d, l[d]);
      return Ac(s.children, u), s.tagName === "template" && (s.content = { type: "root", children: s.children }, s.children = []), s;
    }
    function i(c, l, s) {
      var u, f, d;
      s == null || s !== s || (u = Kp(e, l), f = u.property, d = s, typeof d == "string" && (u.spaceSeparated ? d = Sc(d) : u.commaSeparated ?
      d = Mc(d) : u.commaOrSpaceSeparated && (d = Sc(Mc(d).join(" ")))), f === "style" && typeof s != "string" && (d = o2(d)), f === "classN\
ame" && c.className && (d = c.className.concat(d)), c[f] = n2(u, f, d));
    }
  }
  o(e2, "factory");
  function t2(e, t) {
    return typeof e == "string" || "length" in e || r2(t.tagName, e);
  }
  o(t2, "isChildren");
  function r2(e, t) {
    var r = t.type;
    return e === "input" || !r || typeof r != "string" ? !1 : typeof t.children == "object" && "length" in t.children ? !0 : (r = r.toLowerCase(),
    e === "button" ? r !== "menu" && r !== "submit" && r !== "reset" && r !== "button" : "value" in t);
  }
  o(r2, "isNode");
  function Ac(e, t) {
    var r, n;
    if (typeof t == "string" || typeof t == "number") {
      e.push({ type: "text", value: String(t) });
      return;
    }
    if (typeof t == "object" && "length" in t) {
      for (r = -1, n = t.length; ++r < n; )
        Ac(e, t[r]);
      return;
    }
    if (typeof t != "object" || !("type" in t))
      throw new Error("Expected node, nodes, or string, got `" + t + "`");
    e.push(t);
  }
  o(Ac, "addChild");
  function n2(e, t, r) {
    var n, a, i;
    if (typeof r != "object" || !("length" in r))
      return Lc(e, t, r);
    for (a = r.length, n = -1, i = []; ++n < a; )
      i[n] = Lc(e, t, r[n]);
    return i;
  }
  o(n2, "parsePrimitives");
  function Lc(e, t, r) {
    var n = r;
    return e.number || e.positiveNumber ? !isNaN(n) && n !== "" && (n = Number(n)) : (e.boolean || e.overloadedBoolean) && typeof n == "stri\
ng" && (n === "" || Cc(r) === Cc(t)) && (n = !0), n;
  }
  o(Lc, "parsePrimitive");
  function o2(e) {
    var t = [], r;
    for (r in e)
      t.push([r, e[r]].join(": "));
    return t.join("; ");
  }
  o(o2, "style");
  function a2(e) {
    for (var t = e.length, r = -1, n = {}, a; ++r < t; )
      a = e[r], n[a.toLowerCase()] = a;
    return n;
  }
  o(a2, "createAdjustMap");
});

// ../node_modules/hastscript/html.js
var Pc = z((Xw, zc) => {
  "use strict";
  var i2 = pc(), l2 = Hc(), Tc = l2(i2, "div");
  Tc.displayName = "html";
  zc.exports = Tc;
});

// ../node_modules/hastscript/index.js
var Bc = z((Zw, kc) => {
  "use strict";
  kc.exports = Pc();
});

// ../node_modules/refractor/node_modules/character-entities-legacy/index.json
var Oc = z((Yw, c2) => {
  c2.exports = {
    AElig: "\xC6",
    AMP: "&",
    Aacute: "\xC1",
    Acirc: "\xC2",
    Agrave: "\xC0",
    Aring: "\xC5",
    Atilde: "\xC3",
    Auml: "\xC4",
    COPY: "\xA9",
    Ccedil: "\xC7",
    ETH: "\xD0",
    Eacute: "\xC9",
    Ecirc: "\xCA",
    Egrave: "\xC8",
    Euml: "\xCB",
    GT: ">",
    Iacute: "\xCD",
    Icirc: "\xCE",
    Igrave: "\xCC",
    Iuml: "\xCF",
    LT: "<",
    Ntilde: "\xD1",
    Oacute: "\xD3",
    Ocirc: "\xD4",
    Ograve: "\xD2",
    Oslash: "\xD8",
    Otilde: "\xD5",
    Ouml: "\xD6",
    QUOT: '"',
    REG: "\xAE",
    THORN: "\xDE",
    Uacute: "\xDA",
    Ucirc: "\xDB",
    Ugrave: "\xD9",
    Uuml: "\xDC",
    Yacute: "\xDD",
    aacute: "\xE1",
    acirc: "\xE2",
    acute: "\xB4",
    aelig: "\xE6",
    agrave: "\xE0",
    amp: "&",
    aring: "\xE5",
    atilde: "\xE3",
    auml: "\xE4",
    brvbar: "\xA6",
    ccedil: "\xE7",
    cedil: "\xB8",
    cent: "\xA2",
    copy: "\xA9",
    curren: "\xA4",
    deg: "\xB0",
    divide: "\xF7",
    eacute: "\xE9",
    ecirc: "\xEA",
    egrave: "\xE8",
    eth: "\xF0",
    euml: "\xEB",
    frac12: "\xBD",
    frac14: "\xBC",
    frac34: "\xBE",
    gt: ">",
    iacute: "\xED",
    icirc: "\xEE",
    iexcl: "\xA1",
    igrave: "\xEC",
    iquest: "\xBF",
    iuml: "\xEF",
    laquo: "\xAB",
    lt: "<",
    macr: "\xAF",
    micro: "\xB5",
    middot: "\xB7",
    nbsp: "\xA0",
    not: "\xAC",
    ntilde: "\xF1",
    oacute: "\xF3",
    ocirc: "\xF4",
    ograve: "\xF2",
    ordf: "\xAA",
    ordm: "\xBA",
    oslash: "\xF8",
    otilde: "\xF5",
    ouml: "\xF6",
    para: "\xB6",
    plusmn: "\xB1",
    pound: "\xA3",
    quot: '"',
    raquo: "\xBB",
    reg: "\xAE",
    sect: "\xA7",
    shy: "\xAD",
    sup1: "\xB9",
    sup2: "\xB2",
    sup3: "\xB3",
    szlig: "\xDF",
    thorn: "\xFE",
    times: "\xD7",
    uacute: "\xFA",
    ucirc: "\xFB",
    ugrave: "\xF9",
    uml: "\xA8",
    uuml: "\xFC",
    yacute: "\xFD",
    yen: "\xA5",
    yuml: "\xFF"
  };
});

// ../node_modules/refractor/node_modules/character-reference-invalid/index.json
var Nc = z((Kw, s2) => {
  s2.exports = {
    "0": "\uFFFD",
    "128": "\u20AC",
    "130": "\u201A",
    "131": "\u0192",
    "132": "\u201E",
    "133": "\u2026",
    "134": "\u2020",
    "135": "\u2021",
    "136": "\u02C6",
    "137": "\u2030",
    "138": "\u0160",
    "139": "\u2039",
    "140": "\u0152",
    "142": "\u017D",
    "145": "\u2018",
    "146": "\u2019",
    "147": "\u201C",
    "148": "\u201D",
    "149": "\u2022",
    "150": "\u2013",
    "151": "\u2014",
    "152": "\u02DC",
    "153": "\u2122",
    "154": "\u0161",
    "155": "\u203A",
    "156": "\u0153",
    "158": "\u017E",
    "159": "\u0178"
  };
});

// ../node_modules/refractor/node_modules/is-decimal/index.js
var Uo = z((Jw, Dc) => {
  "use strict";
  Dc.exports = u2;
  function u2(e) {
    var t = typeof e == "string" ? e.charCodeAt(0) : e;
    return t >= 48 && t <= 57;
  }
  o(u2, "decimal");
});

// ../node_modules/refractor/node_modules/is-hexadecimal/index.js
var Fc = z((e8, _c) => {
  "use strict";
  _c.exports = f2;
  function f2(e) {
    var t = typeof e == "string" ? e.charCodeAt(0) : e;
    return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
  }
  o(f2, "hexadecimal");
});

// ../node_modules/refractor/node_modules/is-alphabetical/index.js
var Wc = z((r8, Vc) => {
  "use strict";
  Vc.exports = d2;
  function d2(e) {
    var t = typeof e == "string" ? e.charCodeAt(0) : e;
    return t >= 97 && t <= 122 || t >= 65 && t <= 90;
  }
  o(d2, "alphabetical");
});

// ../node_modules/refractor/node_modules/is-alphanumerical/index.js
var jc = z((o8, $c) => {
  "use strict";
  var p2 = Wc(), m2 = Uo();
  $c.exports = h2;
  function h2(e) {
    return p2(e) || m2(e);
  }
  o(h2, "alphanumerical");
});

// ../node_modules/refractor/node_modules/parse-entities/decode-entity.browser.js
var qc = z((i8, Uc) => {
  "use strict";
  var yn, v2 = 59;
  Uc.exports = g2;
  function g2(e) {
    var t = "&" + e + ";", r;
    return yn = yn || document.createElement("i"), yn.innerHTML = t, r = yn.textContent, r.charCodeAt(r.length - 1) === v2 && e !== "semi" ||
    r === t ? !1 : r;
  }
  o(g2, "decodeEntity");
});

// ../node_modules/refractor/node_modules/parse-entities/index.js
var i1 = z((c8, a1) => {
  "use strict";
  var Gc = Oc(), Xc = Nc(), w2 = Uo(), R2 = Fc(), Jc = jc(), x2 = qc();
  a1.exports = P2;
  var b2 = {}.hasOwnProperty, rr = String.fromCharCode, y2 = Function.prototype, Zc = {
    warning: null,
    reference: null,
    text: null,
    warningContext: null,
    referenceContext: null,
    textContext: null,
    position: {},
    additional: null,
    attribute: !1,
    nonTerminated: !0
  }, E2 = 9, Yc = 10, C2 = 12, S2 = 32, Kc = 38, M2 = 59, L2 = 60, A2 = 61, I2 = 35, H2 = 88, T2 = 120, z2 = 65533, nr = "named", Go = "hexa\
decimal", Xo = "decimal", Zo = {};
  Zo[Go] = 16;
  Zo[Xo] = 10;
  var En = {};
  En[nr] = Jc;
  En[Xo] = w2;
  En[Go] = R2;
  var Qc = 1, e1 = 2, t1 = 3, r1 = 4, n1 = 5, qo = 6, o1 = 7, vt = {};
  vt[Qc] = "Named character references must be terminated by a semicolon";
  vt[e1] = "Numeric character references must be terminated by a semicolon";
  vt[t1] = "Named character references cannot be empty";
  vt[r1] = "Numeric character references cannot be empty";
  vt[n1] = "Named character references must be known";
  vt[qo] = "Numeric character references cannot be disallowed";
  vt[o1] = "Numeric character references cannot be outside the permissible Unicode range";
  function P2(e, t) {
    var r = {}, n, a;
    t || (t = {});
    for (a in Zc)
      n = t[a], r[a] = n ?? Zc[a];
    return (r.position.indent || r.position.start) && (r.indent = r.position.indent || [], r.position = r.position.start), k2(e, r);
  }
  o(P2, "parseEntities");
  function k2(e, t) {
    var r = t.additional, n = t.nonTerminated, a = t.text, i = t.reference, c = t.warning, l = t.textContext, s = t.referenceContext, u = t.
    warningContext, f = t.position, d = t.indent || [], m = e.length, g = 0, x = -1, p = f.column || 1, h = f.line || 1, v = "", w = [], R, y,
    E, b, C, L, M, A, P, F, _, Y, T, H, k, W, D, $, B;
    for (typeof r == "string" && (r = r.charCodeAt(0)), W = q(), A = c ? Se : y2, g--, m++; ++g < m; )
      if (C === Yc && (p = d[x] || 1), C = e.charCodeAt(g), C === Kc) {
        if (M = e.charCodeAt(g + 1), M === E2 || M === Yc || M === C2 || M === S2 || M === Kc || M === L2 || M !== M || r && M === r) {
          v += rr(C), p++;
          continue;
        }
        for (T = g + 1, Y = T, B = T, M === I2 ? (B = ++Y, M = e.charCodeAt(B), M === H2 || M === T2 ? (H = Go, B = ++Y) : H = Xo) : H = nr,
        R = "", _ = "", b = "", k = En[H], B--; ++B < m && (M = e.charCodeAt(B), !!k(M)); )
          b += rr(M), H === nr && b2.call(Gc, b) && (R = b, _ = Gc[b]);
        E = e.charCodeAt(B) === M2, E && (B++, y = H === nr ? x2(b) : !1, y && (R = b, _ = y)), $ = 1 + B - T, !E && !n || (b ? H === nr ? (E &&
        !_ ? A(n1, 1) : (R !== b && (B = Y + R.length, $ = 1 + B - Y, E = !1), E || (P = R ? Qc : t1, t.attribute ? (M = e.charCodeAt(B), M ===
        A2 ? (A(P, $), _ = null) : Jc(M) ? _ = null : A(P, $)) : A(P, $))), L = _) : (E || A(e1, $), L = parseInt(b, Zo[H]), B2(L) ? (A(o1, $),
        L = rr(z2)) : L in Xc ? (A(qo, $), L = Xc[L]) : (F = "", O2(L) && A(qo, $), L > 65535 && (L -= 65536, F += rr(L >>> 10 | 55296), L =
        56320 | L & 1023), L = F + rr(L))) : H !== nr && A(r1, $)), L ? (he(), W = q(), g = B - 1, p += B - T + 1, w.push(L), D = q(), D.offset++,
        i && i.call(
          s,
          L,
          { start: W, end: D },
          e.slice(T - 1, B)
        ), W = D) : (b = e.slice(T - 1, B), v += b, p += b.length, g = B - 1);
      } else
        C === 10 && (h++, x++, p = 0), C === C ? (v += rr(C), p++) : he();
    return w.join("");
    function q() {
      return {
        line: h,
        column: p,
        offset: g + (f.offset || 0)
      };
    }
    function Se(fe, xe) {
      var Me = q();
      Me.column += xe, Me.offset += xe, c.call(u, vt[fe], Me, fe);
    }
    function he() {
      v && (w.push(v), a && a.call(l, v, { start: W, end: q() }), v = "");
    }
  }
  o(k2, "parse");
  function B2(e) {
    return e >= 55296 && e <= 57343 || e > 1114111;
  }
  o(B2, "prohibited");
  function O2(e) {
    return e >= 1 && e <= 8 || e === 11 || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 ||
    (e & 65535) === 65534;
  }
  o(O2, "disallowed");
});

// ../node_modules/refractor/node_modules/prismjs/components/prism-core.js
var c1 = z((u8, Cn) => {
  var N2 = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
  var l1 = function(e) {
    var t = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, r = 0, n = {}, a = {
      /**
       * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
       * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
       * additional languages or plugins yourself.
       *
       * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
       *
       * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.manual = true;
       * // add a new <script> to load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      manual: e.Prism && e.Prism.manual,
      /**
       * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
       * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
       * own worker, you don't want it to do this.
       *
       * By setting this value to `true`, Prism will not add its own listeners to the worker.
       *
       * You obviously have to change this value before Prism executes. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.disableWorkerMessageHandler = true;
       * // Load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      disableWorkerMessageHandler: e.Prism && e.Prism.disableWorkerMessageHandler,
      /**
       * A namespace for utility methods.
       *
       * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
       * change or disappear at any time.
       *
       * @namespace
       * @memberof Prism
       */
      util: {
        encode: /* @__PURE__ */ o(function p(h) {
          return h instanceof i ? new i(h.type, p(h.content), h.alias) : Array.isArray(h) ? h.map(p) : h.replace(/&/g, "&amp;").replace(/</g,
          "&lt;").replace(/\u00a0/g, " ");
        }, "encode"),
        /**
         * Returns the name of the type of the given value.
         *
         * @param {any} o
         * @returns {string}
         * @example
         * type(null)      === 'Null'
         * type(undefined) === 'Undefined'
         * type(123)       === 'Number'
         * type('foo')     === 'String'
         * type(true)      === 'Boolean'
         * type([1, 2])    === 'Array'
         * type({})        === 'Object'
         * type(String)    === 'Function'
         * type(/abc+/)    === 'RegExp'
         */
        type: /* @__PURE__ */ o(function(p) {
          return Object.prototype.toString.call(p).slice(8, -1);
        }, "type"),
        /**
         * Returns a unique number for the given object. Later calls will still return the same number.
         *
         * @param {Object} obj
         * @returns {number}
         */
        objId: /* @__PURE__ */ o(function(p) {
          return p.__id || Object.defineProperty(p, "__id", { value: ++r }), p.__id;
        }, "objId"),
        /**
         * Creates a deep clone of the given object.
         *
         * The main intended use of this function is to clone language definitions.
         *
         * @param {T} o
         * @param {Record<number, any>} [visited]
         * @returns {T}
         * @template T
         */
        clone: /* @__PURE__ */ o(function p(h, v) {
          v = v || {};
          var w, R;
          switch (a.util.type(h)) {
            case "Object":
              if (R = a.util.objId(h), v[R])
                return v[R];
              w = /** @type {Record<string, any>} */
              {}, v[R] = w;
              for (var y in h)
                h.hasOwnProperty(y) && (w[y] = p(h[y], v));
              return (
                /** @type {any} */
                w
              );
            case "Array":
              return R = a.util.objId(h), v[R] ? v[R] : (w = [], v[R] = w, /** @type {Array} */
              /** @type {any} */
              h.forEach(function(E, b) {
                w[b] = p(E, v);
              }), /** @type {any} */
              w);
            default:
              return h;
          }
        }, "deepClone"),
        /**
         * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
         *
         * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
         *
         * @param {Element} element
         * @returns {string}
         */
        getLanguage: /* @__PURE__ */ o(function(p) {
          for (; p; ) {
            var h = t.exec(p.className);
            if (h)
              return h[1].toLowerCase();
            p = p.parentElement;
          }
          return "none";
        }, "getLanguage"),
        /**
         * Sets the Prism `language-xxxx` class of the given element.
         *
         * @param {Element} element
         * @param {string} language
         * @returns {void}
         */
        setLanguage: /* @__PURE__ */ o(function(p, h) {
          p.className = p.className.replace(RegExp(t, "gi"), ""), p.classList.add("language-" + h);
        }, "setLanguage"),
        /**
         * Returns the script element that is currently executing.
         *
         * This does __not__ work for line script element.
         *
         * @returns {HTMLScriptElement | null}
         */
        currentScript: /* @__PURE__ */ o(function() {
          if (typeof document > "u")
            return null;
          if ("currentScript" in document)
            return (
              /** @type {any} */
              document.currentScript
            );
          try {
            throw new Error();
          } catch (w) {
            var p = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(w.stack) || [])[1];
            if (p) {
              var h = document.getElementsByTagName("script");
              for (var v in h)
                if (h[v].src == p)
                  return h[v];
            }
            return null;
          }
        }, "currentScript"),
        /**
         * Returns whether a given class is active for `element`.
         *
         * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
         * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
         * given class is just the given class with a `no-` prefix.
         *
         * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
         * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
         * ancestors have the given class or the negated version of it, then the default activation will be returned.
         *
         * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
         * version of it, the class is considered active.
         *
         * @param {Element} element
         * @param {string} className
         * @param {boolean} [defaultActivation=false]
         * @returns {boolean}
         */
        isActive: /* @__PURE__ */ o(function(p, h, v) {
          for (var w = "no-" + h; p; ) {
            var R = p.classList;
            if (R.contains(h))
              return !0;
            if (R.contains(w))
              return !1;
            p = p.parentElement;
          }
          return !!v;
        }, "isActive")
      },
      /**
       * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
       *
       * @namespace
       * @memberof Prism
       * @public
       */
      languages: {
        /**
         * The grammar for plain, unformatted text.
         */
        plain: n,
        plaintext: n,
        text: n,
        txt: n,
        /**
         * Creates a deep copy of the language with the given id and appends the given tokens.
         *
         * If a token in `redef` also appears in the copied language, then the existing token in the copied language
         * will be overwritten at its original position.
         *
         * ## Best practices
         *
         * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
         * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
         * understand the language definition because, normally, the order of tokens matters in Prism grammars.
         *
         * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
         * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
         *
         * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
         * @param {Grammar} redef The new tokens to append.
         * @returns {Grammar} The new language created.
         * @public
         * @example
         * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
         *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
         *     // at its original position
         *     'comment': { ... },
         *     // CSS doesn't have a 'color' token, so this token will be appended
         *     'color': /\b(?:red|green|blue)\b/
         * });
         */
        extend: /* @__PURE__ */ o(function(p, h) {
          var v = a.util.clone(a.languages[p]);
          for (var w in h)
            v[w] = h[w];
          return v;
        }, "extend"),
        /**
         * Inserts tokens _before_ another token in a language definition or any other grammar.
         *
         * ## Usage
         *
         * This helper method makes it easy to modify existing languages. For example, the CSS language definition
         * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
         * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
         * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
         * this:
         *
         * ```js
         * Prism.languages.markup.style = {
         *     // token
         * };
         * ```
         *
         * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
         * before existing tokens. For the CSS example above, you would use it like this:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'cdata', {
         *     'style': {
         *         // token
         *     }
         * });
         * ```
         *
         * ## Special cases
         *
         * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
         * will be ignored.
         *
         * This behavior can be used to insert tokens after `before`:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'comment', {
         *     'comment': Prism.languages.markup.comment,
         *     // tokens after 'comment'
         * });
         * ```
         *
         * ## Limitations
         *
         * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
         * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
         * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
         * deleting properties which is necessary to insert at arbitrary positions.
         *
         * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
         * Instead, it will create a new object and replace all references to the target object with the new one. This
         * can be done without temporarily deleting properties, so the iteration order is well-defined.
         *
         * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
         * you hold the target object in a variable, then the value of the variable will not change.
         *
         * ```js
         * var oldMarkup = Prism.languages.markup;
         * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
         *
         * assert(oldMarkup !== Prism.languages.markup);
         * assert(newMarkup === Prism.languages.markup);
         * ```
         *
         * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
         * object to be modified.
         * @param {string} before The key to insert before.
         * @param {Grammar} insert An object containing the key-value pairs to be inserted.
         * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
         * object to be modified.
         *
         * Defaults to `Prism.languages`.
         * @returns {Grammar} The new grammar object.
         * @public
         */
        insertBefore: /* @__PURE__ */ o(function(p, h, v, w) {
          w = w || /** @type {any} */
          a.languages;
          var R = w[p], y = {};
          for (var E in R)
            if (R.hasOwnProperty(E)) {
              if (E == h)
                for (var b in v)
                  v.hasOwnProperty(b) && (y[b] = v[b]);
              v.hasOwnProperty(E) || (y[E] = R[E]);
            }
          var C = w[p];
          return w[p] = y, a.languages.DFS(a.languages, function(L, M) {
            M === C && L != p && (this[L] = y);
          }), y;
        }, "insertBefore"),
        // Traverse a language definition with Depth First Search
        DFS: /* @__PURE__ */ o(function p(h, v, w, R) {
          R = R || {};
          var y = a.util.objId;
          for (var E in h)
            if (h.hasOwnProperty(E)) {
              v.call(h, E, h[E], w || E);
              var b = h[E], C = a.util.type(b);
              C === "Object" && !R[y(b)] ? (R[y(b)] = !0, p(b, v, null, R)) : C === "Array" && !R[y(b)] && (R[y(b)] = !0, p(b, v, E, R));
            }
        }, "DFS")
      },
      plugins: {},
      /**
       * This is the most high-level function in Prism’s API.
       * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
       * each one of them.
       *
       * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
       *
       * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
       * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
       * @memberof Prism
       * @public
       */
      highlightAll: /* @__PURE__ */ o(function(p, h) {
        a.highlightAllUnder(document, p, h);
      }, "highlightAll"),
      /**
       * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
       * {@link Prism.highlightElement} on each one of them.
       *
       * The following hooks will be run:
       * 1. `before-highlightall`
       * 2. `before-all-elements-highlight`
       * 3. All hooks of {@link Prism.highlightElement} for each element.
       *
       * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
       * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
       * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
       * @memberof Prism
       * @public
       */
      highlightAllUnder: /* @__PURE__ */ o(function(p, h, v) {
        var w = {
          callback: v,
          container: p,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        a.hooks.run("before-highlightall", w), w.elements = Array.prototype.slice.apply(w.container.querySelectorAll(w.selector)), a.hooks.run(
        "before-all-elements-highlight", w);
        for (var R = 0, y; y = w.elements[R++]; )
          a.highlightElement(y, h === !0, w.callback);
      }, "highlightAllUnder"),
      /**
       * Highlights the code inside a single element.
       *
       * The following hooks will be run:
       * 1. `before-sanity-check`
       * 2. `before-highlight`
       * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
       * 4. `before-insert`
       * 5. `after-highlight`
       * 6. `complete`
       *
       * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
       * the element's language.
       *
       * @param {Element} element The element containing the code.
       * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
       * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
       * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
       * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
       *
       * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
       * asynchronous highlighting to work. You can build your own bundle on the
       * [Download page](https://prismjs.com/download.html).
       * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
       * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
       * @memberof Prism
       * @public
       */
      highlightElement: /* @__PURE__ */ o(function(p, h, v) {
        var w = a.util.getLanguage(p), R = a.languages[w];
        a.util.setLanguage(p, w);
        var y = p.parentElement;
        y && y.nodeName.toLowerCase() === "pre" && a.util.setLanguage(y, w);
        var E = p.textContent, b = {
          element: p,
          language: w,
          grammar: R,
          code: E
        };
        function C(M) {
          b.highlightedCode = M, a.hooks.run("before-insert", b), b.element.innerHTML = b.highlightedCode, a.hooks.run("after-highlight", b),
          a.hooks.run("complete", b), v && v.call(b.element);
        }
        if (o(C, "insertHighlightedCode"), a.hooks.run("before-sanity-check", b), y = b.element.parentElement, y && y.nodeName.toLowerCase() ===
        "pre" && !y.hasAttribute("tabindex") && y.setAttribute("tabindex", "0"), !b.code) {
          a.hooks.run("complete", b), v && v.call(b.element);
          return;
        }
        if (a.hooks.run("before-highlight", b), !b.grammar) {
          C(a.util.encode(b.code));
          return;
        }
        if (h && e.Worker) {
          var L = new Worker(a.filename);
          L.onmessage = function(M) {
            C(M.data);
          }, L.postMessage(JSON.stringify({
            language: b.language,
            code: b.code,
            immediateClose: !0
          }));
        } else
          C(a.highlight(b.code, b.grammar, b.language));
      }, "highlightElement"),
      /**
       * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
       * and the language definitions to use, and returns a string with the HTML produced.
       *
       * The following hooks will be run:
       * 1. `before-tokenize`
       * 2. `after-tokenize`
       * 3. `wrap`: On each {@link Token}.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @param {string} language The name of the language definition passed to `grammar`.
       * @returns {string} The highlighted HTML.
       * @memberof Prism
       * @public
       * @example
       * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
       */
      highlight: /* @__PURE__ */ o(function(p, h, v) {
        var w = {
          code: p,
          grammar: h,
          language: v
        };
        if (a.hooks.run("before-tokenize", w), !w.grammar)
          throw new Error('The language "' + w.language + '" has no grammar.');
        return w.tokens = a.tokenize(w.code, w.grammar), a.hooks.run("after-tokenize", w), i.stringify(a.util.encode(w.tokens), w.language);
      }, "highlight"),
      /**
       * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
       * and the language definitions to use, and returns an array with the tokenized code.
       *
       * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
       *
       * This method could be useful in other contexts as well, as a very crude parser.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @returns {TokenStream} An array of strings and tokens, a token stream.
       * @memberof Prism
       * @public
       * @example
       * let code = `var foo = 0;`;
       * let tokens = Prism.tokenize(code, Prism.languages.javascript);
       * tokens.forEach(token => {
       *     if (token instanceof Prism.Token && token.type === 'number') {
       *         console.log(`Found numeric literal: ${token.content}`);
       *     }
       * });
       */
      tokenize: /* @__PURE__ */ o(function(p, h) {
        var v = h.rest;
        if (v) {
          for (var w in v)
            h[w] = v[w];
          delete h.rest;
        }
        var R = new s();
        return u(R, R.head, p), l(p, R, h, R.head, 0), d(R);
      }, "tokenize"),
      /**
       * @namespace
       * @memberof Prism
       * @public
       */
      hooks: {
        all: {},
        /**
         * Adds the given callback to the list of callbacks for the given hook.
         *
         * The callback will be invoked when the hook it is registered for is run.
         * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
         *
         * One callback function can be registered to multiple hooks and the same hook multiple times.
         *
         * @param {string} name The name of the hook.
         * @param {HookCallback} callback The callback function which is given environment variables.
         * @public
         */
        add: /* @__PURE__ */ o(function(p, h) {
          var v = a.hooks.all;
          v[p] = v[p] || [], v[p].push(h);
        }, "add"),
        /**
         * Runs a hook invoking all registered callbacks with the given environment variables.
         *
         * Callbacks will be invoked synchronously and in the order in which they were registered.
         *
         * @param {string} name The name of the hook.
         * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
         * @public
         */
        run: /* @__PURE__ */ o(function(p, h) {
          var v = a.hooks.all[p];
          if (!(!v || !v.length))
            for (var w = 0, R; R = v[w++]; )
              R(h);
        }, "run")
      },
      Token: i
    };
    e.Prism = a;
    function i(p, h, v, w) {
      this.type = p, this.content = h, this.alias = v, this.length = (w || "").length | 0;
    }
    o(i, "Token"), i.stringify = /* @__PURE__ */ o(function p(h, v) {
      if (typeof h == "string")
        return h;
      if (Array.isArray(h)) {
        var w = "";
        return h.forEach(function(C) {
          w += p(C, v);
        }), w;
      }
      var R = {
        type: h.type,
        content: p(h.content, v),
        tag: "span",
        classes: ["token", h.type],
        attributes: {},
        language: v
      }, y = h.alias;
      y && (Array.isArray(y) ? Array.prototype.push.apply(R.classes, y) : R.classes.push(y)), a.hooks.run("wrap", R);
      var E = "";
      for (var b in R.attributes)
        E += " " + b + '="' + (R.attributes[b] || "").replace(/"/g, "&quot;") + '"';
      return "<" + R.tag + ' class="' + R.classes.join(" ") + '"' + E + ">" + R.content + "</" + R.tag + ">";
    }, "stringify");
    function c(p, h, v, w) {
      p.lastIndex = h;
      var R = p.exec(v);
      if (R && w && R[1]) {
        var y = R[1].length;
        R.index += y, R[0] = R[0].slice(y);
      }
      return R;
    }
    o(c, "matchPattern");
    function l(p, h, v, w, R, y) {
      for (var E in v)
        if (!(!v.hasOwnProperty(E) || !v[E])) {
          var b = v[E];
          b = Array.isArray(b) ? b : [b];
          for (var C = 0; C < b.length; ++C) {
            if (y && y.cause == E + "," + C)
              return;
            var L = b[C], M = L.inside, A = !!L.lookbehind, P = !!L.greedy, F = L.alias;
            if (P && !L.pattern.global) {
              var _ = L.pattern.toString().match(/[imsuy]*$/)[0];
              L.pattern = RegExp(L.pattern.source, _ + "g");
            }
            for (var Y = L.pattern || L, T = w.next, H = R; T !== h.tail && !(y && H >= y.reach); H += T.value.length, T = T.next) {
              var k = T.value;
              if (h.length > p.length)
                return;
              if (!(k instanceof i)) {
                var W = 1, D;
                if (P) {
                  if (D = c(Y, H, p, A), !D || D.index >= p.length)
                    break;
                  var Se = D.index, $ = D.index + D[0].length, B = H;
                  for (B += T.value.length; Se >= B; )
                    T = T.next, B += T.value.length;
                  if (B -= T.value.length, H = B, T.value instanceof i)
                    continue;
                  for (var q = T; q !== h.tail && (B < $ || typeof q.value == "string"); q = q.next)
                    W++, B += q.value.length;
                  W--, k = p.slice(H, B), D.index -= H;
                } else if (D = c(Y, 0, k, A), !D)
                  continue;
                var Se = D.index, he = D[0], fe = k.slice(0, Se), xe = k.slice(Se + he.length), Me = H + k.length;
                y && Me > y.reach && (y.reach = Me);
                var Le = T.prev;
                fe && (Le = u(h, Le, fe), H += fe.length), f(h, Le, W);
                var kr = new i(E, M ? a.tokenize(he, M) : he, F, he);
                if (T = u(h, Le, kr), xe && u(h, T, xe), W > 1) {
                  var Br = {
                    cause: E + "," + C,
                    reach: Me
                  };
                  l(p, h, v, T.prev, H, Br), y && Br.reach > y.reach && (y.reach = Br.reach);
                }
              }
            }
          }
        }
    }
    o(l, "matchGrammar");
    function s() {
      var p = { value: null, prev: null, next: null }, h = { value: null, prev: p, next: null };
      p.next = h, this.head = p, this.tail = h, this.length = 0;
    }
    o(s, "LinkedList");
    function u(p, h, v) {
      var w = h.next, R = { value: v, prev: h, next: w };
      return h.next = R, w.prev = R, p.length++, R;
    }
    o(u, "addAfter");
    function f(p, h, v) {
      for (var w = h.next, R = 0; R < v && w !== p.tail; R++)
        w = w.next;
      h.next = w, w.prev = h, p.length -= R;
    }
    o(f, "removeRange");
    function d(p) {
      for (var h = [], v = p.head.next; v !== p.tail; )
        h.push(v.value), v = v.next;
      return h;
    }
    if (o(d, "toArray"), !e.document)
      return e.addEventListener && (a.disableWorkerMessageHandler || e.addEventListener("message", function(p) {
        var h = JSON.parse(p.data), v = h.language, w = h.code, R = h.immediateClose;
        e.postMessage(a.highlight(w, a.languages[v], v)), R && e.close();
      }, !1)), a;
    var m = a.util.currentScript();
    m && (a.filename = m.src, m.hasAttribute("data-manual") && (a.manual = !0));
    function g() {
      a.manual || a.highlightAll();
    }
    if (o(g, "highlightAutomaticallyCallback"), !a.manual) {
      var x = document.readyState;
      x === "loading" || x === "interactive" && m && m.defer ? document.addEventListener("DOMContentLoaded", g) : window.requestAnimationFrame ?
      window.requestAnimationFrame(g) : window.setTimeout(g, 16);
    }
    return a;
  }(N2);
  typeof Cn < "u" && Cn.exports && (Cn.exports = l1);
  typeof global < "u" && (global.Prism = l1);
});

// ../node_modules/refractor/lang/markup.js
var Ko = z((d8, s1) => {
  "use strict";
  s1.exports = Yo;
  Yo.displayName = "markup";
  Yo.aliases = ["html", "mathml", "svg", "xml", "ssml", "atom", "rss"];
  function Yo(e) {
    e.languages.markup = {
      comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: !0
      },
      prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: !0
      },
      doctype: {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: !0,
        inside: {
          "internal-subset": {
            pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
            lookbehind: !0,
            greedy: !0,
            inside: null
            // see below
          },
          string: {
            pattern: /"[^"]*"|'[^']*'/,
            greedy: !0
          },
          punctuation: /^<!|>$|[[\]]/,
          "doctype-tag": /^DOCTYPE/i,
          name: /[^\s<>'"]+/
        }
      },
      cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: !0
      },
      tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: !0,
        inside: {
          tag: {
            pattern: /^<\/?[^\s>\/]+/,
            inside: {
              punctuation: /^<\/?/,
              namespace: /^[^\s>\/:]+:/
            }
          },
          "special-attr": [],
          "attr-value": {
            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
            inside: {
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          },
          punctuation: /\/?>/,
          "attr-name": {
            pattern: /[^\s>\/]+/,
            inside: {
              namespace: /^[^\s>\/:]+:/
            }
          }
        }
      },
      entity: [
        {
          pattern: /&[\da-z]{1,8};/i,
          alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
      ]
    }, e.languages.markup.tag.inside["attr-value"].inside.entity = e.languages.markup.entity, e.languages.markup.doctype.inside["internal-su\
bset"].inside = e.languages.markup, e.hooks.add("wrap", function(t) {
      t.type === "entity" && (t.attributes.title = t.content.value.replace(/&amp;/, "&"));
    }), Object.defineProperty(e.languages.markup.tag, "addInlined", {
      /**
       * Adds an inlined language to markup.
       *
       * An example of an inlined language is CSS with `<style>` tags.
       *
       * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addInlined('style', 'css');
       */
      value: /* @__PURE__ */ o(function(r, n) {
        var a = {};
        a["language-" + n] = {
          pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
          lookbehind: !0,
          inside: e.languages[n]
        }, a.cdata = /^<!\[CDATA\[|\]\]>$/i;
        var i = {
          "included-cdata": {
            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
            inside: a
          }
        };
        i["language-" + n] = {
          pattern: /[\s\S]+/,
          inside: e.languages[n]
        };
        var c = {};
        c[r] = {
          pattern: RegExp(
            /(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(
              /__/g,
              function() {
                return r;
              }
            ),
            "i"
          ),
          lookbehind: !0,
          greedy: !0,
          inside: i
        }, e.languages.insertBefore("markup", "cdata", c);
      }, "addInlined")
    }), Object.defineProperty(e.languages.markup.tag, "addAttribute", {
      /**
       * Adds an pattern to highlight languages embedded in HTML attributes.
       *
       * An example of an inlined language is CSS with `style` attributes.
       *
       * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
       * case insensitive.
       * @param {string} lang The language key.
       * @example
       * addAttribute('style', 'css');
       */
      value: /* @__PURE__ */ o(function(t, r) {
        e.languages.markup.tag.inside["special-attr"].push({
          pattern: RegExp(
            /(^|["'\s])/.source + "(?:" + t + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
            "i"
          ),
          lookbehind: !0,
          inside: {
            "attr-name": /^[^\s=]+/,
            "attr-value": {
              pattern: /=[\s\S]+/,
              inside: {
                value: {
                  pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                  lookbehind: !0,
                  alias: [r, "language-" + r],
                  inside: e.languages[r]
                },
                punctuation: [
                  {
                    pattern: /^=/,
                    alias: "attr-equals"
                  },
                  /"|'/
                ]
              }
            }
          }
        });
      }, "value")
    }), e.languages.html = e.languages.markup, e.languages.mathml = e.languages.markup, e.languages.svg = e.languages.markup, e.languages.xml =
    e.languages.extend("markup", {}), e.languages.ssml = e.languages.xml, e.languages.atom = e.languages.xml, e.languages.rss = e.languages.
    xml;
  }
  o(Yo, "markup");
});

// ../node_modules/refractor/lang/css.js
var Qo = z((m8, u1) => {
  "use strict";
  u1.exports = Jo;
  Jo.displayName = "css";
  Jo.aliases = [];
  function Jo(e) {
    (function(t) {
      var r = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
      t.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
          pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
          inside: {
            rule: /^@[\w-]+/,
            "selector-function-argument": {
              pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
              lookbehind: !0,
              alias: "selector"
            },
            keyword: {
              pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
              lookbehind: !0
            }
            // See rest below
          }
        },
        url: {
          // https://drafts.csswg.org/css-values-3/#urls
          pattern: RegExp(
            "\\burl\\((?:" + r.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)",
            "i"
          ),
          greedy: !0,
          inside: {
            function: /^url/i,
            punctuation: /^\(|\)$/,
            string: {
              pattern: RegExp("^" + r.source + "$"),
              alias: "url"
            }
          }
        },
        selector: {
          pattern: RegExp(
            `(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + r.source + ")*(?=\\s*\\{)"
          ),
          lookbehind: !0
        },
        string: {
          pattern: r,
          greedy: !0
        },
        property: {
          pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
          lookbehind: !0
        },
        important: /!important\b/i,
        function: {
          pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
          lookbehind: !0
        },
        punctuation: /[(){};:,]/
      }, t.languages.css.atrule.inside.rest = t.languages.css;
      var n = t.languages.markup;
      n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
    })(e);
  }
  o(Jo, "css");
});

// ../node_modules/refractor/lang/clike.js
var d1 = z((v8, f1) => {
  "use strict";
  f1.exports = ea;
  ea.displayName = "clike";
  ea.aliases = [];
  function ea(e) {
    e.languages.clike = {
      comment: [
        {
          pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
          lookbehind: !0,
          greedy: !0
        },
        {
          pattern: /(^|[^\\:])\/\/.*/,
          lookbehind: !0,
          greedy: !0
        }
      ],
      string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: !0
      },
      "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: !0,
        inside: {
          punctuation: /[.\\]/
        }
      },
      keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
      boolean: /\b(?:false|true)\b/,
      function: /\b\w+(?=\()/,
      number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
      operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
      punctuation: /[{}[\];(),.:]/
    };
  }
  o(ea, "clike");
});

// ../node_modules/refractor/lang/javascript.js
var m1 = z((w8, p1) => {
  "use strict";
  p1.exports = ta;
  ta.displayName = "javascript";
  ta.aliases = ["js"];
  function ta(e) {
    e.languages.javascript = e.languages.extend("clike", {
      "class-name": [
        e.languages.clike["class-name"],
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
          lookbehind: !0
        }
      ],
      keyword: [
        {
          pattern: /((?:^|\})\s*)catch\b/,
          lookbehind: !0
        },
        {
          pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
          lookbehind: !0
        }
      ],
      // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
      function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
      number: {
        pattern: RegExp(
          /(^|[^\w$])/.source + "(?:" + // constant
          (/NaN|Infinity/.source + "|" + // binary integer
          /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
          /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
          /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
          /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
          /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
        ),
        lookbehind: !0
      },
      operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
    }), e.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, e.languages.
    insertBefore("javascript", "keyword", {
      regex: {
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
        lookbehind: !0,
        greedy: !0,
        inside: {
          "regex-source": {
            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
            lookbehind: !0,
            alias: "language-regex",
            inside: e.languages.regex
          },
          "regex-delimiter": /^\/|\/$/,
          "regex-flags": /^[a-z]+$/
        }
      },
      // This must be declared before keyword because we use "function" inside the look-forward
      "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
      },
      parameter: [
        {
          pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
          lookbehind: !0,
          inside: e.languages.javascript
        },
        {
          pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
          lookbehind: !0,
          inside: e.languages.javascript
        },
        {
          pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
          lookbehind: !0,
          inside: e.languages.javascript
        },
        {
          pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
          lookbehind: !0,
          inside: e.languages.javascript
        }
      ],
      constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
    }), e.languages.insertBefore("javascript", "string", {
      hashbang: {
        pattern: /^#!.*/,
        greedy: !0,
        alias: "comment"
      },
      "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: !0,
        inside: {
          "template-punctuation": {
            pattern: /^`|`$/,
            alias: "string"
          },
          interpolation: {
            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
            lookbehind: !0,
            inside: {
              "interpolation-punctuation": {
                pattern: /^\$\{|\}$/,
                alias: "punctuation"
              },
              rest: e.languages.javascript
            }
          },
          string: /[\s\S]+/
        }
      },
      "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: !0,
        greedy: !0,
        alias: "property"
      }
    }), e.languages.insertBefore("javascript", "operator", {
      "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: !0,
        alias: "property"
      }
    }), e.languages.markup && (e.languages.markup.tag.addInlined("script", "javascript"), e.languages.markup.tag.addAttribute(
      /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.
      source,
      "javascript"
    )), e.languages.js = e.languages.javascript;
  }
  o(ta, "javascript");
});

// ../node_modules/refractor/core.js
var w1 = z((x8, g1) => {
  "use strict";
  var Wr = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global ==
  "object" ? global : {}, D2 = Q2();
  Wr.Prism = { manual: !0, disableWorkerMessageHandler: !0 };
  var _2 = Bc(), F2 = i1(), h1 = c1(), V2 = Ko(), W2 = Qo(), $2 = d1(), j2 = m1();
  D2();
  var ra = {}.hasOwnProperty;
  function v1() {
  }
  o(v1, "Refractor");
  v1.prototype = h1;
  var ne = new v1();
  g1.exports = ne;
  ne.highlight = q2;
  ne.register = $r;
  ne.alias = U2;
  ne.registered = G2;
  ne.listLanguages = X2;
  $r(V2);
  $r(W2);
  $r($2);
  $r(j2);
  ne.util.encode = K2;
  ne.Token.stringify = Z2;
  function $r(e) {
    if (typeof e != "function" || !e.displayName)
      throw new Error("Expected `function` for `grammar`, got `" + e + "`");
    ne.languages[e.displayName] === void 0 && e(ne);
  }
  o($r, "register");
  function U2(e, t) {
    var r = ne.languages, n = e, a, i, c, l;
    t && (n = {}, n[e] = t);
    for (a in n)
      for (i = n[a], i = typeof i == "string" ? [i] : i, c = i.length, l = -1; ++l < c; )
        r[i[l]] = r[a];
  }
  o(U2, "alias");
  function q2(e, t) {
    var r = h1.highlight, n;
    if (typeof e != "string")
      throw new Error("Expected `string` for `value`, got `" + e + "`");
    if (ne.util.type(t) === "Object")
      n = t, t = null;
    else {
      if (typeof t != "string")
        throw new Error("Expected `string` for `name`, got `" + t + "`");
      if (ra.call(ne.languages, t))
        n = ne.languages[t];
      else
        throw new Error("Unknown language: `" + t + "` is not registered");
    }
    return r.call(this, e, n, t);
  }
  o(q2, "highlight");
  function G2(e) {
    if (typeof e != "string")
      throw new Error("Expected `string` for `language`, got `" + e + "`");
    return ra.call(ne.languages, e);
  }
  o(G2, "registered");
  function X2() {
    var e = ne.languages, t = [], r;
    for (r in e)
      ra.call(e, r) && typeof e[r] == "object" && t.push(r);
    return t;
  }
  o(X2, "listLanguages");
  function Z2(e, t, r) {
    var n;
    return typeof e == "string" ? { type: "text", value: e } : ne.util.type(e) === "Array" ? Y2(e, t) : (n = {
      type: e.type,
      content: ne.Token.stringify(e.content, t, r),
      tag: "span",
      classes: ["token", e.type],
      attributes: {},
      language: t,
      parent: r
    }, e.alias && (n.classes = n.classes.concat(e.alias)), ne.hooks.run("wrap", n), _2(
      n.tag + "." + n.classes.join("."),
      J2(n.attributes),
      n.content
    ));
  }
  o(Z2, "stringify");
  function Y2(e, t) {
    for (var r = [], n = e.length, a = -1, i; ++a < n; )
      i = e[a], i !== "" && i !== null && i !== void 0 && r.push(i);
    for (a = -1, n = r.length; ++a < n; )
      i = r[a], r[a] = ne.Token.stringify(i, t, r);
    return r;
  }
  o(Y2, "stringifyAll");
  function K2(e) {
    return e;
  }
  o(K2, "encode");
  function J2(e) {
    var t;
    for (t in e)
      e[t] = F2(e[t]);
    return e;
  }
  o(J2, "attributes");
  function Q2() {
    var e = "Prism" in Wr, t = e ? Wr.Prism : void 0;
    return r;
    function r() {
      e ? Wr.Prism = t : delete Wr.Prism, e = void 0, t = void 0;
    }
  }
  o(Q2, "capture");
});

// ../node_modules/react-syntax-highlighter/dist/esm/prism-light.js
var Sn, na, Mn, R1 = S(() => {
  Bl();
  Sn = ve(w1()), na = Po(Sn.default, {});
  na.registerLanguage = function(e, t) {
    return Sn.default.register(t);
  };
  na.alias = function(e, t) {
    return Sn.default.alias(e, t);
  };
  Mn = na;
});

// ../node_modules/react-syntax-highlighter/dist/esm/index.js
var x1 = S(() => {
  zo();
});

// ../node_modules/refractor/lang/bash.js
var y1 = z((M8, b1) => {
  "use strict";
  b1.exports = oa;
  oa.displayName = "bash";
  oa.aliases = ["shell"];
  function oa(e) {
    (function(t) {
      var r = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE\
|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|G\
DMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HO\
STTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHON\
E|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OST\
YPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS\
|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRE\
NT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_\
SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", n = {
        pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
        lookbehind: !0,
        alias: "punctuation",
        // this looks reasonably well in all themes
        inside: null
        // see below
      }, a = {
        bash: n,
        environment: {
          pattern: RegExp("\\$" + r),
          alias: "constant"
        },
        variable: [
          // [0]: Arithmetic Environment
          {
            pattern: /\$?\(\([\s\S]+?\)\)/,
            greedy: !0,
            inside: {
              // If there is a $ sign at the beginning highlight $(( and )) as variable
              variable: [
                {
                  pattern: /(^\$\(\([\s\S]+)\)\)/,
                  lookbehind: !0
                },
                /^\$\(\(/
              ],
              number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
              // Operators according to https://www.gnu.org/software/bash/manual/bashref.html#Shell-Arithmetic
              operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
              // If there is no $ sign at the beginning highlight (( and )) as punctuation
              punctuation: /\(\(?|\)\)?|,|;/
            }
          },
          // [1]: Command Substitution
          {
            pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
            greedy: !0,
            inside: {
              variable: /^\$\(|^`|\)$|`$/
            }
          },
          // [2]: Brace expansion
          {
            pattern: /\$\{[^}]+\}/,
            greedy: !0,
            inside: {
              operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
              punctuation: /[\[\]]/,
              environment: {
                pattern: RegExp("(\\{)" + r),
                lookbehind: !0,
                alias: "constant"
              }
            }
          },
          /\$(?:\w+|[#?*!@$])/
        ],
        // Escape sequences from echo and printf's manuals, and escaped quotes.
        entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
      };
      t.languages.bash = {
        shebang: {
          pattern: /^#!\s*\/.*/,
          alias: "important"
        },
        comment: {
          pattern: /(^|[^"{\\$])#.*/,
          lookbehind: !0
        },
        "function-name": [
          // a) function foo {
          // b) foo() {
          // c) function foo() {
          // but not “foo {”
          {
            // a) and c)
            pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
            lookbehind: !0,
            alias: "function"
          },
          {
            // b)
            pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
            alias: "function"
          }
        ],
        // Highlight variable names as variables in for and select beginnings.
        "for-or-select": {
          pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
          alias: "variable",
          lookbehind: !0
        },
        // Highlight variable names as variables in the left-hand part
        // of assignments (“=” and “+=”).
        "assign-left": {
          pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
          inside: {
            environment: {
              pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + r),
              lookbehind: !0,
              alias: "constant"
            }
          },
          alias: "variable",
          lookbehind: !0
        },
        string: [
          // Support for Here-documents https://en.wikipedia.org/wiki/Here_document
          {
            pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
            lookbehind: !0,
            greedy: !0,
            inside: a
          },
          // Here-document with quotes around the tag
          // → No expansion (so no “inside”).
          {
            pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
            lookbehind: !0,
            greedy: !0,
            inside: {
              bash: n
            }
          },
          // “Normal” string
          {
            // https://www.gnu.org/software/bash/manual/html_node/Double-Quotes.html
            pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
            lookbehind: !0,
            greedy: !0,
            inside: a
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/Single-Quotes.html
            pattern: /(^|[^$\\])'[^']*'/,
            lookbehind: !0,
            greedy: !0
          },
          {
            // https://www.gnu.org/software/bash/manual/html_node/ANSI_002dC-Quoting.html
            pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
            greedy: !0,
            inside: {
              entity: a.entity
            }
          }
        ],
        environment: {
          pattern: RegExp("\\$?" + r),
          alias: "constant"
        },
        variable: a.variable,
        function: {
          pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        keyword: {
          pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        // https://www.gnu.org/software/bash/manual/html_node/Shell-Builtin-Commands.html
        builtin: {
          pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
          lookbehind: !0,
          // Alias added to make those easier to distinguish from strings.
          alias: "class-name"
        },
        boolean: {
          pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
          lookbehind: !0
        },
        "file-descriptor": {
          pattern: /\B&\d\b/,
          alias: "important"
        },
        operator: {
          // Lots of redirections here, but not just that.
          pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
          inside: {
            "file-descriptor": {
              pattern: /^\d/,
              alias: "important"
            }
          }
        },
        punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
        number: {
          pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
          lookbehind: !0
        }
      }, n.inside = t.languages.bash;
      for (var i = [
        "comment",
        "function-name",
        "for-or-select",
        "assign-left",
        "string",
        "environment",
        "function",
        "keyword",
        "builtin",
        "boolean",
        "file-descriptor",
        "operator",
        "punctuation",
        "number"
      ], c = a.variable[1].inside, l = 0; l < i.length; l++)
        c[i[l]] = t.languages.bash[i[l]];
      t.languages.shell = t.languages.bash;
    })(e);
  }
  o(oa, "bash");
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/bash.js
var E1, C1, S1 = S(() => {
  E1 = ve(y1()), C1 = E1.default;
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/css.js
var M1, L1, A1 = S(() => {
  M1 = ve(Qo()), L1 = M1.default;
});

// ../node_modules/refractor/lang/graphql.js
var H1 = z((H8, I1) => {
  "use strict";
  I1.exports = aa;
  aa.displayName = "graphql";
  aa.aliases = [];
  function aa(e) {
    e.languages.graphql = {
      comment: /#.*/,
      description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: !0,
        alias: "string",
        inside: {
          "language-markdown": {
            pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
            lookbehind: !0,
            inside: e.languages.markdown
          }
        }
      },
      string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: !0
      },
      number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      boolean: /\b(?:false|true)\b/,
      variable: /\$[a-z_]\w*/i,
      directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
      },
      "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: !0
      },
      "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
      },
      scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
      constant: /\b[A-Z][A-Z_\d]*\b/,
      "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: !0
      },
      fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: !0,
        alias: "function"
      },
      keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
      operator: /[!=|&]|\.{3}/,
      "property-query": /\w+(?=\s*\()/,
      object: /\w+(?=\s*\{)/,
      punctuation: /[!(){}\[\]:=,]/,
      property: /\w+/
    }, e.hooks.add("after-tokenize", /* @__PURE__ */ o(function(r) {
      if (r.language !== "graphql")
        return;
      var n = r.tokens.filter(function(h) {
        return typeof h != "string" && h.type !== "comment" && h.type !== "scalar";
      }), a = 0;
      function i(h) {
        return n[a + h];
      }
      o(i, "getToken");
      function c(h, v) {
        v = v || 0;
        for (var w = 0; w < h.length; w++) {
          var R = i(w + v);
          if (!R || R.type !== h[w])
            return !1;
        }
        return !0;
      }
      o(c, "isTokenType");
      function l(h, v) {
        for (var w = 1, R = a; R < n.length; R++) {
          var y = n[R], E = y.content;
          if (y.type === "punctuation" && typeof E == "string") {
            if (h.test(E))
              w++;
            else if (v.test(E) && (w--, w === 0))
              return R;
          }
        }
        return -1;
      }
      o(l, "findClosingBracket");
      function s(h, v) {
        var w = h.alias;
        w ? Array.isArray(w) || (h.alias = w = [w]) : h.alias = w = [], w.push(v);
      }
      for (o(s, "addAlias"); a < n.length; ) {
        var u = n[a++];
        if (u.type === "keyword" && u.content === "mutation") {
          var f = [];
          if (c(["definition-mutation", "punctuation"]) && i(1).content === "(") {
            a += 2;
            var d = l(/^\($/, /^\)$/);
            if (d === -1)
              continue;
            for (; a < d; a++) {
              var m = i(0);
              m.type === "variable" && (s(m, "variable-input"), f.push(m.content));
            }
            a = d + 1;
          }
          if (c(["punctuation", "property-query"]) && i(0).content === "{" && (a++, s(i(0), "property-mutation"), f.length > 0)) {
            var g = l(/^\{$/, /^\}$/);
            if (g === -1)
              continue;
            for (var x = a; x < g; x++) {
              var p = n[x];
              p.type === "variable" && f.indexOf(p.content) >= 0 && s(p, "variable-input");
            }
          }
        }
      }
    }, "afterTokenizeGraphql"));
  }
  o(aa, "graphql");
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/graphql.js
var T1, z1, P1 = S(() => {
  T1 = ve(H1()), z1 = T1.default;
});

// ../node_modules/refractor/lang/js-extras.js
var B1 = z((P8, k1) => {
  "use strict";
  k1.exports = ia;
  ia.displayName = "jsExtras";
  ia.aliases = [];
  function ia(e) {
    (function(t) {
      t.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
          pattern: RegExp(
            "(\\.\\s*)" + t.languages.javascript["function-variable"].pattern.source
          ),
          lookbehind: !0,
          alias: ["function-variable", "method", "function", "property-access"]
        }
      }), t.languages.insertBefore("javascript", "function", {
        method: {
          pattern: RegExp(
            "(\\.\\s*)" + t.languages.javascript.function.source
          ),
          lookbehind: !0,
          alias: ["function", "property-access"]
        }
      }), t.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
          {
            // standard built-ins
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects
            pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
            alias: "class-name"
          },
          {
            // errors
            pattern: /\b(?:[A-Z]\w*)Error\b/,
            alias: "class-name"
          }
        ]
      });
      function r(s, u) {
        return RegExp(
          s.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
          }),
          u
        );
      }
      o(r, "withId"), t.languages.insertBefore("javascript", "keyword", {
        imports: {
          // https://tc39.es/ecma262/#sec-imports
          pattern: r(
            /(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source
          ),
          lookbehind: !0,
          inside: t.languages.javascript
        },
        exports: {
          // https://tc39.es/ecma262/#sec-exports
          pattern: r(
            /(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source
          ),
          lookbehind: !0,
          inside: t.languages.javascript
        }
      }), t.languages.javascript.keyword.unshift(
        {
          pattern: /\b(?:as|default|export|from|import)\b/,
          alias: "module"
        },
        {
          pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
          alias: "control-flow"
        },
        {
          pattern: /\bnull\b/,
          alias: ["null", "nil"]
        },
        {
          pattern: /\bundefined\b/,
          alias: "nil"
        }
      ), t.languages.insertBefore("javascript", "operator", {
        spread: {
          pattern: /\.{3}/,
          alias: "operator"
        },
        arrow: {
          pattern: /=>/,
          alias: "operator"
        }
      }), t.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
          pattern: r(/(\.\s*)#?<ID>/.source),
          lookbehind: !0
        },
        "maybe-class-name": {
          pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
          lookbehind: !0
        },
        dom: {
          // this contains only a few commonly used DOM variables
          pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
          alias: "variable"
        },
        console: {
          pattern: /\bconsole(?=\s*\.)/,
          alias: "class-name"
        }
      });
      for (var n = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
      ], a = 0; a < n.length; a++) {
        var i = n[a], c = t.languages.javascript[i];
        t.util.type(c) === "RegExp" && (c = t.languages.javascript[i] = {
          pattern: c
        });
        var l = c.inside || {};
        c.inside = l, l["maybe-class-name"] = /^[A-Z][\s\S]*/;
      }
    })(e);
  }
  o(ia, "jsExtras");
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/js-extras.js
var O1, N1, D1 = S(() => {
  O1 = ve(B1()), N1 = O1.default;
});

// ../node_modules/refractor/lang/json.js
var F1 = z((O8, _1) => {
  "use strict";
  _1.exports = la;
  la.displayName = "json";
  la.aliases = ["webmanifest"];
  function la(e) {
    e.languages.json = {
      property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: !0,
        greedy: !0
      },
      comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: !0
      },
      number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
      punctuation: /[{}[\],]/,
      operator: /:/,
      boolean: /\b(?:false|true)\b/,
      null: {
        pattern: /\bnull\b/,
        alias: "keyword"
      }
    }, e.languages.webmanifest = e.languages.json;
  }
  o(la, "json");
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/json.js
var V1, W1, $1 = S(() => {
  V1 = ve(F1()), W1 = V1.default;
});

// ../node_modules/refractor/lang/jsx.js
var sa = z((_8, j1) => {
  "use strict";
  j1.exports = ca;
  ca.displayName = "jsx";
  ca.aliases = [];
  function ca(e) {
    (function(t) {
      var r = t.util.clone(t.languages.javascript), n = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.
      source, i = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
      function c(u, f) {
        return u = u.replace(/<S>/g, function() {
          return n;
        }).replace(/<BRACES>/g, function() {
          return a;
        }).replace(/<SPREAD>/g, function() {
          return i;
        }), RegExp(u, f);
      }
      o(c, "re"), i = c(i).source, t.languages.jsx = t.languages.extend("markup", r), t.languages.jsx.tag.pattern = c(
        /<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.
        source
      ), t.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, t.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/,
      t.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, t.languages.jsx.tag.inside.comment = r.comment, t.languages.
      insertBefore(
        "inside",
        "attr-name",
        {
          spread: {
            pattern: c(/<SPREAD>/.source),
            inside: t.languages.jsx
          }
        },
        t.languages.jsx.tag
      ), t.languages.insertBefore(
        "inside",
        "special-attr",
        {
          script: {
            // Allow for two levels of nesting
            pattern: c(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
              "script-punctuation": {
                pattern: /^=(?=\{)/,
                alias: "punctuation"
              },
              rest: t.languages.jsx
            }
          }
        },
        t.languages.jsx.tag
      );
      var l = /* @__PURE__ */ o(function(u) {
        return u ? typeof u == "string" ? u : typeof u.content == "string" ? u.content : u.content.map(l).join("") : "";
      }, "stringifyToken"), s = /* @__PURE__ */ o(function(u) {
        for (var f = [], d = 0; d < u.length; d++) {
          var m = u[d], g = !1;
          if (typeof m != "string" && (m.type === "tag" && m.content[0] && m.content[0].type === "tag" ? m.content[0].content[0].content ===
          "</" ? f.length > 0 && f[f.length - 1].tagName === l(m.content[0].content[1]) && f.pop() : m.content[m.content.length - 1].content ===
          "/>" || f.push({
            tagName: l(m.content[0].content[1]),
            openedBraces: 0
          }) : f.length > 0 && m.type === "punctuation" && m.content === "{" ? f[f.length - 1].openedBraces++ : f.length > 0 && f[f.length -
          1].openedBraces > 0 && m.type === "punctuation" && m.content === "}" ? f[f.length - 1].openedBraces-- : g = !0), (g || typeof m ==
          "string") && f.length > 0 && f[f.length - 1].openedBraces === 0) {
            var x = l(m);
            d < u.length - 1 && (typeof u[d + 1] == "string" || u[d + 1].type === "plain-text") && (x += l(u[d + 1]), u.splice(d + 1, 1)), d >
            0 && (typeof u[d - 1] == "string" || u[d - 1].type === "plain-text") && (x = l(u[d - 1]) + x, u.splice(d - 1, 1), d--), u[d] = new t.
            Token(
              "plain-text",
              x,
              null,
              x
            );
          }
          m.content && typeof m.content != "string" && s(m.content);
        }
      }, "walkTokens");
      t.hooks.add("after-tokenize", function(u) {
        u.language !== "jsx" && u.language !== "tsx" || s(u.tokens);
      });
    })(e);
  }
  o(ca, "jsx");
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/jsx.js
var U1, q1, G1 = S(() => {
  U1 = ve(sa()), q1 = U1.default;
});

// ../node_modules/refractor/lang/markdown.js
var Z1 = z((W8, X1) => {
  "use strict";
  X1.exports = ua;
  ua.displayName = "markdown";
  ua.aliases = ["md"];
  function ua(e) {
    (function(t) {
      var r = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
      function n(d) {
        return d = d.replace(/<inner>/g, function() {
          return r;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + d + ")");
      }
      o(n, "createInline");
      var a = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, i = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.
      replace(
        /__/g,
        function() {
          return a;
        }
      ), c = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
      t.languages.markdown = t.languages.extend("markup", {}), t.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
          pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
          lookbehind: !0,
          greedy: !0,
          inside: {
            punctuation: /^---|---$/,
            "front-matter": {
              pattern: /\S+(?:\s+\S+)*/,
              alias: ["yaml", "language-yaml"],
              inside: t.languages.yaml
            }
          }
        },
        blockquote: {
          // > ...
          pattern: /^>(?:[\t ]*>)*/m,
          alias: "punctuation"
        },
        table: {
          pattern: RegExp(
            "^" + i + c + "(?:" + i + ")*",
            "m"
          ),
          inside: {
            "table-data-rows": {
              pattern: RegExp(
                "^(" + i + c + ")(?:" + i + ")*$"
              ),
              lookbehind: !0,
              inside: {
                "table-data": {
                  pattern: RegExp(a),
                  inside: t.languages.markdown
                },
                punctuation: /\|/
              }
            },
            "table-line": {
              pattern: RegExp("^(" + i + ")" + c + "$"),
              lookbehind: !0,
              inside: {
                punctuation: /\||:?-{3,}:?/
              }
            },
            "table-header-row": {
              pattern: RegExp("^" + i + "$"),
              inside: {
                "table-header": {
                  pattern: RegExp(a),
                  alias: "important",
                  inside: t.languages.markdown
                },
                punctuation: /\|/
              }
            }
          }
        },
        code: [
          {
            // Prefixed by 4 spaces or 1 tab and preceded by an empty line
            pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
            lookbehind: !0,
            alias: "keyword"
          },
          {
            // ```optional language
            // code block
            // ```
            pattern: /^```[\s\S]*?^```$/m,
            greedy: !0,
            inside: {
              "code-block": {
                pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                lookbehind: !0
              },
              "code-language": {
                pattern: /^(```).+/,
                lookbehind: !0
              },
              punctuation: /```/
            }
          }
        ],
        title: [
          {
            // title 1
            // =======
            // title 2
            // -------
            pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
            alias: "important",
            inside: {
              punctuation: /==+$|--+$/
            }
          },
          {
            // # title 1
            // ###### title 6
            pattern: /(^\s*)#.+/m,
            lookbehind: !0,
            alias: "important",
            inside: {
              punctuation: /^#+|#+$/
            }
          }
        ],
        hr: {
          // ***
          // ---
          // * * *
          // -----------
          pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        list: {
          // * item
          // + item
          // - item
          // 1. item
          pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
          lookbehind: !0,
          alias: "punctuation"
        },
        "url-reference": {
          // [id]: http://example.com "Optional title"
          // [id]: http://example.com 'Optional title'
          // [id]: http://example.com (Optional title)
          // [id]: <http://example.com> "Optional title"
          pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
          inside: {
            variable: {
              pattern: /^(!?\[)[^\]]+/,
              lookbehind: !0
            },
            string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
            punctuation: /^[\[\]!:]|[<>]/
          },
          alias: "url"
        },
        bold: {
          // **strong**
          // __strong__
          // allow one nested instance of italic text using the same delimiter
          pattern: n(
            /\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^..)[\s\S]+(?=..$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /\*\*|__/
          }
        },
        italic: {
          // *em*
          // _em_
          // allow one nested instance of bold text using the same delimiter
          pattern: n(
            /\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^.)[\s\S]+(?=.$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /[*_]/
          }
        },
        strike: {
          // ~~strike through~~
          // ~strike~
          // eslint-disable-next-line regexp/strict
          pattern: n(/(~~?)(?:(?!~)<inner>)+\2/.source),
          lookbehind: !0,
          greedy: !0,
          inside: {
            content: {
              pattern: /(^~~?)[\s\S]+(?=\1$)/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            punctuation: /~~?/
          }
        },
        "code-snippet": {
          // `code`
          // ``code``
          pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
          lookbehind: !0,
          greedy: !0,
          alias: ["code", "keyword"]
        },
        url: {
          // [example](http://example.com "Optional title")
          // [example][id]
          // [example] [id]
          pattern: n(
            /!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source
          ),
          lookbehind: !0,
          greedy: !0,
          inside: {
            operator: /^!/,
            content: {
              pattern: /(^\[)[^\]]+(?=\])/,
              lookbehind: !0,
              inside: {}
              // see below
            },
            variable: {
              pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
              lookbehind: !0
            },
            url: {
              pattern: /(^\]\()[^\s)]+/,
              lookbehind: !0
            },
            string: {
              pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
              lookbehind: !0
            }
          }
        }
      }), ["url", "bold", "italic", "strike"].forEach(function(d) {
        ["url", "bold", "italic", "strike", "code-snippet"].forEach(function(m) {
          d !== m && (t.languages.markdown[d].inside.content.inside[m] = t.languages.markdown[m]);
        });
      }), t.hooks.add("after-tokenize", function(d) {
        if (d.language !== "markdown" && d.language !== "md")
          return;
        function m(g) {
          if (!(!g || typeof g == "string"))
            for (var x = 0, p = g.length; x < p; x++) {
              var h = g[x];
              if (h.type !== "code") {
                m(h.content);
                continue;
              }
              var v = h.content[1], w = h.content[3];
              if (v && w && v.type === "code-language" && w.type === "code-block" && typeof v.content == "string") {
                var R = v.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
                R = (/[a-z][\w-]*/i.exec(R) || [""])[0].toLowerCase();
                var y = "language-" + R;
                w.alias ? typeof w.alias == "string" ? w.alias = [w.alias, y] : w.alias.push(y) : w.alias = [y];
              }
            }
        }
        o(m, "walkTokens"), m(d.tokens);
      }), t.hooks.add("wrap", function(d) {
        if (d.type === "code-block") {
          for (var m = "", g = 0, x = d.classes.length; g < x; g++) {
            var p = d.classes[g], h = /language-(.+)/.exec(p);
            if (h) {
              m = h[1];
              break;
            }
          }
          var v = t.languages[m];
          if (v)
            d.content = t.highlight(
              f(d.content.value),
              v,
              m
            );
          else if (m && m !== "none" && t.plugins.autoloader) {
            var w = "md-" + (/* @__PURE__ */ new Date()).valueOf() + "-" + Math.floor(Math.random() * 1e16);
            d.attributes.id = w, t.plugins.autoloader.loadLanguages(m, function() {
              var R = document.getElementById(w);
              R && (R.innerHTML = t.highlight(
                R.textContent,
                t.languages[m],
                m
              ));
            });
          }
        }
      });
      var l = RegExp(t.languages.markup.tag.pattern.source, "gi"), s = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
      }, u = String.fromCodePoint || String.fromCharCode;
      function f(d) {
        var m = d.replace(l, "");
        return m = m.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(g, x) {
          if (x = x.toLowerCase(), x[0] === "#") {
            var p;
            return x[1] === "x" ? p = parseInt(x.slice(2), 16) : p = Number(x.slice(1)), u(p);
          } else {
            var h = s[x];
            return h || g;
          }
        }), m;
      }
      o(f, "textContent"), t.languages.md = t.languages.markdown;
    })(e);
  }
  o(ua, "markdown");
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/markdown.js
var Y1, K1, J1 = S(() => {
  Y1 = ve(Z1()), K1 = Y1.default;
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/markup.js
var Q1, es, ts = S(() => {
  Q1 = ve(Ko()), es = Q1.default;
});

// ../node_modules/refractor/lang/typescript.js
var da = z((q8, rs) => {
  "use strict";
  rs.exports = fa;
  fa.displayName = "typescript";
  fa.aliases = ["ts"];
  function fa(e) {
    (function(t) {
      t.languages.typescript = t.languages.extend("javascript", {
        "class-name": {
          pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
          lookbehind: !0,
          greedy: !0,
          inside: null
          // see below
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
      }), t.languages.typescript.keyword.push(
        /\b(?:abstract|declare|is|keyof|readonly|require)\b/,
        // keywords that have to be followed by an identifier
        /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/,
        // This is for `import type *, {}`
        /\btype\b(?=\s*(?:[\{*]|$))/
      ), delete t.languages.typescript.parameter, delete t.languages.typescript["literal-property"];
      var r = t.languages.extend("typescript", {});
      delete r["class-name"], t.languages.typescript["class-name"].inside = r, t.languages.insertBefore("typescript", "function", {
        decorator: {
          pattern: /@[$\w\xA0-\uFFFF]+/,
          inside: {
            at: {
              pattern: /^@/,
              alias: "operator"
            },
            function: /^[\s\S]+/
          }
        },
        "generic-function": {
          // e.g. foo<T extends "bar" | "baz">( ...
          pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
          greedy: !0,
          inside: {
            function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
            generic: {
              pattern: /<[\s\S]+/,
              // everything after the first <
              alias: "class-name",
              inside: r
            }
          }
        }
      }), t.languages.ts = t.languages.typescript;
    })(e);
  }
  o(fa, "typescript");
});

// ../node_modules/refractor/lang/tsx.js
var os = z((X8, ns) => {
  "use strict";
  var e4 = sa(), t4 = da();
  ns.exports = pa;
  pa.displayName = "tsx";
  pa.aliases = [];
  function pa(e) {
    e.register(e4), e.register(t4), function(t) {
      var r = t.util.clone(t.languages.typescript);
      t.languages.tsx = t.languages.extend("jsx", r), delete t.languages.tsx.parameter, delete t.languages.tsx["literal-property"];
      var n = t.languages.tsx.tag;
      n.pattern = RegExp(
        /(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")",
        n.pattern.flags
      ), n.lookbehind = !0;
    }(e);
  }
  o(pa, "tsx");
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/tsx.js
var as, is, ls = S(() => {
  as = ve(os()), is = as.default;
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/typescript.js
var cs, ss, us = S(() => {
  cs = ve(da()), ss = cs.default;
});

// ../node_modules/refractor/lang/yaml.js
var ds = z((J8, fs) => {
  "use strict";
  fs.exports = ma;
  ma.displayName = "yaml";
  ma.aliases = ["yml"];
  function ma(e) {
    (function(t) {
      var r = /[*&][^\s[\]{},]+/, n = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + n.source +
      "(?:[ 	]+" + r.source + ")?|" + r.source + "(?:[ 	]+" + n.source + ")?)", i = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.
      source.replace(
        /<PLAIN>/g,
        function() {
          return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
        }
      ), c = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
      function l(s, u) {
        u = (u || "").replace(/m/g, "") + "m";
        var f = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
          return a;
        }).replace(/<<value>>/g, function() {
          return s;
        });
        return RegExp(f, u);
      }
      o(l, "createValuePattern"), t.languages.yaml = {
        scalar: {
          pattern: RegExp(
            /([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(
              /<<prop>>/g,
              function() {
                return a;
              }
            )
          ),
          lookbehind: !0,
          alias: "string"
        },
        comment: /#.*/,
        key: {
          pattern: RegExp(
            /((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
              return a;
            }).replace(/<<key>>/g, function() {
              return "(?:" + i + "|" + c + ")";
            })
          ),
          lookbehind: !0,
          greedy: !0,
          alias: "atrule"
        },
        directive: {
          pattern: /(^[ \t]*)%.+/m,
          lookbehind: !0,
          alias: "important"
        },
        datetime: {
          pattern: l(
            /\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.
            source
          ),
          lookbehind: !0,
          alias: "number"
        },
        boolean: {
          pattern: l(/false|true/.source, "i"),
          lookbehind: !0,
          alias: "important"
        },
        null: {
          pattern: l(/null|~/.source, "i"),
          lookbehind: !0,
          alias: "important"
        },
        string: {
          pattern: l(c),
          lookbehind: !0,
          greedy: !0
        },
        number: {
          pattern: l(
            /[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source,
            "i"
          ),
          lookbehind: !0
        },
        tag: n,
        important: r,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
      }, t.languages.yml = t.languages.yaml;
    })(e);
  }
  o(ma, "yaml");
});

// ../node_modules/react-syntax-highlighter/dist/esm/languages/prism/yaml.js
var ps, ms, hs = S(() => {
  ps = ve(ds()), ms = ps.default;
});

// src/components/components/ActionBar/ActionBar.tsx
import vs from "react";
import { styled as gs } from "storybook/theming";
var r4, ws, ha, va = S(() => {
  "use strict";
  r4 = gs.div(({ theme: e }) => ({
    position: "absolute",
    bottom: 0,
    right: 0,
    maxWidth: "100%",
    display: "flex",
    background: e.background.content,
    zIndex: 1
  })), ws = gs.button(
    ({ theme: e }) => ({
      margin: 0,
      border: "0 none",
      padding: "4px 10px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      color: e.color.defaultText,
      background: e.background.content,
      fontSize: 12,
      lineHeight: "16px",
      fontFamily: e.typography.fonts.base,
      fontWeight: e.typography.weight.bold,
      borderTop: `1px solid ${e.appBorderColor}`,
      borderLeft: `1px solid ${e.appBorderColor}`,
      marginLeft: -1,
      borderRadius: "4px 0 0 0",
      "&:not(:last-child)": { borderRight: `1px solid ${e.appBorderColor}` },
      "& + *": {
        borderLeft: `1px solid ${e.appBorderColor}`,
        borderRadius: 0
      },
      "&:focus": {
        boxShadow: `${e.color.secondary} 0 -3px 0 0 inset`,
        outline: "0 none"
      }
    }),
    ({ disabled: e }) => e && {
      cursor: "not-allowed",
      opacity: 0.5
    }
  );
  ws.displayName = "ActionButton";
  ha = /* @__PURE__ */ o(({ actionItems: e, ...t }) => /* @__PURE__ */ vs.createElement(r4, { ...t }, e.map(({ title: r, className: n, onClick: a,
  disabled: i }, c) => /* @__PURE__ */ vs.createElement(ws, { key: c, className: n, onClick: a, disabled: !!i }, r))), "ActionBar");
});

// ../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
import * as Rs from "react";
function n4(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function jr(...e) {
  return (t) => e.forEach((r) => n4(r, t));
}
function oe(...e) {
  return Rs.useCallback(jr(...e), e);
}
var lt = S(() => {
  o(n4, "setRef");
  o(jr, "composeRefs");
  o(oe, "useComposedRefs");
});

// ../node_modules/@radix-ui/react-primitive/node_modules/@radix-ui/react-slot/dist/index.mjs
import * as ge from "react";
import { Fragment as o4, jsx as ga } from "react/jsx-runtime";
function i4(e) {
  return ge.isValidElement(e) && e.type === a4;
}
function l4(e, t) {
  let r = { ...t };
  for (let n in t) {
    let a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...l) => {
      i(...l), a(...l);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...i } : n === "className" && (r[n] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function c4(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref :
  e.props.ref || e.ref);
}
var Ra, wa, a4, xs = S(() => {
  lt();
  Ra = ge.forwardRef((e, t) => {
    let { children: r, ...n } = e, a = ge.Children.toArray(r), i = a.find(i4);
    if (i) {
      let c = i.props.children, l = a.map((s) => s === i ? ge.Children.count(c) > 1 ? ge.Children.only(null) : ge.isValidElement(c) ? c.props.
      children : null : s);
      return /* @__PURE__ */ ga(wa, { ...n, ref: t, children: ge.isValidElement(c) ? ge.cloneElement(c, void 0, l) : null });
    }
    return /* @__PURE__ */ ga(wa, { ...n, ref: t, children: r });
  });
  Ra.displayName = "Slot";
  wa = ge.forwardRef((e, t) => {
    let { children: r, ...n } = e;
    if (ge.isValidElement(r)) {
      let a = c4(r);
      return ge.cloneElement(r, {
        ...l4(n, r.props),
        // @ts-ignore
        ref: t ? jr(t, a) : a
      });
    }
    return ge.Children.count(r) > 1 ? ge.Children.only(null) : null;
  });
  wa.displayName = "SlotClone";
  a4 = /* @__PURE__ */ o(({ children: e }) => /* @__PURE__ */ ga(o4, { children: e }), "Slottable");
  o(i4, "isSlottable");
  o(l4, "mergeProps");
  o(c4, "getElementRef");
});

// ../node_modules/@radix-ui/react-primitive/dist/index.mjs
import * as bs from "react";
import * as ys from "react-dom";
import { jsx as s4 } from "react/jsx-runtime";
function Es(e, t) {
  e && ys.flushSync(() => e.dispatchEvent(t));
}
var u4, ie, or = S(() => {
  xs();
  u4 = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
  ], ie = u4.reduce((e, t) => {
    let r = bs.forwardRef((n, a) => {
      let { asChild: i, ...c } = n, l = i ? Ra : t;
      return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s4(l, { ...c, ref: a });
    });
    return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
  }, {});
  o(Es, "dispatchDiscreteCustomEvent");
});

// ../node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
import * as Cs from "react";
var Ve, ar = S(() => {
  Ve = globalThis?.document ? Cs.useLayoutEffect : () => {
  };
});

// ../node_modules/@radix-ui/react-scroll-area/node_modules/@radix-ui/react-presence/dist/index.mjs
import * as Te from "react";
import * as Ss from "react-dom";
import * as Ms from "react";
function f4(e, t) {
  return Ms.useReducer((r, n) => t[r][n] ?? r, e);
}
function d4(e) {
  let [t, r] = Te.useState(), n = Te.useRef({}), a = Te.useRef(e), i = Te.useRef("none"), c = e ? "mounted" : "unmounted", [l, s] = f4(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return Te.useEffect(() => {
    let u = Ln(n.current);
    i.current = l === "mounted" ? u : "none";
  }, [l]), Ve(() => {
    let u = n.current, f = a.current;
    if (f !== e) {
      let m = i.current, g = Ln(u);
      e ? s("MOUNT") : g === "none" || u?.display === "none" ? s("UNMOUNT") : s(f && m !== g ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, s]), Ve(() => {
    if (t) {
      let u = /* @__PURE__ */ o((d) => {
        let g = Ln(n.current).includes(d.animationName);
        d.target === t && g && Ss.flushSync(() => s("ANIMATION_END"));
      }, "handleAnimationEnd"), f = /* @__PURE__ */ o((d) => {
        d.target === t && (i.current = Ln(n.current));
      }, "handleAnimationStart");
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      s("ANIMATION_END");
  }, [t, s]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: Te.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
function Ln(e) {
  return e?.animationName || "none";
}
function p4(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref :
  e.props.ref || e.ref);
}
var ir, Ls = S(() => {
  "use client";
  lt();
  ar();
  o(f4, "useStateMachine");
  ir = /* @__PURE__ */ o((e) => {
    let { present: t, children: r } = e, n = d4(t), a = typeof r == "function" ? r({ present: n.isPresent }) : Te.Children.only(r), i = oe(n.
    ref, p4(a));
    return typeof r == "function" || n.isPresent ? Te.cloneElement(a, { ref: i }) : null;
  }, "Presence");
  ir.displayName = "Presence";
  o(d4, "usePresence");
  o(Ln, "getAnimationName");
  o(p4, "getElementRef");
});

// ../node_modules/@radix-ui/react-scroll-area/node_modules/@radix-ui/react-context/dist/index.mjs
import * as ct from "react";
import { jsx as m4 } from "react/jsx-runtime";
function As(e, t = []) {
  let r = [];
  function n(i, c) {
    let l = ct.createContext(c), s = r.length;
    r = [...r, c];
    function u(d) {
      let { scope: m, children: g, ...x } = d, p = m?.[e][s] || l, h = ct.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ m4(p.Provider, { value: h, children: g });
    }
    o(u, "Provider");
    function f(d, m) {
      let g = m?.[e][s] || l, x = ct.useContext(g);
      if (x) return x;
      if (c !== void 0) return c;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return o(f, "useContext2"), u.displayName = i + "Provider", [u, f];
  }
  o(n, "createContext3");
  let a = /* @__PURE__ */ o(() => {
    let i = r.map((c) => ct.createContext(c));
    return /* @__PURE__ */ o(function(l) {
      let s = l?.[e] || i;
      return ct.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: s } }),
        [l, s]
      );
    }, "useScope");
  }, "createScope");
  return a.scopeName = e, [n, h4(a, ...t)];
}
function h4(...e) {
  let t = e[0];
  if (e.length === 1) return t;
  let r = /* @__PURE__ */ o(() => {
    let n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return /* @__PURE__ */ o(function(i) {
      let c = n.reduce((l, { useScope: s, scopeName: u }) => {
        let d = s(i)[`__scope${u}`];
        return { ...l, ...d };
      }, {});
      return ct.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    }, "useComposedScopes");
  }, "createScope");
  return r.scopeName = t.scopeName, r;
}
var Is = S(() => {
  o(As, "createContextScope");
  o(h4, "composeContextScopes");
});

// ../node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
import * as lr from "react";
function le(e) {
  let t = lr.useRef(e);
  return lr.useEffect(() => {
    t.current = e;
  }), lr.useMemo(() => (...r) => t.current?.(...r), []);
}
var cr = S(() => {
  o(le, "useCallbackRef");
});

// ../node_modules/@radix-ui/react-scroll-area/node_modules/@radix-ui/react-direction/dist/index.mjs
import * as An from "react";
import { jsx as M9 } from "react/jsx-runtime";
function Hs(e) {
  let t = An.useContext(v4);
  return e || t || "ltr";
}
var v4, Ts = S(() => {
  v4 = An.createContext(void 0);
  o(Hs, "useDirection");
});

// ../node_modules/@radix-ui/number/dist/index.mjs
function zs(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
var Ps = S(() => {
  o(zs, "clamp");
});

// ../node_modules/@radix-ui/primitive/dist/index.mjs
function de(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return /* @__PURE__ */ o(function(a) {
    if (e?.(a), r === !1 || !a.defaultPrevented)
      return t?.(a);
  }, "handleEvent");
}
var In = S(() => {
  o(de, "composeEventHandlers");
});

// ../node_modules/@radix-ui/react-scroll-area/dist/index.mjs
import * as I from "react";
import * as Bs from "react";
import { Fragment as w4, jsx as j, jsxs as R4 } from "react/jsx-runtime";
function g4(e, t) {
  return Bs.useReducer((r, n) => t[r][n] ?? r, e);
}
function Tn(e) {
  return e ? parseInt(e, 10) : 0;
}
function qs(e, t) {
  let r = e / t;
  return isNaN(r) ? 0 : r;
}
function zn(e) {
  let t = qs(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, n = (e.scrollbar.size - r) * t;
  return Math.max(n, 18);
}
function A4(e, t, r, n = "ltr") {
  let a = zn(r), i = a / 2, c = t || i, l = a - c, s = r.scrollbar.paddingStart + c, u = r.scrollbar.size - r.scrollbar.paddingEnd - l, f = r.
  content - r.viewport, d = n === "ltr" ? [0, f] : [f * -1, 0];
  return Gs([s, u], d)(e);
}
function ks(e, t, r = "ltr") {
  let n = zn(t), a = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - a, c = t.content - t.viewport, l = i - n, s = r ===
  "ltr" ? [0, c] : [c * -1, 0], u = zs(e, s);
  return Gs([0, c], [0, l])(u);
}
function Gs(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    let n = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + n * (r - e[0]);
  };
}
function Xs(e, t) {
  return e > 0 && e < t;
}
function Pn(e, t) {
  let r = le(e), n = I.useRef(0);
  return I.useEffect(() => () => window.clearTimeout(n.current), []), I.useCallback(() => {
    window.clearTimeout(n.current), n.current = window.setTimeout(r, t);
  }, [r, t]);
}
function sr(e, t) {
  let r = le(t);
  Ve(() => {
    let n = 0;
    if (e) {
      let a = new ResizeObserver(() => {
        cancelAnimationFrame(n), n = window.requestAnimationFrame(r);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(n), a.unobserve(e);
      };
    }
  }, [e, r]);
}
function H4(e, t) {
  let { asChild: r, children: n } = e;
  if (!r) return typeof t == "function" ? t(n) : t;
  let a = I.Children.only(n);
  return I.cloneElement(a, {
    children: typeof t == "function" ? t(a.props.children) : t
  });
}
var xa, Os, $9, x4, We, Ns, Ds, _s, nt, Fs, b4, y4, Vs, ba, E4, C4, S4, Ws, $s, Hn, js, M4, ya, Us, L4, I4, Zs, Ys, Ks, Js, Qs, e5 = S(() => {
  "use client";
  or();
  Ls();
  Is();
  lt();
  cr();
  Ts();
  ar();
  Ps();
  In();
  o(g4, "useStateMachine");
  xa = "ScrollArea", [Os, $9] = As(xa), [x4, We] = Os(xa), Ns = I.forwardRef(
    (e, t) => {
      let {
        __scopeScrollArea: r,
        type: n = "hover",
        dir: a,
        scrollHideDelay: i = 600,
        ...c
      } = e, [l, s] = I.useState(null), [u, f] = I.useState(null), [d, m] = I.useState(null), [g, x] = I.useState(null), [p, h] = I.useState(
      null), [v, w] = I.useState(0), [R, y] = I.useState(0), [E, b] = I.useState(!1), [C, L] = I.useState(!1), M = oe(t, (P) => s(P)), A = Hs(
      a);
      return /* @__PURE__ */ j(
        x4,
        {
          scope: r,
          type: n,
          dir: A,
          scrollHideDelay: i,
          scrollArea: l,
          viewport: u,
          onViewportChange: f,
          content: d,
          onContentChange: m,
          scrollbarX: g,
          onScrollbarXChange: x,
          scrollbarXEnabled: E,
          onScrollbarXEnabledChange: b,
          scrollbarY: p,
          onScrollbarYChange: h,
          scrollbarYEnabled: C,
          onScrollbarYEnabledChange: L,
          onCornerWidthChange: w,
          onCornerHeightChange: y,
          children: /* @__PURE__ */ j(
            ie.div,
            {
              dir: A,
              ...c,
              ref: M,
              style: {
                position: "relative",
                // Pass corner sizes as CSS vars to reduce re-renders of context consumers
                "--radix-scroll-area-corner-width": v + "px",
                "--radix-scroll-area-corner-height": R + "px",
                ...e.style
              }
            }
          )
        }
      );
    }
  );
  Ns.displayName = xa;
  Ds = "ScrollAreaViewport", _s = I.forwardRef(
    (e, t) => {
      let { __scopeScrollArea: r, children: n, asChild: a, nonce: i, ...c } = e, l = We(Ds, r), s = I.useRef(null), u = oe(t, s, l.onViewportChange);
      return /* @__PURE__ */ R4(w4, { children: [
        /* @__PURE__ */ j(
          "style",
          {
            dangerouslySetInnerHTML: {
              __html: `
[data-radix-scroll-area-viewport] {
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-overflow-scrolling: touch;
}
[data-radix-scroll-area-viewport]::-webkit-scrollbar {
  display: none;
}
:where([data-radix-scroll-area-viewport]) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
:where([data-radix-scroll-area-content]) {
  flex-grow: 1;
}
`
            },
            nonce: i
          }
        ),
        /* @__PURE__ */ j(
          ie.div,
          {
            "data-radix-scroll-area-viewport": "",
            ...c,
            asChild: a,
            ref: u,
            style: {
              /**
               * We don't support `visible` because the intention is to have at least one scrollbar
               * if this component is used and `visible` will behave like `auto` in that case
               * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
               *
               * We don't handle `auto` because the intention is for the native implementation
               * to be hidden if using this component. We just want to ensure the node is scrollable
               * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
               * the browser from having to work out whether to render native scrollbars or not,
               * we tell it to with the intention of hiding them in CSS.
               */
              overflowX: l.scrollbarXEnabled ? "scroll" : "hidden",
              overflowY: l.scrollbarYEnabled ? "scroll" : "hidden",
              ...e.style
            },
            children: H4({ asChild: a, children: n }, (f) => /* @__PURE__ */ j(
              "div",
              {
                "data-radix-scroll-area-content": "",
                ref: l.onContentChange,
                style: { minWidth: l.scrollbarXEnabled ? "fit-content" : void 0 },
                children: f
              }
            ))
          }
        )
      ] });
    }
  );
  _s.displayName = Ds;
  nt = "ScrollAreaScrollbar", Fs = I.forwardRef(
    (e, t) => {
      let { forceMount: r, ...n } = e, a = We(nt, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: c } = a, l = e.
      orientation === "horizontal";
      return I.useEffect(() => (l ? i(!0) : c(!0), () => {
        l ? i(!1) : c(!1);
      }), [l, i, c]), a.type === "hover" ? /* @__PURE__ */ j(b4, { ...n, ref: t, forceMount: r }) : a.type === "scroll" ? /* @__PURE__ */ j(
      y4, { ...n, ref: t, forceMount: r }) : a.type === "auto" ? /* @__PURE__ */ j(Vs, { ...n, ref: t, forceMount: r }) : a.type === "always" ?
      /* @__PURE__ */ j(ba, { ...n, ref: t }) : null;
    }
  );
  Fs.displayName = nt;
  b4 = I.forwardRef((e, t) => {
    let { forceMount: r, ...n } = e, a = We(nt, e.__scopeScrollArea), [i, c] = I.useState(!1);
    return I.useEffect(() => {
      let l = a.scrollArea, s = 0;
      if (l) {
        let u = /* @__PURE__ */ o(() => {
          window.clearTimeout(s), c(!0);
        }, "handlePointerEnter"), f = /* @__PURE__ */ o(() => {
          s = window.setTimeout(() => c(!1), a.scrollHideDelay);
        }, "handlePointerLeave");
        return l.addEventListener("pointerenter", u), l.addEventListener("pointerleave", f), () => {
          window.clearTimeout(s), l.removeEventListener("pointerenter", u), l.removeEventListener("pointerleave", f);
        };
      }
    }, [a.scrollArea, a.scrollHideDelay]), /* @__PURE__ */ j(ir, { present: r || i, children: /* @__PURE__ */ j(
      Vs,
      {
        "data-state": i ? "visible" : "hidden",
        ...n,
        ref: t
      }
    ) });
  }), y4 = I.forwardRef((e, t) => {
    let { forceMount: r, ...n } = e, a = We(nt, e.__scopeScrollArea), i = e.orientation === "horizontal", c = Pn(() => s("SCROLL_END"), 100),
    [l, s] = g4("hidden", {
      hidden: {
        SCROLL: "scrolling"
      },
      scrolling: {
        SCROLL_END: "idle",
        POINTER_ENTER: "interacting"
      },
      interacting: {
        SCROLL: "interacting",
        POINTER_LEAVE: "idle"
      },
      idle: {
        HIDE: "hidden",
        SCROLL: "scrolling",
        POINTER_ENTER: "interacting"
      }
    });
    return I.useEffect(() => {
      if (l === "idle") {
        let u = window.setTimeout(() => s("HIDE"), a.scrollHideDelay);
        return () => window.clearTimeout(u);
      }
    }, [l, a.scrollHideDelay, s]), I.useEffect(() => {
      let u = a.viewport, f = i ? "scrollLeft" : "scrollTop";
      if (u) {
        let d = u[f], m = /* @__PURE__ */ o(() => {
          let g = u[f];
          d !== g && (s("SCROLL"), c()), d = g;
        }, "handleScroll");
        return u.addEventListener("scroll", m), () => u.removeEventListener("scroll", m);
      }
    }, [a.viewport, i, s, c]), /* @__PURE__ */ j(ir, { present: r || l !== "hidden", children: /* @__PURE__ */ j(
      ba,
      {
        "data-state": l === "hidden" ? "hidden" : "visible",
        ...n,
        ref: t,
        onPointerEnter: de(e.onPointerEnter, () => s("POINTER_ENTER")),
        onPointerLeave: de(e.onPointerLeave, () => s("POINTER_LEAVE"))
      }
    ) });
  }), Vs = I.forwardRef((e, t) => {
    let r = We(nt, e.__scopeScrollArea), { forceMount: n, ...a } = e, [i, c] = I.useState(!1), l = e.orientation === "horizontal", s = Pn(() => {
      if (r.viewport) {
        let u = r.viewport.offsetWidth < r.viewport.scrollWidth, f = r.viewport.offsetHeight < r.viewport.scrollHeight;
        c(l ? u : f);
      }
    }, 10);
    return sr(r.viewport, s), sr(r.content, s), /* @__PURE__ */ j(ir, { present: n || i, children: /* @__PURE__ */ j(
      ba,
      {
        "data-state": i ? "visible" : "hidden",
        ...a,
        ref: t
      }
    ) });
  }), ba = I.forwardRef((e, t) => {
    let { orientation: r = "vertical", ...n } = e, a = We(nt, e.__scopeScrollArea), i = I.useRef(null), c = I.useRef(0), [l, s] = I.useState(
    {
      content: 0,
      viewport: 0,
      scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
    }), u = qs(l.viewport, l.content), f = {
      ...n,
      sizes: l,
      onSizesChange: s,
      hasThumb: u > 0 && u < 1,
      onThumbChange: /* @__PURE__ */ o((m) => i.current = m, "onThumbChange"),
      onThumbPointerUp: /* @__PURE__ */ o(() => c.current = 0, "onThumbPointerUp"),
      onThumbPointerDown: /* @__PURE__ */ o((m) => c.current = m, "onThumbPointerDown")
    };
    function d(m, g) {
      return A4(m, c.current, l, g);
    }
    return o(d, "getScrollPosition"), r === "horizontal" ? /* @__PURE__ */ j(
      E4,
      {
        ...f,
        ref: t,
        onThumbPositionChange: /* @__PURE__ */ o(() => {
          if (a.viewport && i.current) {
            let m = a.viewport.scrollLeft, g = ks(m, l, a.dir);
            i.current.style.transform = `translate3d(${g}px, 0, 0)`;
          }
        }, "onThumbPositionChange"),
        onWheelScroll: /* @__PURE__ */ o((m) => {
          a.viewport && (a.viewport.scrollLeft = m);
        }, "onWheelScroll"),
        onDragScroll: /* @__PURE__ */ o((m) => {
          a.viewport && (a.viewport.scrollLeft = d(m, a.dir));
        }, "onDragScroll")
      }
    ) : r === "vertical" ? /* @__PURE__ */ j(
      C4,
      {
        ...f,
        ref: t,
        onThumbPositionChange: /* @__PURE__ */ o(() => {
          if (a.viewport && i.current) {
            let m = a.viewport.scrollTop, g = ks(m, l);
            i.current.style.transform = `translate3d(0, ${g}px, 0)`;
          }
        }, "onThumbPositionChange"),
        onWheelScroll: /* @__PURE__ */ o((m) => {
          a.viewport && (a.viewport.scrollTop = m);
        }, "onWheelScroll"),
        onDragScroll: /* @__PURE__ */ o((m) => {
          a.viewport && (a.viewport.scrollTop = d(m));
        }, "onDragScroll")
      }
    ) : null;
  }), E4 = I.forwardRef((e, t) => {
    let { sizes: r, onSizesChange: n, ...a } = e, i = We(nt, e.__scopeScrollArea), [c, l] = I.useState(), s = I.useRef(null), u = oe(t, s, i.
    onScrollbarXChange);
    return I.useEffect(() => {
      s.current && l(getComputedStyle(s.current));
    }, [s]), /* @__PURE__ */ j(
      $s,
      {
        "data-orientation": "horizontal",
        ...a,
        ref: u,
        sizes: r,
        style: {
          bottom: 0,
          left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
          right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
          "--radix-scroll-area-thumb-width": zn(r) + "px",
          ...e.style
        },
        onThumbPointerDown: /* @__PURE__ */ o((f) => e.onThumbPointerDown(f.x), "onThumbPointerDown"),
        onDragScroll: /* @__PURE__ */ o((f) => e.onDragScroll(f.x), "onDragScroll"),
        onWheelScroll: /* @__PURE__ */ o((f, d) => {
          if (i.viewport) {
            let m = i.viewport.scrollLeft + f.deltaX;
            e.onWheelScroll(m), Xs(m, d) && f.preventDefault();
          }
        }, "onWheelScroll"),
        onResize: /* @__PURE__ */ o(() => {
          s.current && i.viewport && c && n({
            content: i.viewport.scrollWidth,
            viewport: i.viewport.offsetWidth,
            scrollbar: {
              size: s.current.clientWidth,
              paddingStart: Tn(c.paddingLeft),
              paddingEnd: Tn(c.paddingRight)
            }
          });
        }, "onResize")
      }
    );
  }), C4 = I.forwardRef((e, t) => {
    let { sizes: r, onSizesChange: n, ...a } = e, i = We(nt, e.__scopeScrollArea), [c, l] = I.useState(), s = I.useRef(null), u = oe(t, s, i.
    onScrollbarYChange);
    return I.useEffect(() => {
      s.current && l(getComputedStyle(s.current));
    }, [s]), /* @__PURE__ */ j(
      $s,
      {
        "data-orientation": "vertical",
        ...a,
        ref: u,
        sizes: r,
        style: {
          top: 0,
          right: i.dir === "ltr" ? 0 : void 0,
          left: i.dir === "rtl" ? 0 : void 0,
          bottom: "var(--radix-scroll-area-corner-height)",
          "--radix-scroll-area-thumb-height": zn(r) + "px",
          ...e.style
        },
        onThumbPointerDown: /* @__PURE__ */ o((f) => e.onThumbPointerDown(f.y), "onThumbPointerDown"),
        onDragScroll: /* @__PURE__ */ o((f) => e.onDragScroll(f.y), "onDragScroll"),
        onWheelScroll: /* @__PURE__ */ o((f, d) => {
          if (i.viewport) {
            let m = i.viewport.scrollTop + f.deltaY;
            e.onWheelScroll(m), Xs(m, d) && f.preventDefault();
          }
        }, "onWheelScroll"),
        onResize: /* @__PURE__ */ o(() => {
          s.current && i.viewport && c && n({
            content: i.viewport.scrollHeight,
            viewport: i.viewport.offsetHeight,
            scrollbar: {
              size: s.current.clientHeight,
              paddingStart: Tn(c.paddingTop),
              paddingEnd: Tn(c.paddingBottom)
            }
          });
        }, "onResize")
      }
    );
  }), [S4, Ws] = Os(nt), $s = I.forwardRef((e, t) => {
    let {
      __scopeScrollArea: r,
      sizes: n,
      hasThumb: a,
      onThumbChange: i,
      onThumbPointerUp: c,
      onThumbPointerDown: l,
      onThumbPositionChange: s,
      onDragScroll: u,
      onWheelScroll: f,
      onResize: d,
      ...m
    } = e, g = We(nt, r), [x, p] = I.useState(null), h = oe(t, (M) => p(M)), v = I.useRef(null), w = I.useRef(""), R = g.viewport, y = n.content -
    n.viewport, E = le(f), b = le(s), C = Pn(d, 10);
    function L(M) {
      if (v.current) {
        let A = M.clientX - v.current.left, P = M.clientY - v.current.top;
        u({ x: A, y: P });
      }
    }
    return o(L, "handleDragScroll"), I.useEffect(() => {
      let M = /* @__PURE__ */ o((A) => {
        let P = A.target;
        x?.contains(P) && E(A, y);
      }, "handleWheel");
      return document.addEventListener("wheel", M, { passive: !1 }), () => document.removeEventListener("wheel", M, { passive: !1 });
    }, [R, x, y, E]), I.useEffect(b, [n, b]), sr(x, C), sr(g.content, C), /* @__PURE__ */ j(
      S4,
      {
        scope: r,
        scrollbar: x,
        hasThumb: a,
        onThumbChange: le(i),
        onThumbPointerUp: le(c),
        onThumbPositionChange: b,
        onThumbPointerDown: le(l),
        children: /* @__PURE__ */ j(
          ie.div,
          {
            ...m,
            ref: h,
            style: { position: "absolute", ...m.style },
            onPointerDown: de(e.onPointerDown, (M) => {
              M.button === 0 && (M.target.setPointerCapture(M.pointerId), v.current = x.getBoundingClientRect(), w.current = document.body.style.
              webkitUserSelect, document.body.style.webkitUserSelect = "none", g.viewport && (g.viewport.style.scrollBehavior = "auto"), L(M));
            }),
            onPointerMove: de(e.onPointerMove, L),
            onPointerUp: de(e.onPointerUp, (M) => {
              let A = M.target;
              A.hasPointerCapture(M.pointerId) && A.releasePointerCapture(M.pointerId), document.body.style.webkitUserSelect = w.current, g.
              viewport && (g.viewport.style.scrollBehavior = ""), v.current = null;
            })
          }
        )
      }
    );
  }), Hn = "ScrollAreaThumb", js = I.forwardRef(
    (e, t) => {
      let { forceMount: r, ...n } = e, a = Ws(Hn, e.__scopeScrollArea);
      return /* @__PURE__ */ j(ir, { present: r || a.hasThumb, children: /* @__PURE__ */ j(M4, { ref: t, ...n }) });
    }
  ), M4 = I.forwardRef(
    (e, t) => {
      let { __scopeScrollArea: r, style: n, ...a } = e, i = We(Hn, r), c = Ws(Hn, r), { onThumbPositionChange: l } = c, s = oe(
        t,
        (d) => c.onThumbChange(d)
      ), u = I.useRef(), f = Pn(() => {
        u.current && (u.current(), u.current = void 0);
      }, 100);
      return I.useEffect(() => {
        let d = i.viewport;
        if (d) {
          let m = /* @__PURE__ */ o(() => {
            if (f(), !u.current) {
              let g = I4(d, l);
              u.current = g, l();
            }
          }, "handleScroll");
          return l(), d.addEventListener("scroll", m), () => d.removeEventListener("scroll", m);
        }
      }, [i.viewport, f, l]), /* @__PURE__ */ j(
        ie.div,
        {
          "data-state": c.hasThumb ? "visible" : "hidden",
          ...a,
          ref: s,
          style: {
            width: "var(--radix-scroll-area-thumb-width)",
            height: "var(--radix-scroll-area-thumb-height)",
            ...n
          },
          onPointerDownCapture: de(e.onPointerDownCapture, (d) => {
            let g = d.target.getBoundingClientRect(), x = d.clientX - g.left, p = d.clientY - g.top;
            c.onThumbPointerDown({ x, y: p });
          }),
          onPointerUp: de(e.onPointerUp, c.onThumbPointerUp)
        }
      );
    }
  );
  js.displayName = Hn;
  ya = "ScrollAreaCorner", Us = I.forwardRef(
    (e, t) => {
      let r = We(ya, e.__scopeScrollArea), n = !!(r.scrollbarX && r.scrollbarY);
      return r.type !== "scroll" && n ? /* @__PURE__ */ j(L4, { ...e, ref: t }) : null;
    }
  );
  Us.displayName = ya;
  L4 = I.forwardRef((e, t) => {
    let { __scopeScrollArea: r, ...n } = e, a = We(ya, r), [i, c] = I.useState(0), [l, s] = I.useState(0), u = !!(i && l);
    return sr(a.scrollbarX, () => {
      let f = a.scrollbarX?.offsetHeight || 0;
      a.onCornerHeightChange(f), s(f);
    }), sr(a.scrollbarY, () => {
      let f = a.scrollbarY?.offsetWidth || 0;
      a.onCornerWidthChange(f), c(f);
    }), u ? /* @__PURE__ */ j(
      ie.div,
      {
        ...n,
        ref: t,
        style: {
          width: i,
          height: l,
          position: "absolute",
          right: a.dir === "ltr" ? 0 : void 0,
          left: a.dir === "rtl" ? 0 : void 0,
          bottom: 0,
          ...e.style
        }
      }
    ) : null;
  });
  o(Tn, "toInt");
  o(qs, "getThumbRatio");
  o(zn, "getThumbSize");
  o(A4, "getScrollPositionFromPointer");
  o(ks, "getThumbOffsetFromScroll");
  o(Gs, "linearScale");
  o(Xs, "isScrollingWithinScrollbarBounds");
  I4 = /* @__PURE__ */ o((e, t = () => {
  }) => {
    let r = { left: e.scrollLeft, top: e.scrollTop }, n = 0;
    return (/* @__PURE__ */ o(function a() {
      let i = { left: e.scrollLeft, top: e.scrollTop }, c = r.left !== i.left, l = r.top !== i.top;
      (c || l) && t(), r = i, n = window.requestAnimationFrame(a);
    }, "loop"))(), () => window.cancelAnimationFrame(n);
  }, "addUnlinkedScrollListener");
  o(Pn, "useDebounceCallback");
  o(sr, "useResizeObserver");
  o(H4, "getSubtree");
  Zs = Ns, Ys = _s, Ks = Fs, Js = js, Qs = Us;
});

// src/components/components/ScrollArea/ScrollArea.tsx
import kt, { forwardRef as z4 } from "react";
import { styled as kn } from "storybook/theming";
var P4, k4, t5, r5, ur, Bn = S(() => {
  "use strict";
  e5();
  P4 = kn(Zs)(
    ({ scrollbarsize: e, offset: t }) => ({
      width: "100%",
      height: "100%",
      overflow: "hidden",
      "--scrollbar-size": `${e + t}px`,
      "--radix-scroll-area-thumb-width": `${e}px`
    })
  ), k4 = kn(Ys)({
    width: "100%",
    height: "100%"
  }), t5 = kn(Ks)(({ offset: e, horizontal: t, vertical: r }) => ({
    display: "flex",
    userSelect: "none",
    // ensures no selection
    touchAction: "none",
    // disable browser handling of all panning and zooming gestures on touch devices
    background: "transparent",
    transition: "all 0.2s ease-out",
    borderRadius: "var(--scrollbar-size)",
    zIndex: 1,
    '&[data-orientation="vertical"]': {
      width: "var(--scrollbar-size)",
      paddingRight: e,
      marginTop: e,
      marginBottom: t === "true" && r === "true" ? 0 : e
    },
    '&[data-orientation="horizontal"]': {
      flexDirection: "column",
      height: "var(--scrollbar-size)",
      paddingBottom: e,
      marginLeft: e,
      marginRight: t === "true" && r === "true" ? 0 : e
    }
  })), r5 = kn(Js)(({ theme: e }) => ({
    flex: 1,
    background: e.textMutedColor,
    opacity: 0.5,
    borderRadius: "var(--scrollbar-size)",
    position: "relative",
    transition: "opacity 0.2s ease-out",
    "&:hover": { opacity: 0.8 },
    /* increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html */
    "::before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      width: "100%",
      height: "100%"
    }
  })), ur = z4(
    ({ children: e, horizontal: t = !1, vertical: r = !1, offset: n = 2, scrollbarSize: a = 6, className: i }, c) => /* @__PURE__ */ kt.createElement(
    P4, { scrollbarsize: a, offset: n, className: i }, /* @__PURE__ */ kt.createElement(k4, { ref: c }, e), t && /* @__PURE__ */ kt.createElement(
      t5,
      {
        orientation: "horizontal",
        offset: n,
        horizontal: t.toString(),
        vertical: r.toString()
      },
      /* @__PURE__ */ kt.createElement(r5, null)
    ), r && /* @__PURE__ */ kt.createElement(
      t5,
      {
        orientation: "vertical",
        offset: n,
        horizontal: t.toString(),
        vertical: r.toString()
      },
      /* @__PURE__ */ kt.createElement(r5, null)
    ), t && r && /* @__PURE__ */ kt.createElement(Qs, null))
  );
  ur.displayName = "ScrollArea";
});

// src/components/components/syntaxhighlighter/syntaxhighlighter.tsx
var Ca = {};
Nr(Ca, {
  SyntaxHighlighter: () => Gr,
  createCopyToClipboardFunction: () => Ea,
  default: () => Z4,
  supportedLanguages: () => i5
});
import qr, { useCallback as B4, useEffect as O4, useState as n5 } from "react";
import { logger as N4 } from "storybook/internal/client-logger";
import { global as D4 } from "@storybook/global";
import { styled as On } from "storybook/theming";
function Ea() {
  return o5?.clipboard ? (e) => o5.clipboard.writeText(e) : async (e) => {
    let t = Ur.createElement("TEXTAREA"), r = Ur.activeElement;
    t.value = e, Ur.body.appendChild(t), t.select(), Ur.execCommand("copy"), Ur.body.removeChild(t), r.focus();
  };
}
var a5, o5, Ur, _4, i5, F4, V4, W4, $4, j4, U4, q4, l5, G4, X4, Gr, Z4, Xr = S(() => {
  "use strict";
  a5 = ve(Dr(), 1);
  x1();
  S1();
  A1();
  P1();
  D1();
  $1();
  G1();
  J1();
  ts();
  ls();
  us();
  hs();
  R1();
  va();
  Bn();
  ({ navigator: o5, document: Ur, window: _4 } = D4), i5 = {
    jsextra: N1,
    jsx: q1,
    json: W1,
    yml: ms,
    md: K1,
    bash: C1,
    css: L1,
    html: es,
    tsx: is,
    typescript: ss,
    graphql: z1
  };
  Object.entries(i5).forEach(([e, t]) => {
    Mn.registerLanguage(e, t);
  });
  F4 = (0, a5.default)(2)(
    (e) => Object.entries(e.code || {}).reduce((t, [r, n]) => ({ ...t, [`* .${r}`]: n }), {})
  ), V4 = Ea();
  o(Ea, "createCopyToClipboardFunction");
  W4 = On.div(
    ({ theme: e }) => ({
      position: "relative",
      overflow: "hidden",
      color: e.color.defaultText
    }),
    ({ theme: e, bordered: t }) => t ? {
      border: `1px solid ${e.appBorderColor}`,
      borderRadius: e.borderRadius,
      background: e.background.content
    } : {},
    ({ showLineNumbers: e }) => e ? {
      // use the before pseudo element to display line numbers
      ".react-syntax-highlighter-line-number::before": {
        content: "attr(data-line-number)"
      }
    } : {}
  ), $4 = /* @__PURE__ */ o(({ children: e, className: t }) => /* @__PURE__ */ qr.createElement(ur, { horizontal: !0, vertical: !0, className: t },
  e), "UnstyledScroller"), j4 = On($4)(
    {
      position: "relative"
    },
    ({ theme: e }) => F4(e)
  ), U4 = On.pre(({ theme: e, padded: t }) => ({
    display: "flex",
    justifyContent: "flex-start",
    margin: 0,
    padding: t ? e.layoutMargin : 0
  })), q4 = On.div(({ theme: e }) => ({
    flex: 1,
    paddingLeft: 2,
    // TODO: To match theming/global.ts for now
    paddingRight: e.layoutMargin,
    opacity: 1,
    fontFamily: e.typography.fonts.mono
  })), l5 = /* @__PURE__ */ o((e) => {
    let t = [...e.children], r = t[0], n = r.children[0].value, a = {
      ...r,
      // empty the line-number element
      children: [],
      properties: {
        ...r.properties,
        // add a data-line-number attribute to line-number element, so we can access the line number with `content: attr(data-line-number)`
        "data-line-number": n,
        // remove the 'userSelect: none' style, which will produce extra empty lines when copy-pasting in firefox
        style: { ...r.properties.style, userSelect: "auto" }
      }
    };
    return t[0] = a, { ...e, children: t };
  }, "processLineNumber"), G4 = /* @__PURE__ */ o(({ rows: e, stylesheet: t, useInlineStyles: r }) => e.map((n, a) => Ht({
    node: l5(n),
    stylesheet: t,
    useInlineStyles: r,
    key: `code-segement${a}`
  })), "defaultRenderer"), X4 = /* @__PURE__ */ o((e, t) => t ? e ? ({ rows: r, ...n }) => e({ rows: r.map((a) => l5(a)), ...n }) : G4 : e, "\
wrapRenderer"), Gr = /* @__PURE__ */ o(({
    children: e,
    language: t = "jsx",
    copyable: r = !1,
    bordered: n = !1,
    padded: a = !1,
    format: i = !0,
    formatter: c = void 0,
    className: l = void 0,
    showLineNumbers: s = !1,
    ...u
  }) => {
    if (typeof e != "string" || !e.trim())
      return null;
    let [f, d] = n5("");
    O4(() => {
      c ? c(i, e).then(d) : d(e.trim());
    }, [e, i, c]);
    let [m, g] = n5(!1), x = B4(
      (h) => {
        h.preventDefault(), V4(f).then(() => {
          g(!0), _4.setTimeout(() => g(!1), 1500);
        }).catch(N4.error);
      },
      [f]
    ), p = X4(u.renderer, s);
    return /* @__PURE__ */ qr.createElement(
      W4,
      {
        bordered: n,
        padded: a,
        showLineNumbers: s,
        className: l
      },
      /* @__PURE__ */ qr.createElement(j4, null, /* @__PURE__ */ qr.createElement(
        Mn,
        {
          padded: a || n,
          language: t,
          showLineNumbers: s,
          showInlineLineNumbers: s,
          useInlineStyles: !1,
          PreTag: U4,
          CodeTag: q4,
          lineNumberContainerStyle: {},
          ...u,
          renderer: p
        },
        f
      )),
      r ? /* @__PURE__ */ qr.createElement(ha, { actionItems: [{ title: m ? "Copied" : "Copy", onClick: x }] }) : null
    );
  }, "SyntaxHighlighter");
  Gr.registerLanguage = (...e) => Mn.registerLanguage(...e);
  Z4 = Gr;
});

// ../node_modules/ts-dedent/esm/index.js
function h5(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  var n = Array.from(typeof e == "string" ? [e] : e);
  n[n.length - 1] = n[n.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var a = n.reduce(function(l, s) {
    var u = s.match(/\n([\t ]+|(?!\s).)/g);
    return u ? l.concat(u.map(function(f) {
      var d, m;
      return (m = (d = f.match(/[\t ]/g)) === null || d === void 0 ? void 0 : d.length) !== null && m !== void 0 ? m : 0;
    })) : l;
  }, []);
  if (a.length) {
    var i = new RegExp(`
[	 ]{` + Math.min.apply(Math, a) + "}", "g");
    n = n.map(function(l) {
      return l.replace(i, `
`);
    });
  }
  n[0] = n[0].replace(/^\r?\n/, "");
  var c = n[0];
  return t.forEach(function(l, s) {
    var u = c.match(/(?:^|\n)( *)$/), f = u ? u[1] : "", d = l;
    typeof l == "string" && l.includes(`
`) && (d = String(l).split(`
`).map(function(m, g) {
      return g === 0 ? m : "" + f + m;
    }).join(`
`)), c += d + n[s + 1];
  }), c;
}
var v5 = S(() => {
  o(h5, "dedent");
});

// src/components/components/syntaxhighlighter/formatter.ts
var w5 = {};
Nr(w5, {
  formatter: () => zm
});
var g5, zm, R5 = S(() => {
  "use strict";
  g5 = ve(Dr(), 1);
  v5();
  zm = (0, g5.default)(2)(async (e, t) => e === !1 ? t : h5(t));
});

// ../node_modules/react-popper/lib/esm/utils.js
import * as to from "react";
var n0, o0, Ju = S(() => {
  n0 = /* @__PURE__ */ o(function(t) {
    return t.reduce(function(r, n) {
      var a = n[0], i = n[1];
      return r[a] = i, r;
    }, {});
  }, "fromEntries"), o0 = typeof window < "u" && window.document && window.document.createElement ? to.useLayoutEffect : to.useEffect;
});

// ../node_modules/@popperjs/core/lib/enums.js
var ee, se, ae, re, ro, xt, ut, Vt, Qu, no, xr, ef, a0, oo, hg, vg, gg, wg, Rg, xg, bg, yg, Eg, tf, Be = S(() => {
  ee = "top", se = "bottom", ae = "right", re = "left", ro = "auto", xt = [ee, se, ae, re], ut = "start", Vt = "end", Qu = "clippingParents",
  no = "viewport", xr = "popper", ef = "reference", a0 = /* @__PURE__ */ xt.reduce(function(e, t) {
    return e.concat([t + "-" + ut, t + "-" + Vt]);
  }, []), oo = /* @__PURE__ */ [].concat(xt, [ro]).reduce(function(e, t) {
    return e.concat([t, t + "-" + ut, t + "-" + Vt]);
  }, []), hg = "beforeRead", vg = "read", gg = "afterRead", wg = "beforeMain", Rg = "main", xg = "afterMain", bg = "beforeWrite", yg = "writ\
e", Eg = "afterWrite", tf = [hg, vg, gg, wg, Rg, xg, bg, yg, Eg];
});

// ../node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function pe(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
var bt = S(() => {
  o(pe, "getNodeName");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function Z(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
var Je = S(() => {
  o(Z, "getWindow");
});

// ../node_modules/@popperjs/core/lib/dom-utils/instanceOf.js
function Ue(e) {
  var t = Z(e).Element;
  return e instanceof t || e instanceof Element;
}
function ue(e) {
  var t = Z(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function br(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Z(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
var Oe = S(() => {
  Je();
  o(Ue, "isElement");
  o(ue, "isHTMLElement");
  o(br, "isShadowRoot");
});

// ../node_modules/@popperjs/core/lib/modifiers/applyStyles.js
function Cg(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, i = t.elements[r];
    !ue(i) || !pe(i) || (Object.assign(i.style, n), Object.keys(a).forEach(function(c) {
      var l = a[c];
      l === !1 ? i.removeAttribute(c) : i.setAttribute(c, l === !0 ? "" : l);
    }));
  });
}
function Sg(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow),
  function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], i = t.attributes[n] || {}, c = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), l = c.reduce(function(s, u) {
        return s[u] = "", s;
      }, {});
      !ue(a) || !pe(a) || (Object.assign(a.style, l), Object.keys(i).forEach(function(s) {
        a.removeAttribute(s);
      }));
    });
  };
}
var rf, nf = S(() => {
  bt();
  Oe();
  o(Cg, "applyStyles");
  o(Sg, "effect");
  rf = {
    name: "applyStyles",
    enabled: !0,
    phase: "write",
    fn: Cg,
    effect: Sg,
    requires: ["computeStyles"]
  };
});

// ../node_modules/@popperjs/core/lib/utils/getBasePlacement.js
function me(e) {
  return e.split("-")[0];
}
var yt = S(() => {
  o(me, "getBasePlacement");
});

// ../node_modules/@popperjs/core/lib/utils/math.js
var Qe, Wt, ft, Et = S(() => {
  Qe = Math.max, Wt = Math.min, ft = Math.round;
});

// ../node_modules/@popperjs/core/lib/utils/userAgent.js
function yr() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
var i0 = S(() => {
  o(yr, "getUAString");
});

// ../node_modules/@popperjs/core/lib/dom-utils/isLayoutViewport.js
function en() {
  return !/^((?!chrome|android).)*safari/i.test(yr());
}
var l0 = S(() => {
  i0();
  o(en, "isLayoutViewport");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js
function qe(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, i = 1;
  t && ue(e) && (a = e.offsetWidth > 0 && ft(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && ft(n.height) / e.offsetHeight || 1);
  var c = Ue(e) ? Z(e) : window, l = c.visualViewport, s = !en() && r, u = (n.left + (s && l ? l.offsetLeft : 0)) / a, f = (n.top + (s && l ?
  l.offsetTop : 0)) / i, d = n.width / a, m = n.height / i;
  return {
    width: d,
    height: m,
    top: f,
    right: u + d,
    bottom: f + m,
    left: u,
    x: u,
    y: f
  };
}
var Er = S(() => {
  Oe();
  Et();
  Je();
  l0();
  o(qe, "getBoundingClientRect");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
function $t(e) {
  var t = qe(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
var ao = S(() => {
  Er();
  o($t, "getLayoutRect");
});

// ../node_modules/@popperjs/core/lib/dom-utils/contains.js
function tn(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && br(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
var c0 = S(() => {
  Oe();
  o(tn, "contains");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js
function Ce(e) {
  return Z(e).getComputedStyle(e);
}
var Cr = S(() => {
  Je();
  o(Ce, "getComputedStyle");
});

// ../node_modules/@popperjs/core/lib/dom-utils/isTableElement.js
function s0(e) {
  return ["table", "td", "th"].indexOf(pe(e)) >= 0;
}
var of = S(() => {
  bt();
  o(s0, "isTableElement");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js
function Re(e) {
  return ((Ue(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
var dt = S(() => {
  Oe();
  o(Re, "getDocumentElement");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getParentNode.js
function pt(e) {
  return pe(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (br(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Re(e)
  );
}
var rn = S(() => {
  bt();
  dt();
  Oe();
  o(pt, "getParentNode");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js
function af(e) {
  return !ue(e) || // https://github.com/popperjs/popper-core/issues/837
  Ce(e).position === "fixed" ? null : e.offsetParent;
}
function Mg(e) {
  var t = /firefox/i.test(yr()), r = /Trident/i.test(yr());
  if (r && ue(e)) {
    var n = Ce(e);
    if (n.position === "fixed")
      return null;
  }
  var a = pt(e);
  for (br(a) && (a = a.host); ue(a) && ["html", "body"].indexOf(pe(a)) < 0; ) {
    var i = Ce(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !==
    -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function et(e) {
  for (var t = Z(e), r = af(e); r && s0(r) && Ce(r).position === "static"; )
    r = af(r);
  return r && (pe(r) === "html" || pe(r) === "body" && Ce(r).position === "static") ? t : r || Mg(e) || t;
}
var Sr = S(() => {
  Je();
  bt();
  Cr();
  Oe();
  of();
  rn();
  i0();
  o(af, "getTrueOffsetParent");
  o(Mg, "getContainingBlock");
  o(et, "getOffsetParent");
});

// ../node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function jt(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
var io = S(() => {
  o(jt, "getMainAxisFromPlacement");
});

// ../node_modules/@popperjs/core/lib/utils/within.js
function Ut(e, t, r) {
  return Qe(e, Wt(t, r));
}
function lf(e, t, r) {
  var n = Ut(e, t, r);
  return n > r ? r : n;
}
var u0 = S(() => {
  Et();
  o(Ut, "within");
  o(lf, "withinMaxClamp");
});

// ../node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function nn() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
var f0 = S(() => {
  o(nn, "getFreshSideObject");
});

// ../node_modules/@popperjs/core/lib/utils/mergePaddingObject.js
function on(e) {
  return Object.assign({}, nn(), e);
}
var d0 = S(() => {
  f0();
  o(on, "mergePaddingObject");
});

// ../node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function an(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var p0 = S(() => {
  o(an, "expandToHashMap");
});

// ../node_modules/@popperjs/core/lib/modifiers/arrow.js
function Ag(e) {
  var t, r = e.state, n = e.name, a = e.options, i = r.elements.arrow, c = r.modifiersData.popperOffsets, l = me(r.placement), s = jt(l), u = [
  re, ae].indexOf(l) >= 0, f = u ? "height" : "width";
  if (!(!i || !c)) {
    var d = Lg(a.padding, r), m = $t(i), g = s === "y" ? ee : re, x = s === "y" ? se : ae, p = r.rects.reference[f] + r.rects.reference[s] -
    c[s] - r.rects.popper[f], h = c[s] - r.rects.reference[s], v = et(i), w = v ? s === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, R = p /
    2 - h / 2, y = d[g], E = w - m[f] - d[x], b = w / 2 - m[f] / 2 + R, C = Ut(y, b, E), L = s;
    r.modifiersData[n] = (t = {}, t[L] = C, t.centerOffset = C - b, t);
  }
}
function Ig(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  a != null && (typeof a == "string" && (a = t.elements.popper.querySelector(a), !a) || tn(t.elements.popper, a) && (t.elements.arrow = a));
}
var Lg, cf, sf = S(() => {
  yt();
  ao();
  c0();
  Sr();
  io();
  u0();
  d0();
  p0();
  Be();
  Lg = /* @__PURE__ */ o(function(t, r) {
    return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
      placement: r.placement
    })) : t, on(typeof t != "number" ? t : an(t, xt));
  }, "toPaddingObject");
  o(Ag, "arrow");
  o(Ig, "effect");
  cf = {
    name: "arrow",
    enabled: !0,
    phase: "main",
    fn: Ag,
    effect: Ig,
    requires: ["popperOffsets"],
    requiresIfExists: ["preventOverflow"]
  };
});

// ../node_modules/@popperjs/core/lib/utils/getVariation.js
function Ge(e) {
  return e.split("-")[1];
}
var Mr = S(() => {
  o(Ge, "getVariation");
});

// ../node_modules/@popperjs/core/lib/modifiers/computeStyles.js
function Tg(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: ft(r * a) / a || 0,
    y: ft(n * a) / a || 0
  };
}
function uf(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, i = e.variation, c = e.offsets, l = e.position, s = e.gpuAcceleration, u = e.adaptive,
  f = e.roundOffsets, d = e.isFixed, m = c.x, g = m === void 0 ? 0 : m, x = c.y, p = x === void 0 ? 0 : x, h = typeof f == "function" ? f({
    x: g,
    y: p
  }) : {
    x: g,
    y: p
  };
  g = h.x, p = h.y;
  var v = c.hasOwnProperty("x"), w = c.hasOwnProperty("y"), R = re, y = ee, E = window;
  if (u) {
    var b = et(r), C = "clientHeight", L = "clientWidth";
    if (b === Z(r) && (b = Re(r), Ce(b).position !== "static" && l === "absolute" && (C = "scrollHeight", L = "scrollWidth")), b = b, a === ee ||
    (a === re || a === ae) && i === Vt) {
      y = se;
      var M = d && b === E && E.visualViewport ? E.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        b[C]
      );
      p -= M - n.height, p *= s ? 1 : -1;
    }
    if (a === re || (a === ee || a === se) && i === Vt) {
      R = ae;
      var A = d && b === E && E.visualViewport ? E.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        b[L]
      );
      g -= A - n.width, g *= s ? 1 : -1;
    }
  }
  var P = Object.assign({
    position: l
  }, u && Hg), F = f === !0 ? Tg({
    x: g,
    y: p
  }, Z(r)) : {
    x: g,
    y: p
  };
  if (g = F.x, p = F.y, s) {
    var _;
    return Object.assign({}, P, (_ = {}, _[y] = w ? "0" : "", _[R] = v ? "0" : "", _.transform = (E.devicePixelRatio || 1) <= 1 ? "translate\
(" + g + "px, " + p + "px)" : "translate3d(" + g + "px, " + p + "px, 0)", _));
  }
  return Object.assign({}, P, (t = {}, t[y] = w ? p + "px" : "", t[R] = v ? g + "px" : "", t.transform = "", t));
}
function zg(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, i = r.adaptive, c = i === void 0 ? !0 : i, l = r.roundOffsets,
  s = l === void 0 ? !0 : l, u = {
    placement: me(t.placement),
    variation: Ge(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, uf(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: c,
    roundOffsets: s
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, uf(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: s
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var Hg, ff, df = S(() => {
  Be();
  Sr();
  Je();
  dt();
  Cr();
  yt();
  Mr();
  Et();
  Hg = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
  };
  o(Tg, "roundOffsetsByDPR");
  o(uf, "mapToStyles");
  o(zg, "computeStyles");
  ff = {
    name: "computeStyles",
    enabled: !0,
    phase: "beforeWrite",
    fn: zg,
    data: {}
  };
});

// ../node_modules/@popperjs/core/lib/modifiers/eventListeners.js
function Pg(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, i = a === void 0 ? !0 : a, c = n.resize, l = c === void 0 ? !0 : c, s = Z(t.
  elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(f) {
    f.addEventListener("scroll", r.update, lo);
  }), l && s.addEventListener("resize", r.update, lo), function() {
    i && u.forEach(function(f) {
      f.removeEventListener("scroll", r.update, lo);
    }), l && s.removeEventListener("resize", r.update, lo);
  };
}
var lo, pf, mf = S(() => {
  Je();
  lo = {
    passive: !0
  };
  o(Pg, "effect");
  pf = {
    name: "eventListeners",
    enabled: !0,
    phase: "write",
    fn: /* @__PURE__ */ o(function() {
    }, "fn"),
    effect: Pg,
    data: {}
  };
});

// ../node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
function Lr(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return kg[t];
  });
}
var kg, hf = S(() => {
  kg = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  };
  o(Lr, "getOppositePlacement");
});

// ../node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
function co(e) {
  return e.replace(/start|end/g, function(t) {
    return Bg[t];
  });
}
var Bg, vf = S(() => {
  Bg = {
    start: "end",
    end: "start"
  };
  o(co, "getOppositeVariationPlacement");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js
function qt(e) {
  var t = Z(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
var so = S(() => {
  Je();
  o(qt, "getWindowScroll");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js
function Gt(e) {
  return qe(Re(e)).left + qt(e).scrollLeft;
}
var uo = S(() => {
  Er();
  dt();
  so();
  o(Gt, "getWindowScrollBarX");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js
function m0(e, t) {
  var r = Z(e), n = Re(e), a = r.visualViewport, i = n.clientWidth, c = n.clientHeight, l = 0, s = 0;
  if (a) {
    i = a.width, c = a.height;
    var u = en();
    (u || !u && t === "fixed") && (l = a.offsetLeft, s = a.offsetTop);
  }
  return {
    width: i,
    height: c,
    x: l + Gt(e),
    y: s
  };
}
var gf = S(() => {
  Je();
  dt();
  uo();
  l0();
  o(m0, "getViewportRect");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js
function h0(e) {
  var t, r = Re(e), n = qt(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = Qe(r.scrollWidth, r.clientWidth, a ? a.scrollWidth :
  0, a ? a.clientWidth : 0), c = Qe(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), l = -n.scrollLeft + Gt(
  e), s = -n.scrollTop;
  return Ce(a || r).direction === "rtl" && (l += Qe(r.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: c,
    x: l,
    y: s
  };
}
var wf = S(() => {
  dt();
  Cr();
  uo();
  so();
  Et();
  o(h0, "getDocumentRect");
});

// ../node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js
function Xt(e) {
  var t = Ce(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
var fo = S(() => {
  Cr();
  o(Xt, "isScrollParent");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js
function po(e) {
  return ["html", "body", "#document"].indexOf(pe(e)) >= 0 ? e.ownerDocument.body : ue(e) && Xt(e) ? e : po(pt(e));
}
var Rf = S(() => {
  rn();
  fo();
  bt();
  Oe();
  o(po, "getScrollParent");
});

// ../node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js
function Ct(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = po(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = Z(n), c = a ? [i].concat(i.visualViewport || [], Xt(n) ? n :
  []) : n, l = t.concat(c);
  return a ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(Ct(pt(c)))
  );
}
var v0 = S(() => {
  Rf();
  rn();
  Je();
  fo();
  o(Ct, "listScrollParents");
});

// ../node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function Ar(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
var g0 = S(() => {
  o(Ar, "rectToClientRect");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js
function Og(e, t) {
  var r = qe(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.
  width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function xf(e, t, r) {
  return t === no ? Ar(m0(e, r)) : Ue(t) ? Og(t, r) : Ar(h0(Re(e)));
}
function Ng(e) {
  var t = Ct(pt(e)), r = ["absolute", "fixed"].indexOf(Ce(e).position) >= 0, n = r && ue(e) ? et(e) : e;
  return Ue(n) ? t.filter(function(a) {
    return Ue(a) && tn(a, n) && pe(a) !== "body";
  }) : [];
}
function w0(e, t, r, n) {
  var a = t === "clippingParents" ? Ng(e) : [].concat(t), i = [].concat(a, [r]), c = i[0], l = i.reduce(function(s, u) {
    var f = xf(e, u, n);
    return s.top = Qe(f.top, s.top), s.right = Wt(f.right, s.right), s.bottom = Wt(f.bottom, s.bottom), s.left = Qe(f.left, s.left), s;
  }, xf(e, c, n));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
var bf = S(() => {
  Be();
  gf();
  wf();
  v0();
  Sr();
  dt();
  Cr();
  Oe();
  Er();
  rn();
  c0();
  bt();
  g0();
  Et();
  o(Og, "getInnerBoundingClientRect");
  o(xf, "getClientRectFromMixedType");
  o(Ng, "getClippingParents");
  o(w0, "getClippingRect");
});

// ../node_modules/@popperjs/core/lib/utils/computeOffsets.js
function ln(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? me(n) : null, i = n ? Ge(n) : null, c = t.x + t.width / 2 - r.width / 2, l = t.
  y + t.height / 2 - r.height / 2, s;
  switch (a) {
    case ee:
      s = {
        x: c,
        y: t.y - r.height
      };
      break;
    case se:
      s = {
        x: c,
        y: t.y + t.height
      };
      break;
    case ae:
      s = {
        x: t.x + t.width,
        y: l
      };
      break;
    case re:
      s = {
        x: t.x - r.width,
        y: l
      };
      break;
    default:
      s = {
        x: t.x,
        y: t.y
      };
  }
  var u = a ? jt(a) : null;
  if (u != null) {
    var f = u === "y" ? "height" : "width";
    switch (i) {
      case ut:
        s[u] = s[u] - (t[f] / 2 - r[f] / 2);
        break;
      case Vt:
        s[u] = s[u] + (t[f] / 2 - r[f] / 2);
        break;
      default:
    }
  }
  return s;
}
var R0 = S(() => {
  yt();
  Mr();
  io();
  Be();
  o(ln, "computeOffsets");
});

// ../node_modules/@popperjs/core/lib/utils/detectOverflow.js
function tt(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, i = r.strategy, c = i === void 0 ? e.strategy : i, l = r.boundary, s = l ===
  void 0 ? Qu : l, u = r.rootBoundary, f = u === void 0 ? no : u, d = r.elementContext, m = d === void 0 ? xr : d, g = r.altBoundary, x = g ===
  void 0 ? !1 : g, p = r.padding, h = p === void 0 ? 0 : p, v = on(typeof h != "number" ? h : an(h, xt)), w = m === xr ? ef : xr, R = e.rects.
  popper, y = e.elements[x ? w : m], E = w0(Ue(y) ? y : y.contextElement || Re(e.elements.popper), s, f, c), b = qe(e.elements.reference), C = ln(
  {
    reference: b,
    element: R,
    strategy: "absolute",
    placement: a
  }), L = Ar(Object.assign({}, R, C)), M = m === xr ? L : b, A = {
    top: E.top - M.top + v.top,
    bottom: M.bottom - E.bottom + v.bottom,
    left: E.left - M.left + v.left,
    right: M.right - E.right + v.right
  }, P = e.modifiersData.offset;
  if (m === xr && P) {
    var F = P[a];
    Object.keys(A).forEach(function(_) {
      var Y = [ae, se].indexOf(_) >= 0 ? 1 : -1, T = [ee, se].indexOf(_) >= 0 ? "y" : "x";
      A[_] += F[T] * Y;
    });
  }
  return A;
}
var cn = S(() => {
  bf();
  dt();
  Er();
  R0();
  g0();
  Be();
  Oe();
  d0();
  p0();
  o(tt, "detectOverflow");
});

// ../node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js
function x0(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, i = r.rootBoundary, c = r.padding, l = r.flipVariations, s = r.allowedAutoPlacements, u = s ===
  void 0 ? oo : s, f = Ge(n), d = f ? l ? a0 : a0.filter(function(x) {
    return Ge(x) === f;
  }) : xt, m = d.filter(function(x) {
    return u.indexOf(x) >= 0;
  });
  m.length === 0 && (m = d);
  var g = m.reduce(function(x, p) {
    return x[p] = tt(e, {
      placement: p,
      boundary: a,
      rootBoundary: i,
      padding: c
    })[me(p)], x;
  }, {});
  return Object.keys(g).sort(function(x, p) {
    return g[x] - g[p];
  });
}
var yf = S(() => {
  Mr();
  Be();
  cn();
  yt();
  o(x0, "computeAutoPlacement");
});

// ../node_modules/@popperjs/core/lib/modifiers/flip.js
function Dg(e) {
  if (me(e) === ro)
    return [];
  var t = Lr(e);
  return [co(e), t, co(t)];
}
function _g(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, c = r.altAxis, l = c === void 0 ? !0 : c, s = r.fallbackPlacements, u = r.padding, f = r.
    boundary, d = r.rootBoundary, m = r.altBoundary, g = r.flipVariations, x = g === void 0 ? !0 : g, p = r.allowedAutoPlacements, h = t.options.
    placement, v = me(h), w = v === h, R = s || (w || !x ? [Lr(h)] : Dg(h)), y = [h].concat(R).reduce(function(he, fe) {
      return he.concat(me(fe) === ro ? x0(t, {
        placement: fe,
        boundary: f,
        rootBoundary: d,
        padding: u,
        flipVariations: x,
        allowedAutoPlacements: p
      }) : fe);
    }, []), E = t.rects.reference, b = t.rects.popper, C = /* @__PURE__ */ new Map(), L = !0, M = y[0], A = 0; A < y.length; A++) {
      var P = y[A], F = me(P), _ = Ge(P) === ut, Y = [ee, se].indexOf(F) >= 0, T = Y ? "width" : "height", H = tt(t, {
        placement: P,
        boundary: f,
        rootBoundary: d,
        altBoundary: m,
        padding: u
      }), k = Y ? _ ? ae : re : _ ? se : ee;
      E[T] > b[T] && (k = Lr(k));
      var W = Lr(k), D = [];
      if (i && D.push(H[F] <= 0), l && D.push(H[k] <= 0, H[W] <= 0), D.every(function(he) {
        return he;
      })) {
        M = P, L = !1;
        break;
      }
      C.set(P, D);
    }
    if (L)
      for (var $ = x ? 3 : 1, B = /* @__PURE__ */ o(function(fe) {
        var xe = y.find(function(Me) {
          var Le = C.get(Me);
          if (Le)
            return Le.slice(0, fe).every(function(kr) {
              return kr;
            });
        });
        if (xe)
          return M = xe, "break";
      }, "_loop"), q = $; q > 0; q--) {
        var Se = B(q);
        if (Se === "break") break;
      }
    t.placement !== M && (t.modifiersData[n]._skip = !0, t.placement = M, t.reset = !0);
  }
}
var Ef, Cf = S(() => {
  hf();
  yt();
  vf();
  cn();
  yf();
  Be();
  Mr();
  o(Dg, "getExpandedFallbackPlacements");
  o(_g, "flip");
  Ef = {
    name: "flip",
    enabled: !0,
    phase: "main",
    fn: _g,
    requiresIfExists: ["offset"],
    data: {
      _skip: !1
    }
  };
});

// ../node_modules/@popperjs/core/lib/modifiers/hide.js
function Sf(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Mf(e) {
  return [ee, ae, se, re].some(function(t) {
    return e[t] >= 0;
  });
}
function Fg(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, c = tt(t, {
    elementContext: "reference"
  }), l = tt(t, {
    altBoundary: !0
  }), s = Sf(c, n), u = Sf(l, a, i), f = Mf(s), d = Mf(u);
  t.modifiersData[r] = {
    referenceClippingOffsets: s,
    popperEscapeOffsets: u,
    isReferenceHidden: f,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": d
  });
}
var Lf, Af = S(() => {
  Be();
  cn();
  o(Sf, "getSideOffsets");
  o(Mf, "isAnySideFullyClipped");
  o(Fg, "hide");
  Lf = {
    name: "hide",
    enabled: !0,
    phase: "main",
    requiresIfExists: ["preventOverflow"],
    fn: Fg
  };
});

// ../node_modules/@popperjs/core/lib/modifiers/offset.js
function Vg(e, t, r) {
  var n = me(e), a = [re, ee].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, c = i[0], l = i[1];
  return c = c || 0, l = (l || 0) * a, [re, ae].indexOf(n) >= 0 ? {
    x: l,
    y: c
  } : {
    x: c,
    y: l
  };
}
function Wg(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, i = a === void 0 ? [0, 0] : a, c = oo.reduce(function(f, d) {
    return f[d] = Vg(d, t.rects, i), f;
  }, {}), l = c[t.placement], s = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] =
  c;
}
var If, Hf = S(() => {
  yt();
  Be();
  o(Vg, "distanceAndSkiddingToXY");
  o(Wg, "offset");
  If = {
    name: "offset",
    enabled: !0,
    phase: "main",
    requires: ["popperOffsets"],
    fn: Wg
  };
});

// ../node_modules/@popperjs/core/lib/modifiers/popperOffsets.js
function $g(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = ln({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
var Tf, zf = S(() => {
  R0();
  o($g, "popperOffsets");
  Tf = {
    name: "popperOffsets",
    enabled: !0,
    phase: "read",
    fn: $g,
    data: {}
  };
});

// ../node_modules/@popperjs/core/lib/utils/getAltAxis.js
function b0(e) {
  return e === "x" ? "y" : "x";
}
var Pf = S(() => {
  o(b0, "getAltAxis");
});

// ../node_modules/@popperjs/core/lib/modifiers/preventOverflow.js
function jg(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, i = a === void 0 ? !0 : a, c = r.altAxis, l = c === void 0 ? !1 : c, s = r.boundary,
  u = r.rootBoundary, f = r.altBoundary, d = r.padding, m = r.tether, g = m === void 0 ? !0 : m, x = r.tetherOffset, p = x === void 0 ? 0 : x,
  h = tt(t, {
    boundary: s,
    rootBoundary: u,
    padding: d,
    altBoundary: f
  }), v = me(t.placement), w = Ge(t.placement), R = !w, y = jt(v), E = b0(y), b = t.modifiersData.popperOffsets, C = t.rects.reference, L = t.
  rects.popper, M = typeof p == "function" ? p(Object.assign({}, t.rects, {
    placement: t.placement
  })) : p, A = typeof M == "number" ? {
    mainAxis: M,
    altAxis: M
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, M), P = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, F = {
    x: 0,
    y: 0
  };
  if (b) {
    if (i) {
      var _, Y = y === "y" ? ee : re, T = y === "y" ? se : ae, H = y === "y" ? "height" : "width", k = b[y], W = k + h[Y], D = k - h[T], $ = g ?
      -L[H] / 2 : 0, B = w === ut ? C[H] : L[H], q = w === ut ? -L[H] : -C[H], Se = t.elements.arrow, he = g && Se ? $t(Se) : {
        width: 0,
        height: 0
      }, fe = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : nn(), xe = fe[Y], Me = fe[T], Le = Ut(0, C[H],
      he[H]), kr = R ? C[H] / 2 - $ - Le - xe - A.mainAxis : B - Le - xe - A.mainAxis, Br = R ? -C[H] / 2 + $ + Le + Me + A.mainAxis : q + Le +
      Me + A.mainAxis, Eo = t.elements.arrow && et(t.elements.arrow), Id = Eo ? y === "y" ? Eo.clientTop || 0 : Eo.clientLeft || 0 : 0, K0 = (_ =
      P?.[y]) != null ? _ : 0, Hd = k + kr - K0 - Id, Td = k + Br - K0, J0 = Ut(g ? Wt(W, Hd) : W, k, g ? Qe(D, Td) : D);
      b[y] = J0, F[y] = J0 - k;
    }
    if (l) {
      var Q0, zd = y === "x" ? ee : re, Pd = y === "x" ? se : ae, At = b[E], pn = E === "y" ? "height" : "width", el = At + h[zd], tl = At -
      h[Pd], Co = [ee, re].indexOf(v) !== -1, rl = (Q0 = P?.[E]) != null ? Q0 : 0, nl = Co ? el : At - C[pn] - L[pn] - rl + A.altAxis, ol = Co ?
      At + C[pn] + L[pn] - rl - A.altAxis : tl, al = g && Co ? lf(nl, At, ol) : Ut(g ? nl : el, At, g ? ol : tl);
      b[E] = al, F[E] = al - At;
    }
    t.modifiersData[n] = F;
  }
}
var kf, Bf = S(() => {
  Be();
  yt();
  io();
  Pf();
  u0();
  ao();
  Sr();
  cn();
  Mr();
  f0();
  Et();
  o(jg, "preventOverflow");
  kf = {
    name: "preventOverflow",
    enabled: !0,
    phase: "main",
    fn: jg,
    requiresIfExists: ["offset"]
  };
});

// ../node_modules/@popperjs/core/lib/modifiers/index.js
var y0 = S(() => {
});

// ../node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function E0(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
var Of = S(() => {
  o(E0, "getHTMLElementScroll");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js
function C0(e) {
  return e === Z(e) || !ue(e) ? qt(e) : E0(e);
}
var Nf = S(() => {
  so();
  Je();
  Oe();
  Of();
  o(C0, "getNodeScroll");
});

// ../node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js
function Ug(e) {
  var t = e.getBoundingClientRect(), r = ft(t.width) / e.offsetWidth || 1, n = ft(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function S0(e, t, r) {
  r === void 0 && (r = !1);
  var n = ue(t), a = ue(t) && Ug(t), i = Re(t), c = qe(e, a, r), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((pe(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Xt(i)) && (l = C0(t)), ue(t) ? (s = qe(t, !0), s.x += t.clientLeft, s.y += t.clientTop) : i && (s.x = Gt(i))), {
    x: c.left + l.scrollLeft - s.x,
    y: c.top + l.scrollTop - s.y,
    width: c.width,
    height: c.height
  };
}
var Df = S(() => {
  Er();
  Nf();
  bt();
  Oe();
  uo();
  dt();
  fo();
  Et();
  o(Ug, "isElementScaled");
  o(S0, "getCompositeRect");
});

// ../node_modules/@popperjs/core/lib/utils/orderModifiers.js
function qg(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var c = [].concat(i.requires || [], i.requiresIfExists || []);
    c.forEach(function(l) {
      if (!r.has(l)) {
        var s = t.get(l);
        s && a(s);
      }
    }), n.push(i);
  }
  return o(a, "sort"), e.forEach(function(i) {
    r.has(i.name) || a(i);
  }), n;
}
function M0(e) {
  var t = qg(e);
  return tf.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
var _f = S(() => {
  Be();
  o(qg, "order");
  o(M0, "orderModifiers");
});

// ../node_modules/@popperjs/core/lib/utils/debounce.js
function L0(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
var Ff = S(() => {
  o(L0, "debounce");
});

// ../node_modules/@popperjs/core/lib/utils/mergeByName.js
function A0(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Vf = S(() => {
  o(A0, "mergeByName");
});

// ../node_modules/@popperjs/core/lib/createPopper.js
function $f() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function jf(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, i = a === void 0 ? Wf : a;
  return /* @__PURE__ */ o(function(l, s, u) {
    u === void 0 && (u = i);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Wf, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: s
      },
      attributes: {},
      styles: {}
    }, d = [], m = !1, g = {
      state: f,
      setOptions: /* @__PURE__ */ o(function(v) {
        var w = typeof v == "function" ? v(f.options) : v;
        p(), f.options = Object.assign({}, i, f.options, w), f.scrollParents = {
          reference: Ue(l) ? Ct(l) : l.contextElement ? Ct(l.contextElement) : [],
          popper: Ct(s)
        };
        var R = M0(A0([].concat(n, f.options.modifiers)));
        return f.orderedModifiers = R.filter(function(y) {
          return y.enabled;
        }), x(), g.update();
      }, "setOptions"),
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: /* @__PURE__ */ o(function() {
        if (!m) {
          var v = f.elements, w = v.reference, R = v.popper;
          if ($f(w, R)) {
            f.rects = {
              reference: S0(w, et(R), f.options.strategy === "fixed"),
              popper: $t(R)
            }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(A) {
              return f.modifiersData[A.name] = Object.assign({}, A.data);
            });
            for (var y = 0; y < f.orderedModifiers.length; y++) {
              if (f.reset === !0) {
                f.reset = !1, y = -1;
                continue;
              }
              var E = f.orderedModifiers[y], b = E.fn, C = E.options, L = C === void 0 ? {} : C, M = E.name;
              typeof b == "function" && (f = b({
                state: f,
                options: L,
                name: M,
                instance: g
              }) || f);
            }
          }
        }
      }, "forceUpdate"),
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: L0(function() {
        return new Promise(function(h) {
          g.forceUpdate(), h(f);
        });
      }),
      destroy: /* @__PURE__ */ o(function() {
        p(), m = !0;
      }, "destroy")
    };
    if (!$f(l, s))
      return g;
    g.setOptions(u).then(function(h) {
      !m && u.onFirstUpdate && u.onFirstUpdate(h);
    });
    function x() {
      f.orderedModifiers.forEach(function(h) {
        var v = h.name, w = h.options, R = w === void 0 ? {} : w, y = h.effect;
        if (typeof y == "function") {
          var E = y({
            state: f,
            name: v,
            instance: g,
            options: R
          }), b = /* @__PURE__ */ o(function() {
          }, "noopFn");
          d.push(E || b);
        }
      });
    }
    o(x, "runModifierEffects");
    function p() {
      d.forEach(function(h) {
        return h();
      }), d = [];
    }
    return o(p, "cleanupModifierEffects"), g;
  }, "createPopper");
}
var Wf, Uf = S(() => {
  Df();
  ao();
  v0();
  Sr();
  _f();
  Ff();
  Vf();
  Oe();
  Wf = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
  };
  o($f, "areValidElements");
  o(jf, "popperGenerator");
});

// ../node_modules/@popperjs/core/lib/popper.js
var Gg, I0, qf = S(() => {
  Uf();
  mf();
  zf();
  df();
  nf();
  Hf();
  Cf();
  Bf();
  sf();
  Af();
  y0();
  Gg = [pf, Tf, ff, rf, If, Ef, kf, cf, Lf], I0 = /* @__PURE__ */ jf({
    defaultModifiers: Gg
  });
});

// ../node_modules/@popperjs/core/lib/index.js
var Gf = S(() => {
  Be();
  y0();
  qf();
});

// ../node_modules/react-fast-compare/index.js
var Zf = z((aH, Xf) => {
  var Xg = typeof Element < "u", Zg = typeof Map == "function", Yg = typeof Set == "function", Kg = typeof ArrayBuffer == "function" && !!ArrayBuffer.
  isView;
  function mo(e, t) {
    if (e === t) return !0;
    if (e && t && typeof e == "object" && typeof t == "object") {
      if (e.constructor !== t.constructor) return !1;
      var r, n, a;
      if (Array.isArray(e)) {
        if (r = e.length, r != t.length) return !1;
        for (n = r; n-- !== 0; )
          if (!mo(e[n], t[n])) return !1;
        return !0;
      }
      var i;
      if (Zg && e instanceof Map && t instanceof Map) {
        if (e.size !== t.size) return !1;
        for (i = e.entries(); !(n = i.next()).done; )
          if (!t.has(n.value[0])) return !1;
        for (i = e.entries(); !(n = i.next()).done; )
          if (!mo(n.value[1], t.get(n.value[0]))) return !1;
        return !0;
      }
      if (Yg && e instanceof Set && t instanceof Set) {
        if (e.size !== t.size) return !1;
        for (i = e.entries(); !(n = i.next()).done; )
          if (!t.has(n.value[0])) return !1;
        return !0;
      }
      if (Kg && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
        if (r = e.length, r != t.length) return !1;
        for (n = r; n-- !== 0; )
          if (e[n] !== t[n]) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
      if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function") return e.valueOf() ===
      t.valueOf();
      if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function") return e.toString() ===
      t.toString();
      if (a = Object.keys(e), r = a.length, r !== Object.keys(t).length) return !1;
      for (n = r; n-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(t, a[n])) return !1;
      if (Xg && e instanceof Element) return !1;
      for (n = r; n-- !== 0; )
        if (!((a[n] === "_owner" || a[n] === "__v" || a[n] === "__o") && e.$$typeof) && !mo(e[a[n]], t[a[n]]))
          return !1;
      return !0;
    }
    return e !== e && t !== t;
  }
  o(mo, "equal");
  Xf.exports = /* @__PURE__ */ o(function(t, r) {
    try {
      return mo(t, r);
    } catch (n) {
      if ((n.message || "").match(/stack|recursion/i))
        return console.warn("react-fast-compare cannot handle circular refs"), !1;
      throw n;
    }
  }, "isEqual");
});

// ../node_modules/react-popper/lib/esm/usePopper.js
import * as St from "react";
import * as Yf from "react-dom";
var Kf, Jg, H0, Jf = S(() => {
  Gf();
  Kf = ve(Zf());
  Ju();
  Jg = [], H0 = /* @__PURE__ */ o(function(t, r, n) {
    n === void 0 && (n = {});
    var a = St.useRef(null), i = {
      onFirstUpdate: n.onFirstUpdate,
      placement: n.placement || "bottom",
      strategy: n.strategy || "absolute",
      modifiers: n.modifiers || Jg
    }, c = St.useState({
      styles: {
        popper: {
          position: i.strategy,
          left: "0",
          top: "0"
        },
        arrow: {
          position: "absolute"
        }
      },
      attributes: {}
    }), l = c[0], s = c[1], u = St.useMemo(function() {
      return {
        name: "updateState",
        enabled: !0,
        phase: "write",
        fn: /* @__PURE__ */ o(function(g) {
          var x = g.state, p = Object.keys(x.elements);
          Yf.flushSync(function() {
            s({
              styles: n0(p.map(function(h) {
                return [h, x.styles[h] || {}];
              })),
              attributes: n0(p.map(function(h) {
                return [h, x.attributes[h]];
              }))
            });
          });
        }, "fn"),
        requires: ["computeStyles"]
      };
    }, []), f = St.useMemo(function() {
      var m = {
        onFirstUpdate: i.onFirstUpdate,
        placement: i.placement,
        strategy: i.strategy,
        modifiers: [].concat(i.modifiers, [u, {
          name: "applyStyles",
          enabled: !1
        }])
      };
      return (0, Kf.default)(a.current, m) ? a.current || m : (a.current = m, m);
    }, [i.onFirstUpdate, i.placement, i.strategy, i.modifiers, u]), d = St.useRef();
    return o0(function() {
      d.current && d.current.setOptions(f);
    }, [f]), o0(function() {
      if (!(t == null || r == null)) {
        var m = n.createPopper || I0, g = m(t, r, f);
        return d.current = g, function() {
          g.destroy(), d.current = null;
        };
      }
    }, [t, r, n.createPopper]), {
      state: d.current ? d.current.state : null,
      styles: l.styles,
      attributes: l.attributes,
      update: d.current ? d.current.update : null,
      forceUpdate: d.current ? d.current.forceUpdate : null
    };
  }, "usePopper");
});

// ../node_modules/react-popper/lib/esm/index.js
var Qf = S(() => {
  Jf();
});

// ../node_modules/react-popper-tooltip/dist/esm/react-popper-tooltip.js
import * as V from "react";
function rd(e) {
  var t = V.useRef(e);
  return t.current = e, V.useCallback(function() {
    return t.current;
  }, []);
}
function e7(e) {
  var t = e.initial, r = e.value, n = e.onChange, a = n === void 0 ? Qg : n;
  if (t === void 0 && r === void 0)
    throw new TypeError('Either "value" or "initial" variable must be set. Now both are undefined');
  var i = V.useState(t), c = i[0], l = i[1], s = rd(c), u = V.useCallback(function(d) {
    var m = s(), g = typeof d == "function" ? d(m) : d;
    typeof g.persist == "function" && g.persist(), l(g), typeof a == "function" && a(g);
  }, [s, a]), f = r !== void 0;
  return [f ? r : c, f ? a : u];
}
function nd(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), function() {
    return {
      width: 0,
      height: 0,
      top: t,
      right: e,
      bottom: t,
      left: e,
      x: 0,
      y: 0,
      toJSON: /* @__PURE__ */ o(function() {
        return null;
      }, "toJSON")
    };
  };
}
function od(e, t) {
  var r, n, a;
  e === void 0 && (e = {}), t === void 0 && (t = {});
  var i = Object.keys(td).reduce(function(T, H) {
    var k;
    return Ie({}, T, (k = {}, k[H] = T[H] !== void 0 ? T[H] : td[H], k));
  }, e), c = V.useMemo(
    function() {
      return [{
        name: "offset",
        options: {
          offset: i.offset
        }
      }];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Array.isArray(i.offset) ? i.offset : []
  ), l = Ie({}, t, {
    placement: t.placement || i.placement,
    modifiers: t.modifiers || c
  }), s = V.useState(null), u = s[0], f = s[1], d = V.useState(null), m = d[0], g = d[1], x = e7({
    initial: i.defaultVisible,
    value: i.visible,
    onChange: i.onVisibleChange
  }), p = x[0], h = x[1], v = V.useRef();
  V.useEffect(function() {
    return function() {
      return clearTimeout(v.current);
    };
  }, []);
  var w = H0(i.followCursor ? ed : u, m, l), R = w.styles, y = w.attributes, E = Jt(w, t7), b = E.update, C = rd({
    visible: p,
    triggerRef: u,
    tooltipRef: m,
    finalConfig: i
  }), L = V.useCallback(
    function(T) {
      return Array.isArray(i.trigger) ? i.trigger.includes(T) : i.trigger === T;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Array.isArray(i.trigger) ? i.trigger : [i.trigger]
  ), M = V.useCallback(function() {
    clearTimeout(v.current), v.current = window.setTimeout(function() {
      return h(!1);
    }, i.delayHide);
  }, [i.delayHide, h]), A = V.useCallback(function() {
    clearTimeout(v.current), v.current = window.setTimeout(function() {
      return h(!0);
    }, i.delayShow);
  }, [i.delayShow, h]), P = V.useCallback(function() {
    C().visible ? M() : A();
  }, [C, M, A]);
  V.useEffect(function() {
    if (C().finalConfig.closeOnOutsideClick) {
      var T = /* @__PURE__ */ o(function(k) {
        var W, D = C(), $ = D.tooltipRef, B = D.triggerRef, q = (k.composedPath == null || (W = k.composedPath()) == null ? void 0 : W[0]) ||
        k.target;
        q instanceof Node && $ != null && B != null && !$.contains(q) && !B.contains(q) && M();
      }, "handleClickOutside");
      return document.addEventListener("mousedown", T), function() {
        return document.removeEventListener("mousedown", T);
      };
    }
  }, [C, M]), V.useEffect(function() {
    if (!(u == null || !L("click")))
      return u.addEventListener("click", P), function() {
        return u.removeEventListener("click", P);
      };
  }, [u, L, P]), V.useEffect(function() {
    if (!(u == null || !L("double-click")))
      return u.addEventListener("dblclick", P), function() {
        return u.removeEventListener("dblclick", P);
      };
  }, [u, L, P]), V.useEffect(function() {
    if (!(u == null || !L("right-click"))) {
      var T = /* @__PURE__ */ o(function(k) {
        k.preventDefault(), P();
      }, "preventDefaultAndToggle");
      return u.addEventListener("contextmenu", T), function() {
        return u.removeEventListener("contextmenu", T);
      };
    }
  }, [u, L, P]), V.useEffect(function() {
    if (!(u == null || !L("focus")))
      return u.addEventListener("focus", A), u.addEventListener("blur", M), function() {
        u.removeEventListener("focus", A), u.removeEventListener("blur", M);
      };
  }, [u, L, A, M]), V.useEffect(function() {
    if (!(u == null || !L("hover")))
      return u.addEventListener("mouseenter", A), u.addEventListener("mouseleave", M), function() {
        u.removeEventListener("mouseenter", A), u.removeEventListener("mouseleave", M);
      };
  }, [u, L, A, M]), V.useEffect(function() {
    if (!(m == null || !L("hover") || !C().finalConfig.interactive))
      return m.addEventListener("mouseenter", A), m.addEventListener("mouseleave", M), function() {
        m.removeEventListener("mouseenter", A), m.removeEventListener("mouseleave", M);
      };
  }, [m, L, A, M, C]);
  var F = E == null || (r = E.state) == null || (n = r.modifiersData) == null || (a = n.hide) == null ? void 0 : a.isReferenceHidden;
  V.useEffect(function() {
    i.closeOnTriggerHidden && F && M();
  }, [i.closeOnTriggerHidden, M, F]), V.useEffect(function() {
    if (!i.followCursor || u == null) return;
    function T(H) {
      var k = H.clientX, W = H.clientY;
      ed.getBoundingClientRect = nd(k, W), b?.();
    }
    return o(T, "setMousePosition"), u.addEventListener("mousemove", T), function() {
      return u.removeEventListener("mousemove", T);
    };
  }, [i.followCursor, u, b]), V.useEffect(function() {
    if (!(m == null || b == null || i.mutationObserverOptions == null)) {
      var T = new MutationObserver(b);
      return T.observe(m, i.mutationObserverOptions), function() {
        return T.disconnect();
      };
    }
  }, [i.mutationObserverOptions, m, b]);
  var _ = /* @__PURE__ */ o(function(H) {
    return H === void 0 && (H = {}), Ie({}, H, {
      style: Ie({}, H.style, R.popper)
    }, y.popper, {
      "data-popper-interactive": i.interactive
    });
  }, "getTooltipProps"), Y = /* @__PURE__ */ o(function(H) {
    return H === void 0 && (H = {}), Ie({}, H, y.arrow, {
      style: Ie({}, H.style, R.arrow),
      "data-popper-arrow": !0
    });
  }, "getArrowProps");
  return Ie({
    getArrowProps: Y,
    getTooltipProps: _,
    setTooltipRef: g,
    setTriggerRef: f,
    tooltipRef: m,
    triggerRef: u,
    visible: p
  }, E);
}
var Qg, t7, ed, td, ad = S(() => {
  hn();
  gn();
  Qf();
  o(rd, "useGetLatest");
  Qg = /* @__PURE__ */ o(function() {
  }, "noop");
  o(e7, "useControlledState");
  o(nd, "generateBoundingClientRect");
  t7 = ["styles", "attributes"], ed = {
    getBoundingClientRect: nd()
  }, td = {
    closeOnOutsideClick: !0,
    closeOnTriggerHidden: !1,
    defaultVisible: !1,
    delayHide: 0,
    delayShow: 0,
    followCursor: !1,
    interactive: !1,
    mutationObserverOptions: {
      attributes: !0,
      childList: !0,
      subtree: !0
    },
    offset: [0, 6],
    trigger: "hover"
  };
  o(od, "usePopperTooltip");
});

// src/components/components/tooltip/Tooltip.tsx
import T0 from "react";
import { lighten as sn, styled as ld } from "storybook/theming";
var id, Xe, Mt, r7, n7, z0, cd = S(() => {
  "use strict";
  id = ve(Dr(), 1), Xe = (0, id.default)(1e3)(
    (e, t, r, n = 0) => t.split("-")[0] === e ? r : n
  ), Mt = 8, r7 = ld.div(
    {
      position: "absolute",
      borderStyle: "solid"
    },
    ({ placement: e }) => {
      let t = 0, r = 0;
      switch (!0) {
        case (e.startsWith("left") || e.startsWith("right")): {
          r = 8;
          break;
        }
        case (e.startsWith("top") || e.startsWith("bottom")): {
          t = 8;
          break;
        }
        default:
      }
      return { transform: `translate3d(${t}px, ${r}px, 0px)` };
    },
    ({ theme: e, color: t, placement: r }) => ({
      bottom: `${Xe("top", r, `${Mt * -1}px`, "auto")}`,
      top: `${Xe("bottom", r, `${Mt * -1}px`, "auto")}`,
      right: `${Xe("left", r, `${Mt * -1}px`, "auto")}`,
      left: `${Xe("right", r, `${Mt * -1}px`, "auto")}`,
      borderBottomWidth: `${Xe("top", r, "0", Mt)}px`,
      borderTopWidth: `${Xe("bottom", r, "0", Mt)}px`,
      borderRightWidth: `${Xe("left", r, "0", Mt)}px`,
      borderLeftWidth: `${Xe("right", r, "0", Mt)}px`,
      borderTopColor: Xe(
        "top",
        r,
        e.color[t] || t || e.base === "light" ? sn(e.background.app) : e.background.app,
        "transparent"
      ),
      borderBottomColor: Xe(
        "bottom",
        r,
        e.color[t] || t || e.base === "light" ? sn(e.background.app) : e.background.app,
        "transparent"
      ),
      borderLeftColor: Xe(
        "left",
        r,
        e.color[t] || t || e.base === "light" ? sn(e.background.app) : e.background.app,
        "transparent"
      ),
      borderRightColor: Xe(
        "right",
        r,
        e.color[t] || t || e.base === "light" ? sn(e.background.app) : e.background.app,
        "transparent"
      )
    })
  ), n7 = ld.div(
    ({ hidden: e }) => ({
      display: e ? "none" : "inline-block",
      zIndex: 2147483647
    }),
    ({ theme: e, color: t, hasChrome: r }) => r ? {
      background: t && e.color[t] || t || e.base === "light" ? sn(e.background.app) : e.background.app,
      filter: `
            drop-shadow(0px 5px 5px rgba(0,0,0,0.05))
            drop-shadow(0 1px 3px rgba(0,0,0,0.1))
          `,
      borderRadius: e.appBorderRadius + 2,
      fontSize: e.typography.size.s1
    } : {}
  ), z0 = T0.forwardRef(
    ({
      placement: e = "top",
      hasChrome: t = !0,
      children: r,
      arrowProps: n = {},
      tooltipRef: a,
      color: i,
      withArrows: c,
      ...l
    }, s) => /* @__PURE__ */ T0.createElement(n7, { "data-testid": "tooltip", hasChrome: t, ref: s, ...l, color: i }, t && c && /* @__PURE__ */ T0.
    createElement(r7, { placement: e, ...n, color: i }), r)
  );
  z0.displayName = "Tooltip";
});

// src/components/components/tooltip/WithTooltip.tsx
var k0 = {};
Nr(k0, {
  WithToolTipState: () => P0,
  WithTooltip: () => P0,
  WithTooltipPure: () => ud
});
import un, { useCallback as o7, useEffect as a7, useState as i7 } from "react";
import l7 from "react-dom";
import { global as c7 } from "@storybook/global";
import { styled as sd } from "storybook/theming";
var ho, s7, u7, ud, P0, vo = S(() => {
  "use strict";
  ad();
  cd();
  ({ document: ho } = c7), s7 = sd.div`
  display: inline-block;
  cursor: ${(e) => (
    // @ts-expect-error (non strict)
    e.trigger === "hover" || e.trigger.includes("hover") ? "default" : "pointer"
  )};
`, u7 = sd.g`
  cursor: ${(e) => (
    // @ts-expect-error (non strict)
    e.trigger === "hover" || e.trigger.includes("hover") ? "default" : "pointer"
  )};
`, ud = /* @__PURE__ */ o(({
    svg: e = !1,
    trigger: t = "click",
    closeOnOutsideClick: r = !1,
    placement: n = "top",
    modifiers: a = [
      {
        name: "preventOverflow",
        options: {
          padding: 8
        }
      },
      {
        name: "offset",
        options: {
          offset: [8, 8]
        }
      },
      {
        name: "arrow",
        options: {
          padding: 8
        }
      }
    ],
    hasChrome: i = !0,
    defaultVisible: c = !1,
    withArrows: l,
    offset: s,
    tooltip: u,
    children: f,
    closeOnTriggerHidden: d,
    mutationObserverOptions: m,
    delayHide: g = t === "hover" ? 200 : 0,
    visible: x,
    interactive: p,
    delayShow: h = t === "hover" ? 400 : 0,
    strategy: v,
    followCursor: w,
    onVisibleChange: R,
    ...y
  }) => {
    let E = e ? u7 : s7, {
      getArrowProps: b,
      getTooltipProps: C,
      setTooltipRef: L,
      setTriggerRef: M,
      visible: A,
      state: P
    } = od(
      {
        trigger: t,
        placement: n,
        defaultVisible: c,
        delayHide: g,
        interactive: p,
        closeOnOutsideClick: r,
        closeOnTriggerHidden: d,
        onVisibleChange: R,
        delayShow: h,
        followCursor: w,
        mutationObserverOptions: m,
        visible: x,
        offset: s
      },
      {
        modifiers: a,
        strategy: v
      }
    ), F = A ? /* @__PURE__ */ un.createElement(
      z0,
      {
        placement: P?.placement,
        ref: L,
        hasChrome: i,
        arrowProps: b(),
        withArrows: l,
        ...C()
      },
      typeof u == "function" ? u({ onHide: /* @__PURE__ */ o(() => R(!1), "onHide") }) : u
    ) : null;
    return /* @__PURE__ */ un.createElement(un.Fragment, null, /* @__PURE__ */ un.createElement(E, { trigger: t, ref: M, ...y }, f), A && l7.
    createPortal(F, ho.body));
  }, "WithTooltipPure"), P0 = /* @__PURE__ */ o(({
    startOpen: e = !1,
    onVisibleChange: t,
    ...r
  }) => {
    let [n, a] = i7(e), i = o7(
      (c) => {
        t && t(c) === !1 || a(c);
      },
      [t]
    );
    return a7(() => {
      let c = /* @__PURE__ */ o(() => i(!1), "hide");
      ho.addEventListener("keydown", c, !1);
      let l = Array.from(ho.getElementsByTagName("iframe")), s = [];
      return l.forEach((u) => {
        let f = /* @__PURE__ */ o(() => {
          try {
            u.contentWindow.document && (u.contentWindow.document.addEventListener("click", c), s.push(() => {
              try {
                u.contentWindow.document.removeEventListener("click", c);
              } catch {
              }
            }));
          } catch {
          }
        }, "bind");
        f(), u.addEventListener("load", f), s.push(() => {
          u.removeEventListener("load", f);
        });
      }), () => {
        ho.removeEventListener("keydown", c), s.forEach((u) => {
          u();
        });
      };
    }), /* @__PURE__ */ un.createElement(ud, { ...r, visible: n, onVisibleChange: i });
  }, "WithToolTipState");
});

// src/components/index.ts
import { createElement as W3, forwardRef as $3 } from "react";

// src/components/components/typography/components.tsx
import Q from "react";

// src/components/components/typography/DocumentFormatting.tsx
var K = /* @__PURE__ */ o(({ ...e }, t) => {
  let r = [e.class, e.className];
  return delete e.class, e.className = ["sbdocs", `sbdocs-${t}`, ...r].filter(Boolean).join(" "), e;
}, "nameSpaceClassNames");

// src/components/components/typography/ResetWrapper.tsx
import { styled as Fd } from "storybook/theming";

// src/components/components/typography/lib/common.tsx
import { transparentize as il } from "polished";
var De = /* @__PURE__ */ o(({ theme: e }) => ({
  margin: "20px 0 8px",
  padding: 0,
  cursor: "text",
  position: "relative",
  color: e.color.defaultText,
  "&:first-of-type": {
    marginTop: 0,
    paddingTop: 0
  },
  "&:hover a.anchor": {
    textDecoration: "none"
  },
  "& tt, & code": {
    fontSize: "inherit"
  }
}), "headerCommon"), it = /* @__PURE__ */ o(({ theme: e }) => ({
  lineHeight: 1,
  margin: "0 2px",
  padding: "3px 5px",
  whiteSpace: "nowrap",
  borderRadius: 3,
  fontSize: e.typography.size.s2 - 1,
  border: e.base === "light" ? `1px solid ${e.color.mediumlight}` : `1px solid ${e.color.darker}`,
  color: e.base === "light" ? il(0.1, e.color.defaultText) : il(0.3, e.color.defaultText),
  backgroundColor: e.base === "light" ? e.color.lighter : e.color.border
}), "codeCommon"), N = /* @__PURE__ */ o(({ theme: e }) => ({
  fontFamily: e.typography.fonts.base,
  fontSize: e.typography.size.s3,
  margin: 0,
  WebkitFontSmoothing: "antialiased",
  MozOsxFontSmoothing: "grayscale",
  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
  WebkitOverflowScrolling: "touch"
}), "withReset"), Ae = {
  margin: "16px 0"
};

// src/components/components/typography/ResetWrapper.tsx
var ll = Fd.div(N);

// src/components/components/typography/elements/A.tsx
import { styled as Wd } from "storybook/theming";

// src/components/components/typography/elements/Link.tsx
import Vd from "react";
var cl = /* @__PURE__ */ o(({
  href: e = "",
  ...t
}) => {
  let n = /^\//.test(e) ? `./?path=${e}` : e, i = /^#.*/.test(e) ? "_self" : "_top";
  return /* @__PURE__ */ Vd.createElement("a", { href: n, target: i, ...t });
}, "Link");

// src/components/components/typography/elements/A.tsx
var So = Wd(cl)(N, ({ theme: e }) => ({
  fontSize: "inherit",
  lineHeight: "24px",
  color: e.color.secondary,
  textDecoration: "none",
  "&.absent": {
    color: "#cc0000"
  },
  "&.anchor": {
    display: "block",
    paddingLeft: 30,
    marginLeft: -30,
    cursor: "pointer",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0
  }
}));

// src/components/components/typography/elements/Blockquote.tsx
import { styled as $d } from "storybook/theming";
var Mo = $d.blockquote(N, Ae, ({ theme: e }) => ({
  borderLeft: `4px solid ${e.color.medium}`,
  padding: "0 15px",
  color: e.color.dark,
  "& > :first-of-type": {
    marginTop: 0
  },
  "& > :last-child": {
    marginBottom: 0
  }
}));

// src/components/components/typography/elements/Code.tsx
Xr();
import s5, { Children as Y4 } from "react";
import { styled as u5 } from "storybook/theming";

// src/components/components/typography/lib/isReactChildString.tsx
var c5 = /* @__PURE__ */ o((e) => typeof e == "string", "isReactChildString");

// src/components/components/typography/elements/Code.tsx
var K4 = /[\n\r]/g, J4 = u5.code(
  ({ theme: e }) => ({
    // from reset
    fontFamily: e.typography.fonts.mono,
    WebkitFontSmoothing: "antialiased",
    MozOsxFontSmoothing: "grayscale",
    display: "inline-block",
    paddingLeft: 2,
    paddingRight: 2,
    verticalAlign: "baseline",
    color: "inherit"
  }),
  it
), Q4 = u5(Gr)(({ theme: e }) => ({
  // DocBlocks-specific styling and overrides
  fontFamily: e.typography.fonts.mono,
  fontSize: `${e.typography.size.s2 - 1}px`,
  lineHeight: "19px",
  margin: "25px 0 40px",
  borderRadius: e.appBorderRadius,
  boxShadow: e.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0",
  "pre.prismjs": {
    padding: 20,
    background: "inherit"
  }
})), Sa = /* @__PURE__ */ o(({
  className: e,
  children: t,
  ...r
}) => {
  let n = (e || "").match(/lang-(\S+)/), a = Y4.toArray(t);
  return a.filter(c5).some((c) => c.match(K4)) ? /* @__PURE__ */ s5.createElement(
    Q4,
    {
      bordered: !0,
      copyable: !0,
      language: n?.[1] ?? "text",
      format: !1,
      ...r
    },
    t
  ) : /* @__PURE__ */ s5.createElement(J4, { ...r, className: e }, a);
}, "Code");

// src/components/components/typography/elements/DL.tsx
import { styled as em } from "storybook/theming";
var Ma = em.dl(N, Ae, {
  padding: 0,
  "& dt": {
    fontSize: "14px",
    fontWeight: "bold",
    fontStyle: "italic",
    padding: 0,
    margin: "16px 0 4px"
  },
  "& dt:first-of-type": {
    padding: 0
  },
  "& dt > :first-of-type": {
    marginTop: 0
  },
  "& dt > :last-child": {
    marginBottom: 0
  },
  "& dd": {
    margin: "0 0 16px",
    padding: "0 15px"
  },
  "& dd > :first-of-type": {
    marginTop: 0
  },
  "& dd > :last-child": {
    marginBottom: 0
  }
});

// src/components/components/typography/elements/Div.tsx
import { styled as tm } from "storybook/theming";
var La = tm.div(N);

// src/components/components/typography/elements/H1.tsx
import { styled as rm } from "storybook/theming";
var Aa = rm.h1(N, De, ({ theme: e }) => ({
  fontSize: `${e.typography.size.l1}px`,
  fontWeight: e.typography.weight.bold
}));

// src/components/components/typography/elements/H2.tsx
import { styled as nm } from "storybook/theming";
var Ia = nm.h2(N, De, ({ theme: e }) => ({
  fontSize: `${e.typography.size.m2}px`,
  paddingBottom: 4,
  borderBottom: `1px solid ${e.appBorderColor}`
}));

// src/components/components/typography/elements/H3.tsx
import { styled as om } from "storybook/theming";
var Ha = om.h3(N, De, ({ theme: e }) => ({
  fontSize: `${e.typography.size.m1}px`
}));

// src/components/components/typography/elements/H4.tsx
import { styled as am } from "storybook/theming";
var Ta = am.h4(N, De, ({ theme: e }) => ({
  fontSize: `${e.typography.size.s3}px`
}));

// src/components/components/typography/elements/H5.tsx
import { styled as im } from "storybook/theming";
var za = im.h5(N, De, ({ theme: e }) => ({
  fontSize: `${e.typography.size.s2}px`
}));

// src/components/components/typography/elements/H6.tsx
import { styled as lm } from "storybook/theming";
var Pa = lm.h6(N, De, ({ theme: e }) => ({
  fontSize: `${e.typography.size.s2}px`,
  color: e.color.dark
}));

// src/components/components/typography/elements/HR.tsx
import { styled as cm } from "storybook/theming";
var ka = cm.hr(({ theme: e }) => ({
  border: "0 none",
  borderTop: `1px solid ${e.appBorderColor}`,
  height: 4,
  padding: 0
}));

// src/components/components/typography/elements/Img.tsx
import { styled as sm } from "storybook/theming";
var Ba = sm.img({
  maxWidth: "100%"
});

// src/components/components/typography/elements/LI.tsx
import { styled as um } from "storybook/theming";
var Oa = um.li(N, ({ theme: e }) => ({
  fontSize: e.typography.size.s2,
  color: e.color.defaultText,
  lineHeight: "24px",
  "& + li": {
    marginTop: ".25em"
  },
  "& ul, & ol": {
    marginTop: ".25em",
    marginBottom: 0
  },
  "& code": it({ theme: e })
}));

// src/components/components/typography/elements/OL.tsx
import { styled as fm } from "storybook/theming";
var dm = {
  paddingLeft: 30,
  "& :first-of-type": {
    marginTop: 0
  },
  "& :last-child": {
    marginBottom: 0
  }
}, Na = fm.ol(N, Ae, dm, {
  listStyle: "decimal"
});

// src/components/components/typography/elements/P.tsx
import { styled as pm } from "storybook/theming";
var Da = pm.p(N, Ae, ({ theme: e }) => ({
  fontSize: e.typography.size.s2,
  lineHeight: "24px",
  color: e.color.defaultText,
  "& code": it({ theme: e })
}));

// src/components/components/typography/elements/Pre.tsx
import { styled as mm } from "storybook/theming";
var _a = mm.pre(N, Ae, ({ theme: e }) => ({
  // reset
  fontFamily: e.typography.fonts.mono,
  WebkitFontSmoothing: "antialiased",
  MozOsxFontSmoothing: "grayscale",
  lineHeight: "18px",
  padding: "11px 1rem",
  whiteSpace: "pre-wrap",
  color: "inherit",
  borderRadius: 3,
  margin: "1rem 0",
  "&:not(.prismjs)": {
    background: "transparent",
    border: "none",
    borderRadius: 0,
    padding: 0,
    margin: 0
  },
  "& pre, &.prismjs": {
    padding: 15,
    margin: 0,
    whiteSpace: "pre-wrap",
    color: "inherit",
    fontSize: "13px",
    lineHeight: "19px",
    code: {
      color: "inherit",
      fontSize: "inherit"
    }
  },
  "& code": {
    whiteSpace: "pre"
  },
  "& code, & tt": {
    border: "none"
  }
}));

// src/components/components/typography/elements/Span.tsx
import { styled as hm } from "storybook/theming";
var Fa = hm.span(N, ({ theme: e }) => ({
  "&.frame": {
    display: "block",
    overflow: "hidden",
    "& > span": {
      border: `1px solid ${e.color.medium}`,
      display: "block",
      float: "left",
      overflow: "hidden",
      margin: "13px 0 0",
      padding: 7,
      width: "auto"
    },
    "& span img": {
      display: "block",
      float: "left"
    },
    "& span span": {
      clear: "both",
      color: e.color.darkest,
      display: "block",
      padding: "5px 0 0"
    }
  },
  "&.align-center": {
    display: "block",
    overflow: "hidden",
    clear: "both",
    "& > span": {
      display: "block",
      overflow: "hidden",
      margin: "13px auto 0",
      textAlign: "center"
    },
    "& span img": {
      margin: "0 auto",
      textAlign: "center"
    }
  },
  "&.align-right": {
    display: "block",
    overflow: "hidden",
    clear: "both",
    "& > span": {
      display: "block",
      overflow: "hidden",
      margin: "13px 0 0",
      textAlign: "right"
    },
    "& span img": {
      margin: 0,
      textAlign: "right"
    }
  },
  "&.float-left": {
    display: "block",
    marginRight: 13,
    overflow: "hidden",
    float: "left",
    "& span": {
      margin: "13px 0 0"
    }
  },
  "&.float-right": {
    display: "block",
    marginLeft: 13,
    overflow: "hidden",
    float: "right",
    "& > span": {
      display: "block",
      overflow: "hidden",
      margin: "13px auto 0",
      textAlign: "right"
    }
  }
}));

// src/components/components/typography/elements/TT.tsx
import { styled as vm } from "storybook/theming";
var Va = vm.title(it);

// src/components/components/typography/elements/Table.tsx
import { styled as gm } from "storybook/theming";
var Wa = gm.table(N, Ae, ({ theme: e }) => ({
  fontSize: e.typography.size.s2,
  lineHeight: "24px",
  padding: 0,
  borderCollapse: "collapse",
  "& tr": {
    borderTop: `1px solid ${e.appBorderColor}`,
    backgroundColor: e.appContentBg,
    margin: 0,
    padding: 0
  },
  "& tr:nth-of-type(2n)": {
    backgroundColor: e.base === "dark" ? e.color.darker : e.color.lighter
  },
  "& tr th": {
    fontWeight: "bold",
    color: e.color.defaultText,
    border: `1px solid ${e.appBorderColor}`,
    margin: 0,
    padding: "6px 13px"
  },
  "& tr td": {
    border: `1px solid ${e.appBorderColor}`,
    color: e.color.defaultText,
    margin: 0,
    padding: "6px 13px"
  },
  "& tr th :first-of-type, & tr td :first-of-type": {
    marginTop: 0
  },
  "& tr th :last-child, & tr td :last-child": {
    marginBottom: 0
  }
}));

// src/components/components/typography/elements/UL.tsx
import { styled as wm } from "storybook/theming";
var Rm = {
  paddingLeft: 30,
  "& :first-of-type": {
    marginTop: 0
  },
  "& :last-child": {
    marginBottom: 0
  }
}, $a = wm.ul(N, Ae, Rm, { listStyle: "disc" });

// src/components/components/typography/components.tsx
var ja = {
  h1: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Aa, { ...K(e, "h1") }), "h1"),
  h2: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Ia, { ...K(e, "h2") }), "h2"),
  h3: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Ha, { ...K(e, "h3") }), "h3"),
  h4: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Ta, { ...K(e, "h4") }), "h4"),
  h5: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(za, { ...K(e, "h5") }), "h5"),
  h6: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Pa, { ...K(e, "h6") }), "h6"),
  pre: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(_a, { ...K(e, "pre") }), "pre"),
  a: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(So, { ...K(e, "a") }), "a"),
  hr: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(ka, { ...K(e, "hr") }), "hr"),
  dl: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Ma, { ...K(e, "dl") }), "dl"),
  blockquote: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Mo, { ...K(e, "blockquote") }), "blockquote"),
  table: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Wa, { ...K(e, "table") }), "table"),
  img: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Ba, { ...K(e, "img") }), "img"),
  div: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(La, { ...K(e, "div") }), "div"),
  span: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Fa, { ...K(e, "span") }), "span"),
  li: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Oa, { ...K(e, "li") }), "li"),
  ul: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement($a, { ...K(e, "ul") }), "ul"),
  ol: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Na, { ...K(e, "ol") }), "ol"),
  p: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Da, { ...K(e, "p") }), "p"),
  code: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Sa, { ...K(e, "code") }), "code"),
  tt: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(Va, { ...K(e, "tt") }), "tt"),
  resetwrapper: /* @__PURE__ */ o((e) => /* @__PURE__ */ Q.createElement(ll, { ...K(e, "resetwrapper") }), "resetwrapper")
};

// src/components/components/Badge/Badge.tsx
import bm from "react";
import { transparentize as Zr } from "polished";
import { styled as ym } from "storybook/theming";
var Em = ym.div(
  ({ theme: e, compact: t }) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: e.typography.size.s1,
    fontWeight: e.typography.weight.bold,
    lineHeight: "12px",
    minWidth: 20,
    borderRadius: 20,
    padding: t ? "4px 7px" : "4px 10px"
  }),
  {
    svg: {
      height: 12,
      width: 12,
      marginRight: 4,
      marginTop: -2,
      path: {
        fill: "currentColor"
      }
    }
  },
  ({ theme: e, status: t }) => {
    switch (t) {
      case "critical":
        return {
          color: e.color.critical,
          background: e.background.critical
        };
      case "negative":
        return {
          color: e.color.negativeText,
          background: e.background.negative,
          boxShadow: e.base === "light" ? `inset 0 0 0 1px ${Zr(0.9, e.color.negativeText)}` : "none"
        };
      case "warning":
        return {
          color: e.color.warningText,
          background: e.background.warning,
          boxShadow: e.base === "light" ? `inset 0 0 0 1px ${Zr(0.9, e.color.warningText)}` : "none"
        };
      case "neutral":
        return {
          color: e.textMutedColor,
          background: e.base === "light" ? e.background.app : e.barBg,
          boxShadow: `inset 0 0 0 1px ${Zr(0.8, e.textMutedColor)}`
        };
      case "positive":
        return {
          color: e.color.positiveText,
          background: e.background.positive,
          boxShadow: e.base === "light" ? `inset 0 0 0 1px ${Zr(0.9, e.color.positiveText)}` : "none"
        };
      case "active":
        return {
          color: e.color.secondary,
          background: e.background.hoverable,
          boxShadow: `inset 0 0 0 1px ${Zr(0.9, e.color.secondary)}`
        };
      default:
        return {};
    }
  }
), Cm = /* @__PURE__ */ o(({ ...e }) => /* @__PURE__ */ bm.createElement(Em, { ...e }), "Badge");

// src/components/components/typography/link/link.tsx
import Ua from "react";

// ../node_modules/@storybook/icons/dist/index.mjs
import * as Ze from "react";
var f5 = /* @__PURE__ */ Ze.forwardRef(({ color: e = "currentColor", size: t = 14, ...r }, n) => /* @__PURE__ */ Ze.createElement(
  "svg",
  {
    width: t,
    height: t,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: n,
    ...r
  },
  /* @__PURE__ */ Ze.createElement(
    "path",
    {
      d: "M10.139 8.725l1.36-1.323a.568.568 0 00.151-.54.534.534 0 00-.377-.396l-2.705-.708 2.22-4.976a.568.568 0 00-.15-.666.497.497 0 00-.\
648.008L5.464 4.05l.708.71 2.848-2.47-1.64 3.677.697.697 2.164.567-.81.787.708.708zM2.523 6.6a.566.566 0 00-.177.544.534.534 0 00.382.41l2.7\
82.721-1.494 5.013a.563.563 0 00.217.627.496.496 0 00.629-.06l3.843-3.736-.708-.707-2.51 2.44 1.137-3.814-.685-.685-2.125-.55.844-.731-.71-.\
71L2.524 6.6zM1.854 1.146a.5.5 0 10-.708.708l11 11a.5.5 0 00.708-.708l-11-11z",
      fill: e
    }
  )
));
var d5 = /* @__PURE__ */ Ze.forwardRef(({ color: e = "currentColor", size: t = 14, ...r }, n) => /* @__PURE__ */ Ze.createElement(
  "svg",
  {
    width: t,
    height: t,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: n,
    ...r
  },
  /* @__PURE__ */ Ze.createElement(
    "path",
    {
      d: "M1.854 1.146a.5.5 0 10-.708.708L6.293 7l-5.147 5.146a.5.5 0 00.708.708L7 7.707l5.146 5.147a.5.5 0 00.708-.708L7.707 7l5.147-5.146a\
.5.5 0 00-.708-.708L7 6.293 1.854 1.146z",
      fill: e
    }
  )
));
var p5 = /* @__PURE__ */ Ze.forwardRef(({ color: e = "currentColor", size: t = 14, ...r }, n) => /* @__PURE__ */ Ze.createElement(
  "svg",
  {
    width: t,
    height: t,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: n,
    ...r
  },
  /* @__PURE__ */ Ze.createElement(
    "path",
    {
      d: "M11.104 7.354l-5.5 5.5a.5.5 0 01-.708-.708L10.043 7 4.896 1.854a.5.5 0 11.708-.708l5.5 5.5a.5.5 0 010 .708z",
      fill: e
    }
  )
));

// src/components/components/typography/link/link.tsx
import { darken as Nn } from "polished";
import { styled as m5 } from "storybook/theming";
var Sm = 0, Mm = /* @__PURE__ */ o((e) => e.button === Sm && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey, "isPlainLeftClick"), Lm = /* @__PURE__ */ o(
(e, t) => {
  Mm(e) && (e.preventDefault(), t(e));
}, "cancelled"), Am = m5.span(
  ({ withArrow: e }) => e ? {
    "> svg:last-of-type": {
      height: "0.7em",
      width: "0.7em",
      marginRight: 0,
      marginLeft: "0.25em",
      bottom: "auto",
      verticalAlign: "inherit"
    }
  } : {},
  ({ containsIcon: e }) => e ? {
    svg: {
      height: "1em",
      width: "1em",
      verticalAlign: "middle",
      position: "relative",
      bottom: 0,
      marginRight: 0
    }
  } : {}
), Im = m5.a(
  ({ theme: e }) => ({
    display: "inline-block",
    transition: "all 150ms ease-out",
    textDecoration: "none",
    color: e.color.secondary,
    "&:hover, &:focus": {
      cursor: "pointer",
      color: Nn(0.07, e.color.secondary),
      "svg path:not([fill])": {
        fill: Nn(0.07, e.color.secondary)
      }
    },
    "&:active": {
      color: Nn(0.1, e.color.secondary),
      "svg path:not([fill])": {
        fill: Nn(0.1, e.color.secondary)
      }
    },
    svg: {
      display: "inline-block",
      height: "1em",
      width: "1em",
      verticalAlign: "text-top",
      position: "relative",
      bottom: "-0.125em",
      marginRight: "0.4em",
      "& path": {
        fill: e.color.secondary
      }
    }
  }),
  ({ theme: e, secondary: t, tertiary: r }) => {
    let n;
    return t && (n = [e.textMutedColor, e.color.dark, e.color.darker]), r && (n = [e.color.dark, e.color.darkest, e.textMutedColor]), n ? {
      color: n[0],
      "svg path:not([fill])": {
        fill: n[0]
      },
      "&:hover": {
        color: n[1],
        "svg path:not([fill])": {
          fill: n[1]
        }
      },
      "&:active": {
        color: n[2],
        "svg path:not([fill])": {
          fill: n[2]
        }
      }
    } : {};
  },
  ({ nochrome: e }) => e ? {
    color: "inherit",
    "&:hover, &:active": {
      color: "inherit",
      textDecoration: "underline"
    }
  } : {},
  ({ theme: e, inverse: t }) => t ? {
    color: e.color.lightest,
    ":not([fill])": {
      fill: e.color.lightest
    },
    "&:hover": {
      color: e.color.lighter,
      "svg path:not([fill])": {
        fill: e.color.lighter
      }
    },
    "&:active": {
      color: e.color.light,
      "svg path:not([fill])": {
        fill: e.color.light
      }
    }
  } : {},
  ({ isButton: e }) => e ? {
    border: 0,
    borderRadius: 0,
    background: "none",
    padding: 0,
    fontSize: "inherit"
  } : {}
), qa = /* @__PURE__ */ o(({
  cancel: e = !0,
  children: t,
  onClick: r = void 0,
  withArrow: n = !1,
  containsIcon: a = !1,
  className: i = void 0,
  style: c = void 0,
  ...l
}) => /* @__PURE__ */ Ua.createElement(
  Im,
  {
    ...l,
    onClick: r && e ? (s) => Lm(s, r) : r,
    className: i
  },
  /* @__PURE__ */ Ua.createElement(Am, { withArrow: n, containsIcon: a }, t, n && /* @__PURE__ */ Ua.createElement(p5, null))
), "Link");

// src/components/components/typography/DocumentWrapper.tsx
import { styled as Hm } from "storybook/theming";
var Tm = Hm.div(({ theme: e }) => ({
  fontSize: `${e.typography.size.s2}px`,
  lineHeight: "1.6",
  h1: {
    fontSize: `${e.typography.size.l1}px`,
    fontWeight: e.typography.weight.bold
  },
  h2: {
    fontSize: `${e.typography.size.m2}px`,
    borderBottom: `1px solid ${e.appBorderColor}`
  },
  h3: {
    fontSize: `${e.typography.size.m1}px`
  },
  h4: {
    fontSize: `${e.typography.size.s3}px`
  },
  h5: {
    fontSize: `${e.typography.size.s2}px`
  },
  h6: {
    fontSize: `${e.typography.size.s2}px`,
    color: e.color.dark
  },
  "pre:not(.prismjs)": {
    background: "transparent",
    border: "none",
    borderRadius: 0,
    padding: 0,
    margin: 0
  },
  "pre pre, pre.prismjs": {
    padding: 15,
    margin: 0,
    whiteSpace: "pre-wrap",
    color: "inherit",
    fontSize: "13px",
    lineHeight: "19px"
  },
  "pre pre code, pre.prismjs code": {
    color: "inherit",
    fontSize: "inherit"
  },
  "pre code": {
    margin: 0,
    padding: 0,
    whiteSpace: "pre",
    border: "none",
    background: "transparent"
  },
  "pre code, pre tt": {
    backgroundColor: "transparent",
    border: "none"
  },
  /* GitHub inspired Markdown styles loosely from https://gist.github.com/tuzz/3331384 */
  "body > *:first-of-type": {
    marginTop: "0 !important"
  },
  "body > *:last-child": {
    marginBottom: "0 !important"
  },
  a: {
    color: e.color.secondary,
    textDecoration: "none"
  },
  "a.absent": {
    color: "#cc0000"
  },
  "a.anchor": {
    display: "block",
    paddingLeft: 30,
    marginLeft: -30,
    cursor: "pointer",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0
  },
  "h1, h2, h3, h4, h5, h6": {
    margin: "20px 0 10px",
    padding: 0,
    cursor: "text",
    position: "relative",
    "&:first-of-type": {
      marginTop: 0,
      paddingTop: 0
    },
    "&:hover a.anchor": {
      textDecoration: "none"
    },
    "& tt, & code": {
      fontSize: "inherit"
    }
  },
  "h1:first-of-type + h2": {
    marginTop: 0,
    paddingTop: 0
  },
  "p, blockquote, ul, ol, dl, li, table, pre": {
    margin: "15px 0"
  },
  hr: {
    border: "0 none",
    borderTop: `1px solid ${e.appBorderColor}`,
    height: 4,
    padding: 0
  },
  "body > h1:first-of-type, body > h2:first-of-type, body > h3:first-of-type, body > h4:first-of-type, body > h5:first-of-type, body > h6:fi\
rst-of-type": {
    marginTop: 0,
    paddingTop: 0
  },
  "body > h1:first-of-type + h2": {
    marginTop: 0,
    paddingTop: 0
  },
  "a:first-of-type h1, a:first-of-type h2, a:first-of-type h3, a:first-of-type h4, a:first-of-type h5, a:first-of-type h6": {
    marginTop: 0,
    paddingTop: 0
  },
  "h1 p, h2 p, h3 p, h4 p, h5 p, h6 p": {
    marginTop: 0
  },
  "li p.first": {
    display: "inline-block"
  },
  "ul, ol": {
    paddingLeft: 30,
    "& :first-of-type": {
      marginTop: 0
    },
    "& :last-child": {
      marginBottom: 0
    }
  },
  dl: {
    padding: 0
  },
  "dl dt": {
    fontSize: "14px",
    fontWeight: "bold",
    fontStyle: "italic",
    margin: "0 0 15px",
    padding: "0 15px",
    "&:first-of-type": {
      padding: 0
    },
    "& > :first-of-type": {
      marginTop: 0
    },
    "& > :last-child": {
      marginBottom: 0
    }
  },
  blockquote: {
    borderLeft: `4px solid ${e.color.medium}`,
    padding: "0 15px",
    color: e.color.dark,
    "& > :first-of-type": {
      marginTop: 0
    },
    "& > :last-child": {
      marginBottom: 0
    }
  },
  table: {
    padding: 0,
    borderCollapse: "collapse",
    "& tr": {
      borderTop: `1px solid ${e.appBorderColor}`,
      backgroundColor: "white",
      margin: 0,
      padding: 0,
      "& th": {
        fontWeight: "bold",
        border: `1px solid ${e.appBorderColor}`,
        textAlign: "left",
        margin: 0,
        padding: "6px 13px"
      },
      "& td": {
        border: `1px solid ${e.appBorderColor}`,
        textAlign: "left",
        margin: 0,
        padding: "6px 13px"
      },
      "&:nth-of-type(2n)": {
        backgroundColor: e.color.lighter
      },
      "& th :first-of-type, & td :first-of-type": {
        marginTop: 0
      },
      "& th :last-child, & td :last-child": {
        marginBottom: 0
      }
    }
  },
  img: {
    maxWidth: "100%"
  },
  "span.frame": {
    display: "block",
    overflow: "hidden",
    "& > span": {
      border: `1px solid ${e.color.medium}`,
      display: "block",
      float: "left",
      overflow: "hidden",
      margin: "13px 0 0",
      padding: 7,
      width: "auto"
    },
    "& span img": {
      display: "block",
      float: "left"
    },
    "& span span": {
      clear: "both",
      color: e.color.darkest,
      display: "block",
      padding: "5px 0 0"
    }
  },
  "span.align-center": {
    display: "block",
    overflow: "hidden",
    clear: "both",
    "& > span": {
      display: "block",
      overflow: "hidden",
      margin: "13px auto 0",
      textAlign: "center"
    },
    "& span img": {
      margin: "0 auto",
      textAlign: "center"
    }
  },
  "span.align-right": {
    display: "block",
    overflow: "hidden",
    clear: "both",
    "& > span": {
      display: "block",
      overflow: "hidden",
      margin: "13px 0 0",
      textAlign: "right"
    },
    "& span img": {
      margin: 0,
      textAlign: "right"
    }
  },
  "span.float-left": {
    display: "block",
    marginRight: 13,
    overflow: "hidden",
    float: "left",
    "& span": {
      margin: "13px 0 0"
    }
  },
  "span.float-right": {
    display: "block",
    marginLeft: 13,
    overflow: "hidden",
    float: "right",
    "& > span": {
      display: "block",
      overflow: "hidden",
      margin: "13px auto 0",
      textAlign: "right"
    }
  },
  "code, tt": {
    margin: "0 2px",
    padding: "0 5px",
    whiteSpace: "nowrap",
    border: `1px solid ${e.color.mediumlight}`,
    backgroundColor: e.color.lighter,
    borderRadius: 3,
    color: e.base === "dark" ? e.color.darkest : e.color.dark
  }
}));

// src/components/components/syntaxhighlighter/lazy-syntaxhighlighter.tsx
import fr, { Suspense as Pm, lazy as x5 } from "react";
var Bt = [], dr = null, km = x5(async () => {
  let { SyntaxHighlighter: e } = await Promise.resolve().then(() => (Xr(), Ca));
  return Bt.length > 0 && (Bt.forEach((t) => {
    e.registerLanguage(...t);
  }), Bt = []), dr === null && (dr = e), {
    default: /* @__PURE__ */ o((t) => /* @__PURE__ */ fr.createElement(e, { ...t }), "default")
  };
}), Bm = x5(async () => {
  let [{ SyntaxHighlighter: e }, { formatter: t }] = await Promise.all([
    Promise.resolve().then(() => (Xr(), Ca)),
    Promise.resolve().then(() => (R5(), w5))
  ]);
  return Bt.length > 0 && (Bt.forEach((r) => {
    e.registerLanguage(...r);
  }), Bt = []), dr === null && (dr = e), {
    default: /* @__PURE__ */ o((r) => /* @__PURE__ */ fr.createElement(e, { ...r, formatter: t }), "default")
  };
}), b5 = /* @__PURE__ */ o((e) => /* @__PURE__ */ fr.createElement(Pm, { fallback: /* @__PURE__ */ fr.createElement("div", null) }, e.format !==
!1 ? /* @__PURE__ */ fr.createElement(Bm, { ...e }) : /* @__PURE__ */ fr.createElement(km, { ...e })), "SyntaxHighlighter");
b5.registerLanguage = (...e) => {
  if (dr !== null) {
    dr.registerLanguage(...e);
    return;
  }
  Bt.push(e);
};

// src/components/index.ts
Xr();
va();

// src/components/components/Modal/Modal.tsx
import wr from "react";

// ../node_modules/@radix-ui/react-dialog/dist/index.mjs
var Yn = {};
Nr(Yn, {
  Close: () => Oi,
  Content: () => Pi,
  Description: () => Bi,
  Dialog: () => Ri,
  DialogClose: () => Ai,
  DialogContent: () => Ci,
  DialogDescription: () => Li,
  DialogOverlay: () => Ei,
  DialogPortal: () => yi,
  DialogTitle: () => Mi,
  DialogTrigger: () => xi,
  Overlay: () => zi,
  Portal: () => Ti,
  Root: () => Hi,
  Title: () => ki,
  Trigger: () => qh,
  WarningProvider: () => Wh,
  createDialogScope: () => Oh
});
In();
lt();
import * as U from "react";

// ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-context/dist/index.mjs
import * as $e from "react";
import { jsx as y5 } from "react/jsx-runtime";
function E5(e, t) {
  let r = $e.createContext(t), n = /* @__PURE__ */ o((i) => {
    let { children: c, ...l } = i, s = $e.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ y5(r.Provider, { value: s, children: c });
  }, "Provider");
  n.displayName = e + "Provider";
  function a(i) {
    let c = $e.useContext(r);
    if (c) return c;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return o(a, "useContext2"), [n, a];
}
o(E5, "createContext2");
function C5(e, t = []) {
  let r = [];
  function n(i, c) {
    let l = $e.createContext(c), s = r.length;
    r = [...r, c];
    let u = /* @__PURE__ */ o((d) => {
      let { scope: m, children: g, ...x } = d, p = m?.[e]?.[s] || l, h = $e.useMemo(() => x, Object.values(x));
      return /* @__PURE__ */ y5(p.Provider, { value: h, children: g });
    }, "Provider");
    u.displayName = i + "Provider";
    function f(d, m) {
      let g = m?.[e]?.[s] || l, x = $e.useContext(g);
      if (x) return x;
      if (c !== void 0) return c;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return o(f, "useContext2"), [u, f];
  }
  o(n, "createContext3");
  let a = /* @__PURE__ */ o(() => {
    let i = r.map((c) => $e.createContext(c));
    return /* @__PURE__ */ o(function(l) {
      let s = l?.[e] || i;
      return $e.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: s } }),
        [l, s]
      );
    }, "useScope");
  }, "createScope");
  return a.scopeName = e, [n, Om(a, ...t)];
}
o(C5, "createContextScope");
function Om(...e) {
  let t = e[0];
  if (e.length === 1) return t;
  let r = /* @__PURE__ */ o(() => {
    let n = e.map((a) => ({
      useScope: a(),
      scopeName: a.scopeName
    }));
    return /* @__PURE__ */ o(function(i) {
      let c = n.reduce((l, { useScope: s, scopeName: u }) => {
        let d = s(i)[`__scope${u}`];
        return { ...l, ...d };
      }, {});
      return $e.useMemo(() => ({ [`__scope${t.scopeName}`]: c }), [c]);
    }, "useComposedScopes");
  }, "createScope");
  return r.scopeName = t.scopeName, r;
}
o(Om, "composeContextScopes");

// ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-id/dist/index.mjs
ar();
import * as Dn from "react";
var Nm = Dn.useId || (() => {
}), Dm = 0;
function _n(e) {
  let [t, r] = Dn.useState(Nm());
  return Ve(() => {
    e || r((n) => n ?? String(Dm++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
o(_n, "useId");

// ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
cr();
import * as gt from "react";
function S5({
  prop: e,
  defaultProp: t,
  onChange: r = /* @__PURE__ */ o(() => {
  }, "onChange")
}) {
  let [n, a] = _m({ defaultProp: t, onChange: r }), i = e !== void 0, c = i ? e : n, l = le(r), s = gt.useCallback(
    (u) => {
      if (i) {
        let d = typeof u == "function" ? u(e) : u;
        d !== e && l(d);
      } else
        a(u);
    },
    [i, e, a, l]
  );
  return [c, s];
}
o(S5, "useControllableState");
function _m({
  defaultProp: e,
  onChange: t
}) {
  let r = gt.useState(e), [n] = r, a = gt.useRef(n), i = le(t);
  return gt.useEffect(() => {
    a.current !== n && (i(n), a.current = n);
  }, [n, a, i]), r;
}
o(_m, "useUncontrolledState");

// ../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
In();
or();
lt();
cr();
import * as J from "react";

// ../node_modules/@radix-ui/react-use-escape-keydown/dist/index.mjs
cr();
import * as M5 from "react";
function L5(e, t = globalThis?.document) {
  let r = le(e);
  M5.useEffect(() => {
    let n = /* @__PURE__ */ o((a) => {
      a.key === "Escape" && r(a);
    }, "handleKeyDown");
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
o(L5, "useEscapeKeydown");

// ../node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
import { jsx as H5 } from "react/jsx-runtime";
var Fm = "DismissableLayer", Ga = "dismissableLayer.update", Vm = "dismissableLayer.pointerDownOutside", Wm = "dismissableLayer.focusOutside",
A5, T5 = J.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Xa = J.forwardRef(
  (e, t) => {
    let {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: a,
      onFocusOutside: i,
      onInteractOutside: c,
      onDismiss: l,
      ...s
    } = e, u = J.useContext(T5), [f, d] = J.useState(null), m = f?.ownerDocument ?? globalThis?.document, [, g] = J.useState({}), x = oe(t, (C) => d(
    C)), p = Array.from(u.layers), [h] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = p.indexOf(h), w = f ? p.indexOf(f) : -1,
    R = u.layersWithOutsidePointerEventsDisabled.size > 0, y = w >= v, E = Um((C) => {
      let L = C.target, M = [...u.branches].some((A) => A.contains(L));
      !y || M || (a?.(C), c?.(C), C.defaultPrevented || l?.());
    }, m), b = qm((C) => {
      let L = C.target;
      [...u.branches].some((A) => A.contains(L)) || (i?.(C), c?.(C), C.defaultPrevented || l?.());
    }, m);
    return L5((C) => {
      w === u.layers.size - 1 && (n?.(C), !C.defaultPrevented && l && (C.preventDefault(), l()));
    }, m), J.useEffect(() => {
      if (f)
        return r && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (A5 = m.body.style.pointerEvents, m.body.style.pointerEvents = "\
none"), u.layersWithOutsidePointerEventsDisabled.add(f)), u.layers.add(f), I5(), () => {
          r && u.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = A5);
        };
    }, [f, m, r, u]), J.useEffect(() => () => {
      f && (u.layers.delete(f), u.layersWithOutsidePointerEventsDisabled.delete(f), I5());
    }, [f, u]), J.useEffect(() => {
      let C = /* @__PURE__ */ o(() => g({}), "handleUpdate");
      return document.addEventListener(Ga, C), () => document.removeEventListener(Ga, C);
    }, []), /* @__PURE__ */ H5(
      ie.div,
      {
        ...s,
        ref: x,
        style: {
          pointerEvents: R ? y ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: de(e.onFocusCapture, b.onFocusCapture),
        onBlurCapture: de(e.onBlurCapture, b.onBlurCapture),
        onPointerDownCapture: de(
          e.onPointerDownCapture,
          E.onPointerDownCapture
        )
      }
    );
  }
);
Xa.displayName = Fm;
var $m = "DismissableLayerBranch", jm = J.forwardRef((e, t) => {
  let r = J.useContext(T5), n = J.useRef(null), a = oe(t, n);
  return J.useEffect(() => {
    let i = n.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ H5(ie.div, { ...e, ref: a });
});
jm.displayName = $m;
function Um(e, t = globalThis?.document) {
  let r = le(e), n = J.useRef(!1), a = J.useRef(() => {
  });
  return J.useEffect(() => {
    let i = /* @__PURE__ */ o((l) => {
      if (l.target && !n.current) {
        let u = /* @__PURE__ */ o(function() {
          z5(
            Vm,
            r,
            f,
            { discrete: !0 }
          );
        }, "handleAndDispatchPointerDownOutsideEvent2");
        var s = u;
        let f = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = u, t.addEventListener("click", a.current, { once: !0 })) :
        u();
      } else
        t.removeEventListener("click", a.current);
      n.current = !1;
    }, "handlePointerDown"), c = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: /* @__PURE__ */ o(() => n.current = !0, "onPointerDownCapture")
  };
}
o(Um, "usePointerDownOutside");
function qm(e, t = globalThis?.document) {
  let r = le(e), n = J.useRef(!1);
  return J.useEffect(() => {
    let a = /* @__PURE__ */ o((i) => {
      i.target && !n.current && z5(Wm, r, { originalEvent: i }, {
        discrete: !1
      });
    }, "handleFocus");
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [t, r]), {
    onFocusCapture: /* @__PURE__ */ o(() => n.current = !0, "onFocusCapture"),
    onBlurCapture: /* @__PURE__ */ o(() => n.current = !1, "onBlurCapture")
  };
}
o(qm, "useFocusOutside");
function I5() {
  let e = new CustomEvent(Ga);
  document.dispatchEvent(e);
}
o(I5, "dispatchUpdate");
function z5(e, t, r, { discrete: n }) {
  let a = r.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && a.addEventListener(e, t, { once: !0 }), n ? Es(a, i) : a.dispatchEvent(i);
}
o(z5, "handleAndDispatchCustomEvent");

// ../node_modules/@radix-ui/react-focus-scope/dist/index.mjs
lt();
or();
cr();
import * as je from "react";
import { jsx as Gm } from "react/jsx-runtime";
var Za = "focusScope.autoFocusOnMount", Ya = "focusScope.autoFocusOnUnmount", P5 = { bubbles: !1, cancelable: !0 }, Xm = "FocusScope", Ka = je.forwardRef(
(e, t) => {
  let {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: a,
    onUnmountAutoFocus: i,
    ...c
  } = e, [l, s] = je.useState(null), u = le(a), f = le(i), d = je.useRef(null), m = oe(t, (p) => s(p)), g = je.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  je.useEffect(() => {
    if (n) {
      let w = /* @__PURE__ */ o(function(b) {
        if (g.paused || !l) return;
        let C = b.target;
        l.contains(C) ? d.current = C : wt(d.current, { select: !0 });
      }, "handleFocusIn2"), R = /* @__PURE__ */ o(function(b) {
        if (g.paused || !l) return;
        let C = b.relatedTarget;
        C !== null && (l.contains(C) || wt(d.current, { select: !0 }));
      }, "handleFocusOut2"), y = /* @__PURE__ */ o(function(b) {
        if (document.activeElement === document.body)
          for (let L of b)
            L.removedNodes.length > 0 && wt(l);
      }, "handleMutations2");
      var p = w, h = R, v = y;
      document.addEventListener("focusin", w), document.addEventListener("focusout", R);
      let E = new MutationObserver(y);
      return l && E.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", w), document.removeEventListener("focusout", R), E.disconnect();
      };
    }
  }, [n, l, g.paused]), je.useEffect(() => {
    if (l) {
      B5.add(g);
      let p = document.activeElement;
      if (!l.contains(p)) {
        let v = new CustomEvent(Za, P5);
        l.addEventListener(Za, u), l.dispatchEvent(v), v.defaultPrevented || (Zm(eh(N5(l)), { select: !0 }), document.activeElement === p &&
        wt(l));
      }
      return () => {
        l.removeEventListener(Za, u), setTimeout(() => {
          let v = new CustomEvent(Ya, P5);
          l.addEventListener(Ya, f), l.dispatchEvent(v), v.defaultPrevented || wt(p ?? document.body, { select: !0 }), l.removeEventListener(
          Ya, f), B5.remove(g);
        }, 0);
      };
    }
  }, [l, u, f, g]);
  let x = je.useCallback(
    (p) => {
      if (!r && !n || g.paused) return;
      let h = p.key === "Tab" && !p.altKey && !p.ctrlKey && !p.metaKey, v = document.activeElement;
      if (h && v) {
        let w = p.currentTarget, [R, y] = Ym(w);
        R && y ? !p.shiftKey && v === y ? (p.preventDefault(), r && wt(R, { select: !0 })) : p.shiftKey && v === R && (p.preventDefault(), r &&
        wt(y, { select: !0 })) : v === w && p.preventDefault();
      }
    },
    [r, n, g.paused]
  );
  return /* @__PURE__ */ Gm(ie.div, { tabIndex: -1, ...c, ref: m, onKeyDown: x });
});
Ka.displayName = Xm;
function Zm(e, { select: t = !1 } = {}) {
  let r = document.activeElement;
  for (let n of e)
    if (wt(n, { select: t }), document.activeElement !== r) return;
}
o(Zm, "focusFirst");
function Ym(e) {
  let t = N5(e), r = k5(t, e), n = k5(t.reverse(), e);
  return [r, n];
}
o(Ym, "getTabbableEdges");
function N5(e) {
  let t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: /* @__PURE__ */ o((n) => {
      let a = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || a ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }, "acceptNode")
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
o(N5, "getTabbableCandidates");
function k5(e, t) {
  for (let r of e)
    if (!Km(r, { upTo: t })) return r;
}
o(k5, "findVisible");
function Km(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
o(Km, "isHidden");
function Jm(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
o(Jm, "isSelectableInput");
function wt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    let r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Jm(e) && t && e.select();
  }
}
o(wt, "focus");
var B5 = Qm();
function Qm() {
  let e = [];
  return {
    add(t) {
      let r = e[0];
      t !== r && r?.pause(), e = O5(e, t), e.unshift(t);
    },
    remove(t) {
      e = O5(e, t), e[0]?.resume();
    }
  };
}
o(Qm, "createFocusScopesStack");
function O5(e, t) {
  let r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
o(O5, "arrayRemove");
function eh(e) {
  return e.filter((t) => t.tagName !== "A");
}
o(eh, "removeLinks");

// ../node_modules/@radix-ui/react-portal/dist/index.mjs
or();
ar();
import * as Fn from "react";
import th from "react-dom";
import { jsx as rh } from "react/jsx-runtime";
var nh = "Portal", Ja = Fn.forwardRef((e, t) => {
  let { container: r, ...n } = e, [a, i] = Fn.useState(!1);
  Ve(() => i(!0), []);
  let c = r || a && globalThis?.document?.body;
  return c ? th.createPortal(/* @__PURE__ */ rh(ie.div, { ...n, ref: t }), c) : null;
});
Ja.displayName = nh;

// ../node_modules/@radix-ui/react-presence/dist/index.mjs
lt();
ar();
import * as ze from "react";
import * as D5 from "react";
function oh(e, t) {
  return D5.useReducer((r, n) => t[r][n] ?? r, e);
}
o(oh, "useStateMachine");
var Yr = /* @__PURE__ */ o((e) => {
  let { present: t, children: r } = e, n = ah(t), a = typeof r == "function" ? r({ present: n.isPresent }) : ze.Children.only(r), i = oe(n.ref,
  ih(a));
  return typeof r == "function" || n.isPresent ? ze.cloneElement(a, { ref: i }) : null;
}, "Presence");
Yr.displayName = "Presence";
function ah(e) {
  let [t, r] = ze.useState(), n = ze.useRef({}), a = ze.useRef(e), i = ze.useRef("none"), c = e ? "mounted" : "unmounted", [l, s] = oh(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return ze.useEffect(() => {
    let u = Vn(n.current);
    i.current = l === "mounted" ? u : "none";
  }, [l]), Ve(() => {
    let u = n.current, f = a.current;
    if (f !== e) {
      let m = i.current, g = Vn(u);
      e ? s("MOUNT") : g === "none" || u?.display === "none" ? s("UNMOUNT") : s(f && m !== g ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [e, s]), Ve(() => {
    if (t) {
      let u, f = t.ownerDocument.defaultView ?? window, d = /* @__PURE__ */ o((g) => {
        let p = Vn(n.current).includes(g.animationName);
        if (g.target === t && p && (s("ANIMATION_END"), !a.current)) {
          let h = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = f.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = h);
          });
        }
      }, "handleAnimationEnd"), m = /* @__PURE__ */ o((g) => {
        g.target === t && (i.current = Vn(n.current));
      }, "handleAnimationStart");
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        f.clearTimeout(u), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", d), t.removeEventListener("a\
nimationend", d);
      };
    } else
      s("ANIMATION_END");
  }, [t, s]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: ze.useCallback((u) => {
      u && (n.current = getComputedStyle(u)), r(u);
    }, [])
  };
}
o(ah, "usePresence");
function Vn(e) {
  return e?.animationName || "none";
}
o(Vn, "getAnimationName");
function ih(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref :
  e.props.ref || e.ref);
}
o(ih, "getElementRef");

// ../node_modules/@radix-ui/react-dialog/dist/index.mjs
or();

// ../node_modules/@radix-ui/react-focus-guards/dist/index.mjs
import * as F5 from "react";
var Qa = 0;
function V5() {
  F5.useEffect(() => {
    let e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? _5()), document.body.insertAdjacentElement("beforeend", e[1] ?? _5()), Qa++,
    () => {
      Qa === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Qa--;
    };
  }, []);
}
o(V5, "useFocusGuards");
function _5() {
  let e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "\
fixed", e.style.pointerEvents = "none", e;
}
o(_5, "createFocusGuard");

// ../node_modules/tslib/tslib.es6.mjs
var Pe = /* @__PURE__ */ o(function() {
  return Pe = Object.assign || /* @__PURE__ */ o(function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, "__assign"), Pe.apply(this, arguments);
}, "__assign");
function Wn(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
o(Wn, "__rest");
function W5(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, a = t.length, i; n < a; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
o(W5, "__spreadArray");

// ../node_modules/react-remove-scroll/dist/es2015/Combination.js
import * as qn from "react";

// ../node_modules/react-remove-scroll/dist/es2015/UI.js
import * as be from "react";

// ../node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var Ot = "right-scroll-bar-position", Nt = "width-before-scroll-bar", ei = "with-scroll-bars-hidden", ti = "--removed-body-scroll-bar-size";

// ../node_modules/use-callback-ref/dist/es2015/assignRef.js
function $n(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
o($n, "assignRef");

// ../node_modules/use-callback-ref/dist/es2015/useRef.js
import { useState as lh } from "react";
function $5(e, t) {
  var r = lh(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var a = r.value;
          a !== n && (r.value = n, r.callback(n, a));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
o($5, "useCallbackRef");

// ../node_modules/use-callback-ref/dist/es2015/useMergeRef.js
import * as U5 from "react";
var j5 = /* @__PURE__ */ new WeakMap();
function ri(e, t) {
  var r = $5(t || null, function(n) {
    return e.forEach(function(a) {
      return $n(a, n);
    });
  });
  return U5.useLayoutEffect(function() {
    var n = j5.get(r);
    if (n) {
      var a = new Set(n), i = new Set(e), c = r.current;
      a.forEach(function(l) {
        i.has(l) || $n(l, null);
      }), i.forEach(function(l) {
        a.has(l) || $n(l, c);
      });
    }
    j5.set(r, e);
  }, [e]), r;
}
o(ri, "useMergeRefs");

// ../node_modules/use-sidecar/dist/es2015/medium.js
function ch(e) {
  return e;
}
o(ch, "ItoI");
function sh(e, t) {
  t === void 0 && (t = ch);
  var r = [], n = !1, a = {
    read: /* @__PURE__ */ o(function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    }, "read"),
    useMedium: /* @__PURE__ */ o(function(i) {
      var c = t(i, n);
      return r.push(c), function() {
        r = r.filter(function(l) {
          return l !== c;
        });
      };
    }, "useMedium"),
    assignSyncMedium: /* @__PURE__ */ o(function(i) {
      for (n = !0; r.length; ) {
        var c = r;
        r = [], c.forEach(i);
      }
      r = {
        push: /* @__PURE__ */ o(function(l) {
          return i(l);
        }, "push"),
        filter: /* @__PURE__ */ o(function() {
          return r;
        }, "filter")
      };
    }, "assignSyncMedium"),
    assignMedium: /* @__PURE__ */ o(function(i) {
      n = !0;
      var c = [];
      if (r.length) {
        var l = r;
        r = [], l.forEach(i), c = r;
      }
      var s = /* @__PURE__ */ o(function() {
        var f = c;
        c = [], f.forEach(i);
      }, "executeQueue"), u = /* @__PURE__ */ o(function() {
        return Promise.resolve().then(s);
      }, "cycle");
      u(), r = {
        push: /* @__PURE__ */ o(function(f) {
          c.push(f), u();
        }, "push"),
        filter: /* @__PURE__ */ o(function(f) {
          return c = c.filter(f), r;
        }, "filter")
      };
    }, "assignMedium")
  };
  return a;
}
o(sh, "innerCreateMedium");
function ni(e) {
  e === void 0 && (e = {});
  var t = sh(null);
  return t.options = Pe({ async: !0, ssr: !1 }, e), t;
}
o(ni, "createSidecarMedium");

// ../node_modules/use-sidecar/dist/es2015/exports.js
import * as q5 from "react";
var G5 = /* @__PURE__ */ o(function(e) {
  var t = e.sideCar, r = Wn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return q5.createElement(n, Pe({}, r));
}, "SideCar");
G5.isSideCarExport = !0;
function oi(e, t) {
  return e.useMedium(t), G5;
}
o(oi, "exportSidecar");

// ../node_modules/react-remove-scroll/dist/es2015/medium.js
var jn = ni();

// ../node_modules/react-remove-scroll/dist/es2015/UI.js
var ai = /* @__PURE__ */ o(function() {
}, "nothing"), Kr = be.forwardRef(function(e, t) {
  var r = be.useRef(null), n = be.useState({
    onScrollCapture: ai,
    onWheelCapture: ai,
    onTouchMoveCapture: ai
  }), a = n[0], i = n[1], c = e.forwardProps, l = e.children, s = e.className, u = e.removeScrollBar, f = e.enabled, d = e.shards, m = e.sideCar,
  g = e.noIsolation, x = e.inert, p = e.allowPinchZoom, h = e.as, v = h === void 0 ? "div" : h, w = e.gapMode, R = Wn(e, ["forwardProps", "c\
hildren", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), y = m,
  E = ri([r, t]), b = Pe(Pe({}, R), a);
  return be.createElement(
    be.Fragment,
    null,
    f && be.createElement(y, { sideCar: jn, removeScrollBar: u, shards: d, noIsolation: g, inert: x, setCallbacks: i, allowPinchZoom: !!p, lockRef: r,
    gapMode: w }),
    c ? be.cloneElement(be.Children.only(l), Pe(Pe({}, b), { ref: E })) : be.createElement(v, Pe({}, b, { className: s, ref: E }), l)
  );
});
Kr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Kr.classNames = {
  fullWidth: Nt,
  zeroRight: Ot
};

// ../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
import * as X from "react";

// ../node_modules/react-remove-scroll-bar/dist/es2015/component.js
import * as mr from "react";

// ../node_modules/react-style-singleton/dist/es2015/hook.js
import * as Y5 from "react";

// ../node_modules/get-nonce/dist/es2015/index.js
var X5;
var Z5 = /* @__PURE__ */ o(function() {
  if (X5)
    return X5;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
}, "getNonce");

// ../node_modules/react-style-singleton/dist/es2015/singleton.js
function uh() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Z5();
  return t && e.setAttribute("nonce", t), e;
}
o(uh, "makeStyleTag");
function fh(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
o(fh, "injectStyles");
function dh(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
o(dh, "insertStyleTag");
var ii = /* @__PURE__ */ o(function() {
  var e = 0, t = null;
  return {
    add: /* @__PURE__ */ o(function(r) {
      e == 0 && (t = uh()) && (fh(t, r), dh(t)), e++;
    }, "add"),
    remove: /* @__PURE__ */ o(function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }, "remove")
  };
}, "stylesheetSingleton");

// ../node_modules/react-style-singleton/dist/es2015/hook.js
var li = /* @__PURE__ */ o(function() {
  var e = ii();
  return function(t, r) {
    Y5.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, "styleHookSingleton");

// ../node_modules/react-style-singleton/dist/es2015/component.js
var Jr = /* @__PURE__ */ o(function() {
  var e = li(), t = /* @__PURE__ */ o(function(r) {
    var n = r.styles, a = r.dynamic;
    return e(n, a), null;
  }, "Sheet");
  return t;
}, "styleSingleton");

// ../node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var ph = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ci = /* @__PURE__ */ o(function(e) {
  return parseInt(e || "", 10) || 0;
}, "parse"), mh = /* @__PURE__ */ o(function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" :
  "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ci(r), ci(n), ci(a)];
}, "getOffset"), si = /* @__PURE__ */ o(function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ph;
  var t = mh(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, "getGapWidth");

// ../node_modules/react-remove-scroll-bar/dist/es2015/component.js
var hh = Jr(), pr = "data-scroll-locked", vh = /* @__PURE__ */ o(function(e, t, r, n) {
  var a = e.left, i = e.top, c = e.right, l = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(ei, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(l, "px ").concat(n, `;
  }
  body[`).concat(pr, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(c, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(l, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Ot, ` {
    right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(Nt, ` {
    margin-right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(Ot, " .").concat(Ot, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Nt, " .").concat(Nt, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(pr, `] {
    `).concat(ti, ": ").concat(l, `px;
  }
`);
}, "getStyles"), K5 = /* @__PURE__ */ o(function() {
  var e = parseInt(document.body.getAttribute(pr) || "0", 10);
  return isFinite(e) ? e : 0;
}, "getCurrentUseCounter"), gh = /* @__PURE__ */ o(function() {
  mr.useEffect(function() {
    return document.body.setAttribute(pr, (K5() + 1).toString()), function() {
      var e = K5() - 1;
      e <= 0 ? document.body.removeAttribute(pr) : document.body.setAttribute(pr, e.toString());
    };
  }, []);
}, "useLockAttribute"), ui = /* @__PURE__ */ o(function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, a = n === void 0 ? "margin" : n;
  gh();
  var i = mr.useMemo(function() {
    return si(a);
  }, [a]);
  return mr.createElement(hh, { styles: vh(i, !t, a, r ? "" : "!important") });
}, "RemoveScrollBar");

// ../node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var fi = !1;
if (typeof window < "u")
  try {
    Qr = Object.defineProperty({}, "passive", {
      get: /* @__PURE__ */ o(function() {
        return fi = !0, !0;
      }, "get")
    }), window.addEventListener("test", Qr, Qr), window.removeEventListener("test", Qr, Qr);
  } catch {
    fi = !1;
  }
var Qr, Dt = fi ? { passive: !1 } : !1;

// ../node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var wh = /* @__PURE__ */ o(function(e) {
  return e.tagName === "TEXTAREA";
}, "alwaysContainsScroll"), J5 = /* @__PURE__ */ o(function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !wh(e) && r[t] === "visible")
  );
}, "elementCanBeScrolled"), Rh = /* @__PURE__ */ o(function(e) {
  return J5(e, "overflowY");
}, "elementCouldBeVScrolled"), xh = /* @__PURE__ */ o(function(e) {
  return J5(e, "overflowX");
}, "elementCouldBeHScrolled"), di = /* @__PURE__ */ o(function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var a = Q5(e, n);
    if (a) {
      var i = eu(e, n), c = i[1], l = i[2];
      if (c > l)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, "locationCouldBeScrolled"), bh = /* @__PURE__ */ o(function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, "getVScrollVariables"), yh = /* @__PURE__ */ o(function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, "getHScrollVariables"), Q5 = /* @__PURE__ */ o(function(e, t) {
  return e === "v" ? Rh(t) : xh(t);
}, "elementCouldBeScrolled"), eu = /* @__PURE__ */ o(function(e, t) {
  return e === "v" ? bh(t) : yh(t);
}, "getScrollVariables"), Eh = /* @__PURE__ */ o(function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, "getDirectionFactor"), tu = /* @__PURE__ */ o(function(e, t, r, n, a) {
  var i = Eh(e, window.getComputedStyle(t).direction), c = i * n, l = r.target, s = t.contains(l), u = !1, f = c > 0, d = 0, m = 0;
  do {
    var g = eu(e, l), x = g[0], p = g[1], h = g[2], v = p - h - i * x;
    (x || v) && Q5(e, l) && (d += v, m += x), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !s && l !== document.body || // self content
    s && (t.contains(l) || t === l)
  );
  return (f && (a && Math.abs(d) < 1 || !a && c > d) || !f && (a && Math.abs(m) < 1 || !a && -c > m)) && (u = !0), u;
}, "handleScroll");

// ../node_modules/react-remove-scroll/dist/es2015/SideEffect.js
var Un = /* @__PURE__ */ o(function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, "getTouchXY"), ru = /* @__PURE__ */ o(function(e) {
  return [e.deltaX, e.deltaY];
}, "getDeltaXY"), nu = /* @__PURE__ */ o(function(e) {
  return e && "current" in e ? e.current : e;
}, "extractRef"), Ch = /* @__PURE__ */ o(function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, "deltaCompare"), Sh = /* @__PURE__ */ o(function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, "generateStyle"), Mh = 0, hr = [];
function ou(e) {
  var t = X.useRef([]), r = X.useRef([0, 0]), n = X.useRef(), a = X.useState(Mh++)[0], i = X.useState(Jr)[0], c = X.useRef(e);
  X.useEffect(function() {
    c.current = e;
  }, [e]), X.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var p = W5([e.lockRef.current], (e.shards || []).map(nu), !0).filter(Boolean);
      return p.forEach(function(h) {
        return h.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), p.forEach(function(h) {
          return h.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = X.useCallback(function(p, h) {
    if ("touches" in p && p.touches.length === 2 || p.type === "wheel" && p.ctrlKey)
      return !c.current.allowPinchZoom;
    var v = Un(p), w = r.current, R = "deltaX" in p ? p.deltaX : w[0] - v[0], y = "deltaY" in p ? p.deltaY : w[1] - v[1], E, b = p.target, C = Math.
    abs(R) > Math.abs(y) ? "h" : "v";
    if ("touches" in p && C === "h" && b.type === "range")
      return !1;
    var L = di(C, b);
    if (!L)
      return !0;
    if (L ? E = C : (E = C === "v" ? "h" : "v", L = di(C, b)), !L)
      return !1;
    if (!n.current && "changedTouches" in p && (R || y) && (n.current = E), !E)
      return !0;
    var M = n.current || E;
    return tu(M, h, p, M === "h" ? R : y, !0);
  }, []), s = X.useCallback(function(p) {
    var h = p;
    if (!(!hr.length || hr[hr.length - 1] !== i)) {
      var v = "deltaY" in h ? ru(h) : Un(h), w = t.current.filter(function(E) {
        return E.name === h.type && (E.target === h.target || h.target === E.shadowParent) && Ch(E.delta, v);
      })[0];
      if (w && w.should) {
        h.cancelable && h.preventDefault();
        return;
      }
      if (!w) {
        var R = (c.current.shards || []).map(nu).filter(Boolean).filter(function(E) {
          return E.contains(h.target);
        }), y = R.length > 0 ? l(h, R[0]) : !c.current.noIsolation;
        y && h.cancelable && h.preventDefault();
      }
    }
  }, []), u = X.useCallback(function(p, h, v, w) {
    var R = { name: p, delta: h, target: v, should: w, shadowParent: Lh(v) };
    t.current.push(R), setTimeout(function() {
      t.current = t.current.filter(function(y) {
        return y !== R;
      });
    }, 1);
  }, []), f = X.useCallback(function(p) {
    r.current = Un(p), n.current = void 0;
  }, []), d = X.useCallback(function(p) {
    u(p.type, ru(p), p.target, l(p, e.lockRef.current));
  }, []), m = X.useCallback(function(p) {
    u(p.type, Un(p), p.target, l(p, e.lockRef.current));
  }, []);
  X.useEffect(function() {
    return hr.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", s, Dt), document.addEventListener("touchmove", s, Dt), document.addEventListener("touchstart", f,
    Dt), function() {
      hr = hr.filter(function(p) {
        return p !== i;
      }), document.removeEventListener("wheel", s, Dt), document.removeEventListener("touchmove", s, Dt), document.removeEventListener("touc\
hstart", f, Dt);
    };
  }, []);
  var g = e.removeScrollBar, x = e.inert;
  return X.createElement(
    X.Fragment,
    null,
    x ? X.createElement(i, { styles: Sh(a) }) : null,
    g ? X.createElement(ui, { gapMode: e.gapMode }) : null
  );
}
o(ou, "RemoveScrollSideCar");
function Lh(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
o(Lh, "getOutermostShadowParent");

// ../node_modules/react-remove-scroll/dist/es2015/sidecar.js
var au = oi(jn, ou);

// ../node_modules/react-remove-scroll/dist/es2015/Combination.js
var iu = qn.forwardRef(function(e, t) {
  return qn.createElement(Kr, Pe({}, e, { ref: t, sideCar: au }));
});
iu.classNames = Kr.classNames;
var pi = iu;

// ../node_modules/aria-hidden/dist/es2015/index.js
var Ah = /* @__PURE__ */ o(function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, "getDefaultParent"), vr = /* @__PURE__ */ new WeakMap(), Gn = /* @__PURE__ */ new WeakMap(), Xn = {}, mi = 0, lu = /* @__PURE__ */ o(function(e) {
  return e && (e.host || lu(e.parentNode));
}, "unwrapHost"), Ih = /* @__PURE__ */ o(function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = lu(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, "correctTargets"), Hh = /* @__PURE__ */ o(function(e, t, r, n) {
  var a = Ih(t, Array.isArray(e) ? e : [e]);
  Xn[r] || (Xn[r] = /* @__PURE__ */ new WeakMap());
  var i = Xn[r], c = [], l = /* @__PURE__ */ new Set(), s = new Set(a), u = /* @__PURE__ */ o(function(d) {
    !d || l.has(d) || (l.add(d), u(d.parentNode));
  }, "keep");
  a.forEach(u);
  var f = /* @__PURE__ */ o(function(d) {
    !d || s.has(d) || Array.prototype.forEach.call(d.children, function(m) {
      if (l.has(m))
        f(m);
      else {
        var g = m.getAttribute(n), x = g !== null && g !== "false", p = (vr.get(m) || 0) + 1, h = (i.get(m) || 0) + 1;
        vr.set(m, p), i.set(m, h), c.push(m), p === 1 && x && Gn.set(m, !0), h === 1 && m.setAttribute(r, "true"), x || m.setAttribute(n, "t\
rue");
      }
    });
  }, "deep");
  return f(t), l.clear(), mi++, function() {
    c.forEach(function(d) {
      var m = vr.get(d) - 1, g = i.get(d) - 1;
      vr.set(d, m), i.set(d, g), m || (Gn.has(d) || d.removeAttribute(n), Gn.delete(d)), g || d.removeAttribute(r);
    }), mi--, mi || (vr = /* @__PURE__ */ new WeakMap(), vr = /* @__PURE__ */ new WeakMap(), Gn = /* @__PURE__ */ new WeakMap(), Xn = {});
  };
}, "applyAttributeToOthers"), cu = /* @__PURE__ */ o(function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), a = t || Ah(e);
  return a ? (n.push.apply(n, Array.from(a.querySelectorAll("[aria-live]"))), Hh(n, a, r, "aria-hidden")) : function() {
    return null;
  };
}, "hideOthers");

// ../node_modules/@radix-ui/react-dialog/node_modules/@radix-ui/react-slot/dist/index.mjs
lt();
import * as we from "react";
import { Fragment as Th, jsx as hi } from "react/jsx-runtime";
var gi = we.forwardRef((e, t) => {
  let { children: r, ...n } = e, a = we.Children.toArray(r), i = a.find(Ph);
  if (i) {
    let c = i.props.children, l = a.map((s) => s === i ? we.Children.count(c) > 1 ? we.Children.only(null) : we.isValidElement(c) ? c.props.
    children : null : s);
    return /* @__PURE__ */ hi(vi, { ...n, ref: t, children: we.isValidElement(c) ? we.cloneElement(c, void 0, l) : null });
  }
  return /* @__PURE__ */ hi(vi, { ...n, ref: t, children: r });
});
gi.displayName = "Slot";
var vi = we.forwardRef((e, t) => {
  let { children: r, ...n } = e;
  if (we.isValidElement(r)) {
    let a = Bh(r);
    return we.cloneElement(r, {
      ...kh(n, r.props),
      // @ts-ignore
      ref: t ? jr(t, a) : a
    });
  }
  return we.Children.count(r) > 1 ? we.Children.only(null) : null;
});
vi.displayName = "SlotClone";
var zh = /* @__PURE__ */ o(({ children: e }) => /* @__PURE__ */ hi(Th, { children: e }), "Slottable");
function Ph(e) {
  return we.isValidElement(e) && e.type === zh;
}
o(Ph, "isSlottable");
function kh(e, t) {
  let r = { ...t };
  for (let n in t) {
    let a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...l) => {
      i(...l), a(...l);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...i } : n === "className" && (r[n] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
o(kh, "mergeProps");
function Bh(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref :
  e.props.ref || e.ref);
}
o(Bh, "getElementRef");

// ../node_modules/@radix-ui/react-dialog/dist/index.mjs
import { Fragment as su, jsx as te, jsxs as uu } from "react/jsx-runtime";
var wi = "Dialog", [fu, Oh] = C5(wi), [Nh, Ye] = fu(wi), Ri = /* @__PURE__ */ o((e) => {
  let {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: a,
    onOpenChange: i,
    modal: c = !0
  } = e, l = U.useRef(null), s = U.useRef(null), [u = !1, f] = S5({
    prop: n,
    defaultProp: a,
    onChange: i
  });
  return /* @__PURE__ */ te(
    Nh,
    {
      scope: t,
      triggerRef: l,
      contentRef: s,
      contentId: _n(),
      titleId: _n(),
      descriptionId: _n(),
      open: u,
      onOpenChange: f,
      onOpenToggle: U.useCallback(() => f((d) => !d), [f]),
      modal: c,
      children: r
    }
  );
}, "Dialog");
Ri.displayName = wi;
var du = "DialogTrigger", xi = U.forwardRef(
  (e, t) => {
    let { __scopeDialog: r, ...n } = e, a = Ye(du, r), i = oe(t, a.triggerRef);
    return /* @__PURE__ */ te(
      ie.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": a.open,
        "aria-controls": a.contentId,
        "data-state": Ii(a.open),
        ...n,
        ref: i,
        onClick: de(e.onClick, a.onOpenToggle)
      }
    );
  }
);
xi.displayName = du;
var bi = "DialogPortal", [Dh, pu] = fu(bi, {
  forceMount: void 0
}), yi = /* @__PURE__ */ o((e) => {
  let { __scopeDialog: t, forceMount: r, children: n, container: a } = e, i = Ye(bi, t);
  return /* @__PURE__ */ te(Dh, { scope: t, forceMount: r, children: U.Children.map(n, (c) => /* @__PURE__ */ te(Yr, { present: r || i.open,
  children: /* @__PURE__ */ te(Ja, { asChild: !0, container: a, children: c }) })) });
}, "DialogPortal");
yi.displayName = bi;
var Zn = "DialogOverlay", Ei = U.forwardRef(
  (e, t) => {
    let r = pu(Zn, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, i = Ye(Zn, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ te(Yr, { present: n || i.open, children: /* @__PURE__ */ te(_h, { ...a, ref: t }) }) : null;
  }
);
Ei.displayName = Zn;
var _h = U.forwardRef(
  (e, t) => {
    let { __scopeDialog: r, ...n } = e, a = Ye(Zn, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ te(pi, { as: gi, allowPinchZoom: !0, shards: [a.contentRef], children: /* @__PURE__ */ te(
        ie.div,
        {
          "data-state": Ii(a.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), _t = "DialogContent", Ci = U.forwardRef(
  (e, t) => {
    let r = pu(_t, e.__scopeDialog), { forceMount: n = r.forceMount, ...a } = e, i = Ye(_t, e.__scopeDialog);
    return /* @__PURE__ */ te(Yr, { present: n || i.open, children: i.modal ? /* @__PURE__ */ te(Fh, { ...a, ref: t }) : /* @__PURE__ */ te(
    Vh, { ...a, ref: t }) });
  }
);
Ci.displayName = _t;
var Fh = U.forwardRef(
  (e, t) => {
    let r = Ye(_t, e.__scopeDialog), n = U.useRef(null), a = oe(t, r.contentRef, n);
    return U.useEffect(() => {
      let i = n.current;
      if (i) return cu(i);
    }, []), /* @__PURE__ */ te(
      mu,
      {
        ...e,
        ref: a,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: de(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: de(e.onPointerDownOutside, (i) => {
          let c = i.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0;
          (c.button === 2 || l) && i.preventDefault();
        }),
        onFocusOutside: de(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), Vh = U.forwardRef(
  (e, t) => {
    let r = Ye(_t, e.__scopeDialog), n = U.useRef(!1), a = U.useRef(!1);
    return /* @__PURE__ */ te(
      mu,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: /* @__PURE__ */ o((i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (n.current || r.triggerRef.current?.focus(), i.preventDefault()), n.current = !1, a.
          current = !1;
        }, "onCloseAutoFocus"),
        onInteractOutside: /* @__PURE__ */ o((i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (a.current = !0));
          let c = i.target;
          r.triggerRef.current?.contains(c) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && a.current && i.preventDefault();
        }, "onInteractOutside")
      }
    );
  }
), mu = U.forwardRef(
  (e, t) => {
    let { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: a, onCloseAutoFocus: i, ...c } = e, l = Ye(_t, r), s = U.useRef(null), u = oe(t, s);
    return V5(), /* @__PURE__ */ uu(su, { children: [
      /* @__PURE__ */ te(
        Ka,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: a,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ te(
            Xa,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": Ii(l.open),
              ...c,
              ref: u,
              onDismiss: /* @__PURE__ */ o(() => l.onOpenChange(!1), "onDismiss")
            }
          )
        }
      ),
      /* @__PURE__ */ uu(su, { children: [
        /* @__PURE__ */ te($h, { titleId: l.titleId }),
        /* @__PURE__ */ te(Uh, { contentRef: s, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), Si = "DialogTitle", Mi = U.forwardRef(
  (e, t) => {
    let { __scopeDialog: r, ...n } = e, a = Ye(Si, r);
    return /* @__PURE__ */ te(ie.h2, { id: a.titleId, ...n, ref: t });
  }
);
Mi.displayName = Si;
var hu = "DialogDescription", Li = U.forwardRef(
  (e, t) => {
    let { __scopeDialog: r, ...n } = e, a = Ye(hu, r);
    return /* @__PURE__ */ te(ie.p, { id: a.descriptionId, ...n, ref: t });
  }
);
Li.displayName = hu;
var vu = "DialogClose", Ai = U.forwardRef(
  (e, t) => {
    let { __scopeDialog: r, ...n } = e, a = Ye(vu, r);
    return /* @__PURE__ */ te(
      ie.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: de(e.onClick, () => a.onOpenChange(!1))
      }
    );
  }
);
Ai.displayName = vu;
function Ii(e) {
  return e ? "open" : "closed";
}
o(Ii, "getState");
var gu = "DialogTitleWarning", [Wh, wu] = E5(gu, {
  contentName: _t,
  titleName: Si,
  docsSlug: "dialog"
}), $h = /* @__PURE__ */ o(({ titleId: e }) => {
  let t = wu(gu), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return U.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, "TitleWarning"), jh = "DialogDescriptionWarning", Uh = /* @__PURE__ */ o(({ contentRef: e, descriptionId: t }) => {
  let n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${wu(jh).contentName}}.`;
  return U.useEffect(() => {
    let a = e.current?.getAttribute("aria-describedby");
    t && a && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, "DescriptionWarning"), Hi = Ri, qh = xi, Ti = yi, zi = Ei, Pi = Ci, ki = Mi, Bi = Li, Oi = Ai;

// src/components/components/Modal/Modal.styled.tsx
var $i = {};
Nr($i, {
  Actions: () => mv,
  CloseButton: () => Su,
  Col: () => Lu,
  Container: () => Wi,
  Content: () => uv,
  Description: () => pv,
  Error: () => hv,
  ErrorWrapper: () => Au,
  Header: () => fv,
  Overlay: () => Vi,
  Row: () => Mu,
  Title: () => dv
});
import Rt from "react";
import { keyframes as Fi, styled as st } from "storybook/theming";

// src/components/components/IconButton/IconButton.tsx
import iv, { forwardRef as lv } from "react";

// src/components/components/Button/Button.tsx
import Qh, { forwardRef as ev, useEffect as tv, useState as rv } from "react";

// ../node_modules/@radix-ui/react-slot/dist/index.mjs
import * as ce from "react";

// ../node_modules/@radix-ui/react-slot/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
import * as Gh from "react";
function Ru(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
o(Ru, "setRef");
function xu(...e) {
  return (t) => {
    let r = !1, n = e.map((a) => {
      let i = Ru(a, t);
      return !r && typeof i == "function" && (r = !0), i;
    });
    if (r)
      return () => {
        for (let a = 0; a < n.length; a++) {
          let i = n[a];
          typeof i == "function" ? i() : Ru(e[a], null);
        }
      };
  };
}
o(xu, "composeRefs");

// ../node_modules/@radix-ui/react-slot/dist/index.mjs
import { Fragment as Xh, jsx as Ni } from "react/jsx-runtime";
var _i = ce.forwardRef((e, t) => {
  let { children: r, ...n } = e, a = ce.Children.toArray(r), i = a.find(Yh);
  if (i) {
    let c = i.props.children, l = a.map((s) => s === i ? ce.Children.count(c) > 1 ? ce.Children.only(null) : ce.isValidElement(c) ? c.props.
    children : null : s);
    return /* @__PURE__ */ Ni(Di, { ...n, ref: t, children: ce.isValidElement(c) ? ce.cloneElement(c, void 0, l) : null });
  }
  return /* @__PURE__ */ Ni(Di, { ...n, ref: t, children: r });
});
_i.displayName = "Slot";
var Di = ce.forwardRef((e, t) => {
  let { children: r, ...n } = e;
  if (ce.isValidElement(r)) {
    let a = Jh(r), i = Kh(n, r.props);
    return r.type !== ce.Fragment && (i.ref = t ? xu(t, a) : a), ce.cloneElement(r, i);
  }
  return ce.Children.count(r) > 1 ? ce.Children.only(null) : null;
});
Di.displayName = "SlotClone";
var Zh = /* @__PURE__ */ o(({ children: e }) => /* @__PURE__ */ Ni(Xh, { children: e }), "Slottable");
function Yh(e) {
  return ce.isValidElement(e) && e.type === Zh;
}
o(Yh, "isSlottable");
function Kh(e, t) {
  let r = { ...t };
  for (let n in t) {
    let a = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? a && i ? r[n] = (...l) => {
      i(...l), a(...l);
    } : a && (r[n] = a) : n === "style" ? r[n] = { ...a, ...i } : n === "className" && (r[n] = [a, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
o(Kh, "mergeProps");
function Jh(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref :
  e.props.ref || e.ref);
}
o(Jh, "getElementRef");

// src/components/components/Button/Button.tsx
import { darken as bu, lighten as yu, rgba as Eu, transparentize as Kn } from "polished";
import { isPropValid as nv, styled as ov } from "storybook/theming";
var gr = ev(
  ({
    asChild: e = !1,
    animation: t = "none",
    size: r = "small",
    variant: n = "outline",
    padding: a = "medium",
    disabled: i = !1,
    active: c = !1,
    onClick: l,
    ...s
  }, u) => {
    let f = "button";
    e && (f = _i);
    let [d, m] = rv(!1), g = /* @__PURE__ */ o((x) => {
      l && l(x), t !== "none" && m(!0);
    }, "handleClick");
    return tv(() => {
      let x = setTimeout(() => {
        d && m(!1);
      }, 1e3);
      return () => clearTimeout(x);
    }, [d]), /* @__PURE__ */ Qh.createElement(
      av,
      {
        as: f,
        ref: u,
        variant: n,
        size: r,
        padding: a,
        disabled: i,
        active: c,
        animating: d,
        animation: t,
        onClick: g,
        ...s
      }
    );
  }
);
gr.displayName = "Button";
var av = ov("button", {
  shouldForwardProp: /* @__PURE__ */ o((e) => nv(e), "shouldForwardProp")
})(({ theme: e, variant: t, size: r, disabled: n, active: a, animating: i, animation: c = "none", padding: l }) => ({
  border: 0,
  cursor: n ? "not-allowed" : "pointer",
  display: "inline-flex",
  gap: "6px",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  padding: l === "none" ? 0 : l === "small" && r === "small" ? "0 7px" : l === "small" && r === "medium" ? "0 9px" : r === "small" ? "0 10px" :
  r === "medium" ? "0 12px" : 0,
  height: r === "small" ? "28px" : "32px",
  position: "relative",
  textAlign: "center",
  textDecoration: "none",
  transitionProperty: "background, box-shadow",
  transitionDuration: "150ms",
  transitionTimingFunction: "ease-out",
  verticalAlign: "top",
  whiteSpace: "nowrap",
  userSelect: "none",
  opacity: n ? 0.5 : 1,
  margin: 0,
  fontSize: `${e.typography.size.s1}px`,
  fontWeight: e.typography.weight.bold,
  lineHeight: "1",
  background: t === "solid" ? e.color.secondary : t === "outline" ? e.button.background : t === "ghost" && a ? e.background.hoverable : "tra\
nsparent",
  ...t === "ghost" ? {
    // This is a hack to apply bar styles to the button as soon as it is part of a bar
    // It is a temporary solution until we have implemented Theming 2.0.
    ".sb-bar &": {
      background: a ? Kn(0.9, e.barTextColor) : "transparent",
      color: a ? e.barSelectedColor : e.barTextColor,
      "&:hover": {
        color: e.barHoverColor,
        background: Kn(0.86, e.barHoverColor)
      },
      "&:active": {
        color: e.barSelectedColor,
        background: Kn(0.9, e.barSelectedColor)
      },
      "&:focus": {
        boxShadow: `${Eu(e.barHoverColor, 1)} 0 0 0 1px inset`,
        outline: "none"
      }
    }
  } : {},
  color: t === "solid" ? e.color.lightest : t === "outline" ? e.input.color : t === "ghost" && a ? e.color.secondary : t === "ghost" ? e.color.
  mediumdark : e.input.color,
  boxShadow: t === "outline" ? `${e.button.border} 0 0 0 1px inset` : "none",
  borderRadius: e.input.borderRadius,
  // Making sure that the button never shrinks below its minimum size
  flexShrink: 0,
  "&:hover": {
    color: t === "ghost" ? e.color.secondary : void 0,
    background: (() => {
      let s = e.color.secondary;
      return t === "solid" && (s = e.color.secondary), t === "outline" && (s = e.button.background), t === "ghost" ? Kn(0.86, e.color.secondary) :
      e.base === "light" ? bu(0.02, s) : yu(0.03, s);
    })()
  },
  "&:active": {
    color: t === "ghost" ? e.color.secondary : void 0,
    background: (() => {
      let s = e.color.secondary;
      return t === "solid" && (s = e.color.secondary), t === "outline" && (s = e.button.background), t === "ghost" ? e.background.hoverable :
      e.base === "light" ? bu(0.02, s) : yu(0.03, s);
    })()
  },
  "&:focus": {
    boxShadow: `${Eu(e.color.secondary, 1)} 0 0 0 1px inset`,
    outline: "none"
  },
  "> svg": {
    animation: i && c !== "none" ? `${e.animation[c]} 1000ms ease-out` : ""
  }
}));

// src/components/components/IconButton/IconButton.tsx
var Jn = lv(
  ({ padding: e = "small", variant: t = "ghost", ...r }, n) => /* @__PURE__ */ iv.createElement(gr, { padding: e, variant: t, ref: n, ...r })
);
Jn.displayName = "IconButton";

// src/components/components/Modal/Modal.styled.tsx
var Cu = Fi({
  from: { opacity: 0 },
  to: { opacity: 1 }
}), cv = Fi({
  from: { maxHeight: 0 },
  to: {}
}), sv = Fi({
  from: {
    opacity: 0,
    transform: "translate(-50%, -50%) scale(0.9)"
  },
  to: {
    opacity: 1,
    transform: "translate(-50%, -50%) scale(1)"
  }
}), Vi = st.div({
  backdropFilter: "blur(24px)",
  position: "fixed",
  inset: 0,
  width: "100%",
  height: "100%",
  zIndex: 10,
  animation: `${Cu} 200ms`
}), Wi = st.div(
  ({ theme: e, width: t, height: r }) => ({
    backgroundColor: e.background.bar,
    borderRadius: 6,
    boxShadow: "0px 4px 67px 0px #00000040",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: t ?? 740,
    height: r ?? "auto",
    maxWidth: "calc(100% - 40px)",
    maxHeight: "85vh",
    overflow: "hidden",
    zIndex: 11,
    animation: `${sv} 200ms`,
    "&:focus-visible": {
      outline: "none"
    }
  })
), Su = /* @__PURE__ */ o((e) => /* @__PURE__ */ Rt.createElement(Oi, { asChild: !0 }, /* @__PURE__ */ Rt.createElement(Jn, { ...e }, /* @__PURE__ */ Rt.
createElement(d5, null))), "CloseButton"), uv = st.div({
  display: "flex",
  flexDirection: "column",
  margin: 16,
  gap: 16
}), Mu = st.div({
  display: "flex",
  justifyContent: "space-between",
  gap: 16
}), Lu = st.div({
  display: "flex",
  flexDirection: "column",
  gap: 4
}), fv = /* @__PURE__ */ o((e) => /* @__PURE__ */ Rt.createElement(Mu, null, /* @__PURE__ */ Rt.createElement(Lu, { ...e }), /* @__PURE__ */ Rt.
createElement(Su, null)), "Header"), dv = st(ki)(({ theme: e }) => ({
  margin: 0,
  fontSize: e.typography.size.s3,
  fontWeight: e.typography.weight.bold
})), pv = st(Bi)(({ theme: e }) => ({
  position: "relative",
  zIndex: 1,
  margin: 0,
  fontSize: e.typography.size.s2
})), mv = st.div({
  display: "flex",
  flexDirection: "row-reverse",
  gap: 8
}), Au = st.div(({ theme: e }) => ({
  maxHeight: 100,
  overflow: "auto",
  animation: `${cv} 300ms, ${Cu} 300ms`,
  backgroundColor: e.background.critical,
  color: e.color.lightest,
  fontSize: e.typography.size.s2,
  "& > div": {
    position: "relative",
    padding: "8px 16px"
  }
})), hv = /* @__PURE__ */ o(({
  children: e,
  ...t
}) => /* @__PURE__ */ Rt.createElement(Au, { ...t }, /* @__PURE__ */ Rt.createElement("div", null, e)), "Error");

// src/components/components/Modal/Modal.tsx
function vv({
  children: e,
  width: t,
  height: r,
  onEscapeKeyDown: n,
  onInteractOutside: a = /* @__PURE__ */ o((s) => s.preventDefault(), "onInteractOutside"),
  className: i,
  container: c,
  ...l
}) {
  return /* @__PURE__ */ wr.createElement(Hi, { ...l }, /* @__PURE__ */ wr.createElement(Ti, { container: c }, /* @__PURE__ */ wr.createElement(
  zi, { asChild: !0 }, /* @__PURE__ */ wr.createElement(Vi, null)), /* @__PURE__ */ wr.createElement(
    Pi,
    {
      asChild: !0,
      onInteractOutside: a,
      onEscapeKeyDown: n
    },
    /* @__PURE__ */ wr.createElement(Wi, { className: i, width: t, height: r }, e)
  )));
}
o(vv, "BaseModal");
var gv = Object.assign(vv, $i, { Dialog: Yn });

// src/components/components/spaced/Spaced.tsx
import wv from "react";
import { ignoreSsrWarning as Iu, styled as Rv } from "storybook/theming";
var xv = /* @__PURE__ */ o((e) => typeof e == "number" ? e : Number(e), "toNumber"), bv = Rv.div(
  ({ theme: e, col: t, row: r = 1 }) => t ? {
    display: "inline-block",
    verticalAlign: "inherit",
    "& > *": {
      marginLeft: t * e.layoutMargin,
      verticalAlign: "inherit"
    },
    [`& > *:first-child${Iu}`]: {
      marginLeft: 0
    }
  } : {
    "& > *": {
      marginTop: r * e.layoutMargin
    },
    [`& > *:first-child${Iu}`]: {
      marginTop: 0
    }
  },
  ({ theme: e, outer: t, col: r, row: n }) => {
    switch (!0) {
      case !!(t && r):
        return {
          marginLeft: t * e.layoutMargin,
          marginRight: t * e.layoutMargin
        };
      case !!(t && n):
        return {
          marginTop: t * e.layoutMargin,
          marginBottom: t * e.layoutMargin
        };
      default:
        return {};
    }
  }
), yv = /* @__PURE__ */ o(({ col: e, row: t, outer: r, children: n, ...a }) => {
  let i = xv(typeof r == "number" || !r ? r : e || t);
  return /* @__PURE__ */ wv.createElement(bv, { col: e, row: t, outer: i, ...a }, n);
}, "Spaced");

// src/components/components/placeholder/placeholder.tsx
import ji, { Children as Ev } from "react";
import { styled as Ui } from "storybook/theming";
var Cv = Ui.div(({ theme: e }) => ({
  fontWeight: e.typography.weight.bold
})), Sv = Ui.div(), Mv = Ui.div(({ theme: e }) => ({
  padding: 30,
  textAlign: "center",
  color: e.color.defaultText,
  fontSize: e.typography.size.s2 - 1
})), Lv = /* @__PURE__ */ o(({ children: e, ...t }) => {
  let [r, n] = Ev.toArray(e);
  return /* @__PURE__ */ ji.createElement(Mv, { ...t }, /* @__PURE__ */ ji.createElement(Cv, null, r), n && /* @__PURE__ */ ji.createElement(
  Sv, null, n));
}, "Placeholder");

// src/components/index.ts
Bn();

// src/components/components/Zoom/ZoomElement.tsx
import Tu, { useCallback as Tv, useEffect as zv, useRef as Pv, useState as kv } from "react";
import { styled as Bv } from "storybook/theming";

// ../node_modules/use-resize-observer/dist/bundle.esm.js
import { useRef as Ft, useEffect as qi, useCallback as Gi, useState as Av, useMemo as Iv } from "react";
function Hv(e, t) {
  var r = Ft(null), n = Ft(null);
  n.current = t;
  var a = Ft(null);
  qi(function() {
    i();
  });
  var i = Gi(function() {
    var c = a.current, l = n.current, s = c || (l ? l instanceof Element ? l : l.current : null);
    r.current && r.current.element === s && r.current.subscriber === e || (r.current && r.current.cleanup && r.current.cleanup(), r.current =
    {
      element: s,
      subscriber: e,
      // Only calling the subscriber, if there's an actual element to report.
      // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
      cleanup: s ? e(s) : void 0
    });
  }, [e]);
  return qi(function() {
    return function() {
      r.current && r.current.cleanup && (r.current.cleanup(), r.current = null);
    };
  }, []), Gi(function(c) {
    a.current = c, i();
  }, [i]);
}
o(Hv, "useResolvedElement");
function Hu(e, t, r) {
  return e[t] ? e[t][0] ? e[t][0][r] : (
    // TS complains about this, because the RO entry type follows the spec and does not reflect Firefox's current
    // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    e[t][r]
  ) : t === "contentBoxSize" ? e.contentRect[r === "inlineSize" ? "width" : "height"] : void 0;
}
o(Hu, "extractSize");
function Qn(e) {
  e === void 0 && (e = {});
  var t = e.onResize, r = Ft(void 0);
  r.current = t;
  var n = e.round || Math.round, a = Ft(), i = Av({
    width: void 0,
    height: void 0
  }), c = i[0], l = i[1], s = Ft(!1);
  qi(function() {
    return s.current = !1, function() {
      s.current = !0;
    };
  }, []);
  var u = Ft({
    width: void 0,
    height: void 0
  }), f = Hv(Gi(function(d) {
    return (!a.current || a.current.box !== e.box || a.current.round !== n) && (a.current = {
      box: e.box,
      round: n,
      instance: new ResizeObserver(function(m) {
        var g = m[0], x = e.box === "border-box" ? "borderBoxSize" : e.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "c\
ontentBoxSize", p = Hu(g, x, "inlineSize"), h = Hu(g, x, "blockSize"), v = p ? n(p) : void 0, w = h ? n(h) : void 0;
        if (u.current.width !== v || u.current.height !== w) {
          var R = {
            width: v,
            height: w
          };
          u.current.width = v, u.current.height = w, r.current ? r.current(R) : s.current || l(R);
        }
      })
    }), a.current.instance.observe(d, {
      box: e.box
    }), function() {
      a.current && a.current.instance.unobserve(d);
    };
  }, [e.box, n]), e.ref);
  return Iv(function() {
    return {
      ref: f,
      width: c.width,
      height: c.height
    };
  }, [f, c.width, c.height]);
}
o(Qn, "useResizeObserver");

// src/components/components/Zoom/ZoomElement.tsx
var Ov = Bv.div(
  ({ scale: e = 1, elementHeight: t }) => ({
    height: t || "auto",
    transformOrigin: "top left",
    transform: `scale(${1 / e})`
  })
);
function zu({ scale: e, children: t }) {
  let r = Pv(null), [n, a] = kv(0), i = Tv(
    ({ height: c }) => {
      c && a(c / e);
    },
    [e]
  );
  return zv(() => {
    r.current && a(r.current.getBoundingClientRect().height);
  }, [e]), Qn({
    ref: r,
    onResize: i
  }), /* @__PURE__ */ Tu.createElement(Ov, { scale: e, elementHeight: n }, /* @__PURE__ */ Tu.createElement("div", { ref: r, className: "inn\
erZoomElementWrapper" }, t));
}
o(zu, "ZoomElement");

// src/components/components/Zoom/ZoomIFrame.tsx
import Pu, { Component as Nv } from "react";
var Xi = class Xi extends Nv {
  constructor() {
    super(...arguments);
    // @ts-expect-error (non strict)
    this.iframe = null;
  }
  componentDidMount() {
    let { iFrameRef: r } = this.props;
    this.iframe = r.current;
  }
  shouldComponentUpdate(r) {
    let { scale: n, active: a } = this.props;
    return n !== r.scale && this.setIframeInnerZoom(r.scale), a !== r.active && this.iframe.setAttribute("data-is-storybook", r.active ? "tr\
ue" : "false"), r.children.props.src !== this.props.children.props.src;
  }
  setIframeInnerZoom(r) {
    try {
      Object.assign(this.iframe.contentDocument.body.style, {
        width: `${r * 100}%`,
        height: `${r * 100}%`,
        transform: `scale(${1 / r})`,
        transformOrigin: "top left"
      });
    } catch {
      this.setIframeZoom(r);
    }
  }
  setIframeZoom(r) {
    Object.assign(this.iframe.style, {
      width: `${r * 100}%`,
      height: `${r * 100}%`,
      transform: `scale(${1 / r})`,
      transformOrigin: "top left"
    });
  }
  render() {
    let { children: r } = this.props;
    return /* @__PURE__ */ Pu.createElement(Pu.Fragment, null, r);
  }
};
o(Xi, "ZoomIFrame");
var eo = Xi;

// src/components/components/Zoom/Zoom.tsx
var Dv = {
  Element: zu,
  IFrame: eo
};

// src/components/components/ErrorFormatter/ErrorFormatter.tsx
import ke, { Fragment as Rr } from "react";
import { global as _v } from "@storybook/global";
import { styled as Zi } from "storybook/theming";
var { document: Fv } = _v, Vv = Zi.strong(({ theme: e }) => ({
  color: e.color.orange
})), Wv = Zi.strong(({ theme: e }) => ({
  color: e.color.ancillary,
  textDecoration: "underline"
})), ku = Zi.em(({ theme: e }) => ({
  color: e.textMutedColor
})), $v = /(Error): (.*)\n/, jv = /at (?:(.*) )?\(?(.+)\)?/, Uv = /([^@]+)?(?:\/<)?@(.+)?/, qv = /([^@]+)?@(.+)?/, Gv = /* @__PURE__ */ o(({
error: e }) => {
  if (!e)
    return /* @__PURE__ */ ke.createElement(Rr, null, "This error has no stack or message");
  if (!e.stack)
    return /* @__PURE__ */ ke.createElement(Rr, null, e.message || "This error has no stack or message");
  let t = e.stack.toString();
  t && e.message && !t.includes(e.message) && (t = `Error: ${e.message}

${t}`);
  let r = t.match($v);
  if (!r)
    return /* @__PURE__ */ ke.createElement(Rr, null, t);
  let [, n, a] = r, i = t.split(/\n/).slice(1), [, ...c] = i.map((l) => {
    let s = l.match(jv) || l.match(Uv) || l.match(qv);
    return s ? {
      name: (s[1] || "").replace("/<", ""),
      location: s[2].replace(Fv.location.origin, "")
    } : null;
  }).filter(Boolean);
  return /* @__PURE__ */ ke.createElement(Rr, null, /* @__PURE__ */ ke.createElement("span", null, n), ": ", /* @__PURE__ */ ke.createElement(
  Vv, null, a), /* @__PURE__ */ ke.createElement("br", null), c.map(
    (l, s) => l?.name ? /* @__PURE__ */ ke.createElement(Rr, { key: s }, "  ", "at ", /* @__PURE__ */ ke.createElement(Wv, null, l.name), " \
(", /* @__PURE__ */ ke.createElement(ku, null, l.location), ")", /* @__PURE__ */ ke.createElement("br", null)) : /* @__PURE__ */ ke.createElement(
    Rr, { key: s }, "  ", "at ", /* @__PURE__ */ ke.createElement(ku, null, l?.location), /* @__PURE__ */ ke.createElement("br", null))
  ));
}, "ErrorFormatter");

// src/components/components/form/index.tsx
import { styled as pg } from "storybook/theming";

// src/components/components/form/field/field.tsx
import Yi from "react";
import { styled as Bu } from "storybook/theming";
var Xv = Bu.label(({ theme: e }) => ({
  display: "flex",
  borderBottom: `1px solid ${e.appBorderColor}`,
  margin: "0 15px",
  padding: "8px 0",
  "&:last-child": {
    marginBottom: "3rem"
  }
})), Zv = Bu.span(({ theme: e }) => ({
  minWidth: 100,
  fontWeight: e.typography.weight.bold,
  marginRight: 15,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  lineHeight: "16px"
})), Ou = /* @__PURE__ */ o(({ label: e, children: t, ...r }) => /* @__PURE__ */ Yi.createElement(Xv, { ...r }, e ? /* @__PURE__ */ Yi.createElement(
Zv, null, /* @__PURE__ */ Yi.createElement("span", null, e)) : null, t), "Field");

// src/components/components/form/input/input.tsx
import Ki, { forwardRef as Ji } from "react";

// ../node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js
gn();
hn();
import * as Ke from "react";

// ../node_modules/use-latest/dist/use-latest.esm.js
import * as Du from "react";

// ../node_modules/use-isomorphic-layout-effect/dist/use-isomorphic-layout-effect.browser.esm.js
import { useLayoutEffect as Yv } from "react";
var Kv = Yv, Nu = Kv;

// ../node_modules/use-latest/dist/use-latest.esm.js
var _u = /* @__PURE__ */ o(function(t) {
  var r = Du.useRef(t);
  return Nu(function() {
    r.current = t;
  }), r;
}, "useLatest");

// ../node_modules/use-composed-ref/dist/use-composed-ref.esm.js
import { useRef as Jv, useCallback as Qv } from "react";
var Fu = /* @__PURE__ */ o(function(t, r) {
  if (typeof t == "function") {
    t(r);
    return;
  }
  t.current = r;
}, "updateRef"), eg = /* @__PURE__ */ o(function(t, r) {
  var n = Jv();
  return Qv(function(a) {
    t.current = a, n.current && Fu(n.current, null), n.current = r, r && Fu(r, a);
  }, [r]);
}, "useComposedRef"), Vu = eg;

// ../node_modules/react-textarea-autosize/dist/react-textarea-autosize.browser.esm.js
var Wu = {
  "min-height": "0",
  "max-height": "none",
  height: "0",
  visibility: "hidden",
  overflow: "hidden",
  position: "absolute",
  "z-index": "-1000",
  top: "0",
  right: "0"
}, tg = /* @__PURE__ */ o(function(t) {
  Object.keys(Wu).forEach(function(r) {
    t.style.setProperty(r, Wu[r], "important");
  });
}, "forceHiddenStyles"), $u = tg, Ee = null, ju = /* @__PURE__ */ o(function(t, r) {
  var n = t.scrollHeight;
  return r.sizingStyle.boxSizing === "border-box" ? n + r.borderSize : n - r.paddingSize;
}, "getHeight");
function rg(e, t, r, n) {
  r === void 0 && (r = 1), n === void 0 && (n = 1 / 0), Ee || (Ee = document.createElement("textarea"), Ee.setAttribute("tabindex", "-1"), Ee.
  setAttribute("aria-hidden", "true"), $u(Ee)), Ee.parentNode === null && document.body.appendChild(Ee);
  var a = e.paddingSize, i = e.borderSize, c = e.sizingStyle, l = c.boxSizing;
  Object.keys(c).forEach(function(m) {
    var g = m;
    Ee.style[g] = c[g];
  }), $u(Ee), Ee.value = t;
  var s = ju(Ee, e);
  Ee.value = t, s = ju(Ee, e), Ee.value = "x";
  var u = Ee.scrollHeight - a, f = u * r;
  l === "border-box" && (f = f + a + i), s = Math.max(f, s);
  var d = u * n;
  return l === "border-box" && (d = d + a + i), s = Math.min(d, s), [s, u];
}
o(rg, "calculateNodeHeight");
var Uu = /* @__PURE__ */ o(function() {
}, "noop"), ng = /* @__PURE__ */ o(function(t, r) {
  return t.reduce(function(n, a) {
    return n[a] = r[a], n;
  }, {});
}, "pick"), og = [
  "borderBottomWidth",
  "borderLeftWidth",
  "borderRightWidth",
  "borderTopWidth",
  "boxSizing",
  "fontFamily",
  "fontSize",
  "fontStyle",
  "fontWeight",
  "letterSpacing",
  "lineHeight",
  "paddingBottom",
  "paddingLeft",
  "paddingRight",
  "paddingTop",
  // non-standard
  "tabSize",
  "textIndent",
  // non-standard
  "textRendering",
  "textTransform",
  "width",
  "wordBreak"
], ag = !!document.documentElement.currentStyle, ig = /* @__PURE__ */ o(function(t) {
  var r = window.getComputedStyle(t);
  if (r === null)
    return null;
  var n = ng(og, r), a = n.boxSizing;
  if (a === "")
    return null;
  ag && a === "border-box" && (n.width = parseFloat(n.width) + parseFloat(n.borderRightWidth) + parseFloat(n.borderLeftWidth) + parseFloat(n.
  paddingRight) + parseFloat(n.paddingLeft) + "px");
  var i = parseFloat(n.paddingBottom) + parseFloat(n.paddingTop), c = parseFloat(n.borderBottomWidth) + parseFloat(n.borderTopWidth);
  return {
    sizingStyle: n,
    paddingSize: i,
    borderSize: c
  };
}, "getSizingData"), lg = ig;
function qu(e, t, r) {
  var n = _u(r);
  Ke.useLayoutEffect(function() {
    var a = /* @__PURE__ */ o(function(c) {
      return n.current(c);
    }, "handler");
    if (e)
      return e.addEventListener(t, a), function() {
        return e.removeEventListener(t, a);
      };
  }, []);
}
o(qu, "useListener");
var cg = /* @__PURE__ */ o(function(t) {
  qu(window, "resize", t);
}, "useWindowResizeListener"), sg = /* @__PURE__ */ o(function(t) {
  qu(document.fonts, "loadingdone", t);
}, "useFontsLoadedListener"), ug = ["cacheMeasurements", "maxRows", "minRows", "onChange", "onHeightChange"], fg = /* @__PURE__ */ o(function(t, r) {
  var n = t.cacheMeasurements, a = t.maxRows, i = t.minRows, c = t.onChange, l = c === void 0 ? Uu : c, s = t.onHeightChange, u = s === void 0 ?
  Uu : s, f = Jt(t, ug), d = f.value !== void 0, m = Ke.useRef(null), g = Vu(m, r), x = Ke.useRef(0), p = Ke.useRef(), h = /* @__PURE__ */ o(
  function() {
    var R = m.current, y = n && p.current ? p.current : lg(R);
    if (y) {
      p.current = y;
      var E = rg(y, R.value || R.placeholder || "x", i, a), b = E[0], C = E[1];
      x.current !== b && (x.current = b, R.style.setProperty("height", b + "px", "important"), u(b, {
        rowHeight: C
      }));
    }
  }, "resizeTextarea"), v = /* @__PURE__ */ o(function(R) {
    d || h(), l(R);
  }, "handleChange");
  return Ke.useLayoutEffect(h), cg(h), sg(h), /* @__PURE__ */ Ke.createElement("textarea", Ie({}, f, {
    onChange: v,
    ref: g
  }));
}, "TextareaAutosize"), Gu = /* @__PURE__ */ Ke.forwardRef(fg);

// src/components/components/form/input/input.tsx
import { styled as Qi } from "storybook/theming";
var dg = {
  // resets
  appearance: "none",
  border: "0 none",
  boxSizing: "inherit",
  display: " block",
  margin: " 0",
  background: "transparent",
  padding: 0,
  fontSize: "inherit",
  position: "relative"
}, e0 = /* @__PURE__ */ o(({ theme: e }) => ({
  ...dg,
  transition: "box-shadow 200ms ease-out, opacity 200ms ease-out",
  color: e.input.color || "inherit",
  background: e.input.background,
  boxShadow: `${e.input.border} 0 0 0 1px inset`,
  borderRadius: e.input.borderRadius,
  fontSize: e.typography.size.s2 - 1,
  lineHeight: "20px",
  padding: "6px 10px",
  // 32
  boxSizing: "border-box",
  height: 32,
  '&[type="file"]': {
    height: "auto"
  },
  "&:focus": {
    boxShadow: `${e.color.secondary} 0 0 0 1px inset`,
    outline: "none"
  },
  "&[disabled]": {
    cursor: "not-allowed",
    opacity: 0.5
  },
  "&:-webkit-autofill": { WebkitBoxShadow: `0 0 0 3em ${e.color.lightest} inset` },
  "&::placeholder": {
    color: e.textMutedColor,
    opacity: 1
  }
}), "styles"), t0 = /* @__PURE__ */ o(({ size: e }) => {
  switch (e) {
    case "100%":
      return { width: "100%" };
    case "flex":
      return { flex: 1 };
    case "auto":
    default:
      return { display: "inline" };
  }
}, "sizes"), Xu = /* @__PURE__ */ o(({
  align: e
}) => {
  switch (e) {
    case "end":
      return { textAlign: "right" };
    case "center":
      return { textAlign: "center" };
    case "start":
    default:
      return { textAlign: "left" };
  }
}, "alignment"), r0 = /* @__PURE__ */ o(({ valid: e, theme: t }) => {
  switch (e) {
    case "valid":
      return { boxShadow: `${t.color.positive} 0 0 0 1px inset !important` };
    case "error":
      return { boxShadow: `${t.color.negative} 0 0 0 1px inset !important` };
    case "warn":
      return {
        boxShadow: `${t.color.warning} 0 0 0 1px inset`
      };
    case void 0:
    case null:
    default:
      return {};
  }
}, "validation"), Zu = Object.assign(
  Qi(
    Ji(/* @__PURE__ */ o(function({ size: t, valid: r, align: n, ...a }, i) {
      return /* @__PURE__ */ Ki.createElement("input", { ...a, ref: i });
    }, "Input"))
  )(e0, t0, Xu, r0, {
    minHeight: 32
  }),
  {
    displayName: "Input"
  }
), Yu = Object.assign(
  Qi(
    Ji(/* @__PURE__ */ o(function({ size: t, valid: r, align: n, ...a }, i) {
      return /* @__PURE__ */ Ki.createElement("select", { ...a, ref: i });
    }, "Select"))
  )(e0, t0, r0, {
    height: 32,
    userSelect: "none",
    paddingRight: 20,
    appearance: "menulist"
  }),
  {
    displayName: "Select"
  }
), Ku = Object.assign(
  Qi(
    Ji(/* @__PURE__ */ o(function({ size: t, valid: r, align: n, ...a }, i) {
      return /* @__PURE__ */ Ki.createElement(Gu, { ...a, ref: i });
    }, "Textarea"))
  )(e0, t0, Xu, r0, ({ height: e = 400 }) => ({
    overflow: "visible",
    maxHeight: e
  })),
  {
    displayName: "Textarea"
  }
);

// src/components/components/form/index.tsx
var mg = Object.assign(
  pg.form({
    boxSizing: "border-box",
    width: "100%"
  }),
  {
    Field: Ou,
    Input: Zu,
    Select: Yu,
    Textarea: Ku,
    Button: gr
  }
);

// src/components/components/tooltip/lazy-WithTooltip.tsx
import Ir, { Suspense as fd, lazy as dd } from "react";
var f7 = dd(
  () => Promise.resolve().then(() => (vo(), k0)).then((e) => ({ default: e.WithTooltip }))
), d7 = /* @__PURE__ */ o((e) => /* @__PURE__ */ Ir.createElement(fd, { fallback: /* @__PURE__ */ Ir.createElement("div", null) }, /* @__PURE__ */ Ir.
createElement(f7, { ...e })), "WithTooltip"), p7 = dd(
  () => Promise.resolve().then(() => (vo(), k0)).then((e) => ({ default: e.WithTooltipPure }))
), m7 = /* @__PURE__ */ o((e) => /* @__PURE__ */ Ir.createElement(fd, { fallback: /* @__PURE__ */ Ir.createElement("div", null) }, /* @__PURE__ */ Ir.
createElement(p7, { ...e })), "WithTooltipPure");

// src/components/components/tooltip/TooltipMessage.tsx
import Hr from "react";
import { styled as fn } from "storybook/theming";
var h7 = fn.div(({ theme: e }) => ({
  fontWeight: e.typography.weight.bold
})), v7 = fn.span(), g7 = fn.div(({ theme: e }) => ({
  marginTop: 8,
  textAlign: "center",
  "> *": {
    margin: "0 8px",
    fontWeight: e.typography.weight.bold
  }
})), w7 = fn.div(({ theme: e }) => ({
  color: e.color.defaultText,
  lineHeight: "18px"
})), R7 = fn.div({
  padding: 15,
  width: 280,
  boxSizing: "border-box"
}), x7 = /* @__PURE__ */ o(({ title: e, desc: t, links: r }) => /* @__PURE__ */ Hr.createElement(R7, null, /* @__PURE__ */ Hr.createElement(
w7, null, e && /* @__PURE__ */ Hr.createElement(h7, null, e), t && /* @__PURE__ */ Hr.createElement(v7, null, t)), r && /* @__PURE__ */ Hr.createElement(
g7, null, r.map(({ title: n, ...a }) => /* @__PURE__ */ Hr.createElement(qa, { ...a, key: n }, n)))), "TooltipMessage");

// src/components/components/tooltip/TooltipNote.tsx
import b7 from "react";
import { styled as y7 } from "storybook/theming";
var E7 = y7.div(({ theme: e }) => ({
  padding: "2px 6px",
  lineHeight: "16px",
  fontSize: 10,
  fontWeight: e.typography.weight.bold,
  color: e.color.lightest,
  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
  borderRadius: 4,
  whiteSpace: "nowrap",
  pointerEvents: "none",
  zIndex: -1,
  background: e.base === "light" ? "rgba(60, 60, 60, 0.9)" : "rgba(0, 0, 0, 0.95)",
  margin: 6
})), C7 = /* @__PURE__ */ o(({ note: e, ...t }) => /* @__PURE__ */ b7.createElement(E7, { ...t }, e), "TooltipNote");

// src/components/components/tooltip/TooltipLinkList.tsx
import dn, { Fragment as P7, useCallback as k7 } from "react";
import { styled as md } from "storybook/theming";

// src/components/components/tooltip/ListItem.tsx
var pd = ve(Dr(), 1);
import ot from "react";
import { styled as Tr } from "storybook/theming";
var S7 = Tr(({ active: e, loading: t, disabled: r, ...n }) => /* @__PURE__ */ ot.createElement("span", { ...n }))(
  ({ theme: e }) => ({
    color: e.color.defaultText,
    // Previously was theme.typography.weight.normal but this weight does not exists in Theme
    fontWeight: e.typography.weight.regular
  }),
  ({ active: e, theme: t }) => e ? {
    color: t.color.secondary,
    fontWeight: t.typography.weight.bold
  } : {},
  ({ loading: e, theme: t }) => e ? {
    display: "inline-block",
    flex: "none",
    ...t.animation.inlineGlow
  } : {},
  ({ disabled: e, theme: t }) => e ? {
    color: t.textMutedColor
  } : {}
), M7 = Tr.span({
  display: "flex",
  "& svg": {
    height: 12,
    width: 12,
    margin: "3px 0",
    verticalAlign: "top"
  },
  "& path": {
    fill: "inherit"
  }
}), L7 = Tr.span(
  {
    flex: 1,
    textAlign: "left",
    display: "flex",
    flexDirection: "column"
  },
  ({ isIndented: e }) => e ? { marginLeft: 24 } : {}
), A7 = Tr.span(
  ({ theme: e }) => ({
    fontSize: "11px",
    lineHeight: "14px"
  }),
  ({ active: e, theme: t }) => e ? {
    color: t.color.secondary
  } : {},
  ({ theme: e, disabled: t }) => t ? {
    color: e.textMutedColor
  } : {}
), I7 = Tr.span(
  ({ active: e, theme: t }) => e ? {
    color: t.color.secondary
  } : {},
  () => ({
    display: "flex",
    maxWidth: 14
  })
), H7 = Tr.div(
  ({ theme: e }) => ({
    width: "100%",
    border: "none",
    borderRadius: e.appBorderRadius,
    background: "none",
    fontSize: e.typography.size.s1,
    transition: "all 150ms ease-out",
    color: e.color.dark,
    textDecoration: "none",
    justifyContent: "space-between",
    lineHeight: "18px",
    padding: "7px 10px",
    display: "flex",
    alignItems: "center",
    "& > * + *": {
      paddingLeft: 10
    }
  }),
  ({ theme: e, href: t, onClick: r }) => (t || r) && {
    cursor: "pointer",
    "&:hover": {
      background: e.background.hoverable
    },
    "&:hover svg": {
      opacity: 1
    }
  },
  ({ theme: e, as: t }) => t === "label" && {
    "&:has(input:not(:disabled))": {
      cursor: "pointer",
      "&:hover": {
        background: e.background.hoverable
      }
    }
  },
  ({ disabled: e }) => e && { cursor: "not-allowed" }
), T7 = (0, pd.default)(100)((e, t, r) => ({
  ...e && {
    as: "button",
    onClick: e
  },
  ...t && {
    as: "a",
    href: t,
    ...r && {
      as: r,
      to: t
    }
  }
})), z7 = /* @__PURE__ */ o(({
  loading: e = !1,
  title: t = /* @__PURE__ */ ot.createElement("span", null, "Loading state"),
  center: r = null,
  right: n = null,
  active: a = !1,
  disabled: i = !1,
  isIndented: c,
  href: l = void 0,
  onClick: s = void 0,
  icon: u,
  LinkWrapper: f = void 0,
  ...d
}) => {
  let m = { active: a, disabled: i }, g = T7(s, l, f);
  return /* @__PURE__ */ ot.createElement(H7, { ...d, ...m, ...g }, /* @__PURE__ */ ot.createElement(ot.Fragment, null, u && /* @__PURE__ */ ot.
  createElement(I7, { ...m }, u), t || r ? /* @__PURE__ */ ot.createElement(L7, { isIndented: !!(!u && c) }, t && /* @__PURE__ */ ot.createElement(
  S7, { ...m, loading: e }, t), r && /* @__PURE__ */ ot.createElement(A7, { ...m }, r)) : null, n && /* @__PURE__ */ ot.createElement(M7, { ...m },
  n)));
}, "ListItem"), B0 = z7;

// src/components/components/tooltip/TooltipLinkList.tsx
var B7 = md.div(
  {
    minWidth: 180,
    overflow: "hidden",
    overflowY: "auto",
    maxHeight: 15.5 * 32 + 8
    // 15.5 items at 32px each + 8px padding
  },
  ({ theme: e }) => ({
    borderRadius: e.appBorderRadius + 2
  }),
  ({ theme: e }) => e.base === "dark" ? { background: e.background.content } : {}
), O7 = md.div(({ theme: e }) => ({
  padding: 4,
  "& + &": {
    borderTop: `1px solid ${e.appBorderColor}`
  }
})), N7 = /* @__PURE__ */ o(({ id: e, onClick: t, ...r }) => {
  let { active: n, disabled: a, title: i, href: c } = r, l = k7(
    (s) => t?.(s, { id: e, active: n, disabled: a, title: i, href: c }),
    [t, e, n, a, i, c]
  );
  return /* @__PURE__ */ dn.createElement(B0, { id: `list-item-${e}`, ...r, ...t && { onClick: l } });
}, "Item"), O0 = /* @__PURE__ */ o(({ links: e, LinkWrapper: t, ...r }) => {
  let n = Array.isArray(e[0]) ? e : [e], a = n.some((i) => i.some((c) => "icon" in c && c.icon));
  return /* @__PURE__ */ dn.createElement(B7, { ...r }, n.filter((i) => i.length).map((i, c) => /* @__PURE__ */ dn.createElement(O7, { key: i.
  map((l) => l.id).join(`~${c}~`) }, i.map((l) => "content" in l ? /* @__PURE__ */ dn.createElement(P7, { key: l.id }, l.content) : /* @__PURE__ */ dn.
  createElement(N7, { key: l.id, isIndented: a, LinkWrapper: t, ...l })))));
}, "TooltipLinkList");

// src/components/components/tabs/tabs.tsx
import Ne, { Component as bd, memo as o3, useMemo as a3 } from "react";
import { sanitize as i3 } from "storybook/internal/csf";
import { styled as j0 } from "storybook/theming";

// src/components/components/bar/bar.tsx
Bn();
import zr, { Children as D7 } from "react";
import { styled as D0 } from "storybook/theming";
var N0 = D0.div(
  {
    display: "flex",
    whiteSpace: "nowrap",
    flexBasis: "auto",
    marginLeft: 3,
    marginRight: 10
  },
  ({ scrollable: e }) => e ? { flexShrink: 0 } : {},
  ({ left: e }) => e ? {
    "& > *": {
      marginLeft: 4
    }
  } : {},
  ({ right: e }) => e ? {
    gap: 6
  } : {}
);
N0.displayName = "Side";
var _7 = /* @__PURE__ */ o(({ children: e, className: t, scrollable: r }) => r ? /* @__PURE__ */ zr.createElement(ur, { vertical: !1, className: t },
e) : /* @__PURE__ */ zr.createElement("div", { className: t }, e), "UnstyledBar"), _0 = D0(_7)(
  ({ theme: e, scrollable: t = !0 }) => ({
    color: e.barTextColor,
    width: "100%",
    height: 40,
    flexShrink: 0,
    overflow: t ? "auto" : "hidden",
    overflowY: "hidden"
  }),
  ({ theme: e, border: t = !1 }) => t ? {
    boxShadow: `${e.appBorderColor}  0 -1px 0 0 inset`,
    background: e.barBg
  } : {}
);
_0.displayName = "Bar";
var F7 = D0.div(({ bgColor: e }) => ({
  display: "flex",
  justifyContent: "space-between",
  position: "relative",
  flexWrap: "nowrap",
  flexShrink: 0,
  height: 40,
  backgroundColor: e || ""
})), go = /* @__PURE__ */ o(({ children: e, backgroundColor: t, className: r, ...n }) => {
  let [a, i] = D7.toArray(e);
  return /* @__PURE__ */ zr.createElement(_0, { className: `sb-bar ${r}`, ...n }, /* @__PURE__ */ zr.createElement(F7, { bgColor: t }, /* @__PURE__ */ zr.
  createElement(N0, { scrollable: n.scrollable, left: !0 }, a), i ? /* @__PURE__ */ zr.createElement(N0, { right: !0 }, i) : null));
}, "FlexBar");
go.displayName = "FlexBar";

// src/components/components/bar/button.tsx
import hd, { forwardRef as V7 } from "react";
import { isPropValid as W7, styled as $7 } from "storybook/theming";
var j7 = /* @__PURE__ */ o((e) => typeof e.props.href == "string", "isLink"), U7 = /* @__PURE__ */ o((e) => typeof e.props.href != "string",
"isButton");
function q7({ children: e, ...t }, r) {
  let n = { props: t, ref: r };
  if (j7(n))
    return /* @__PURE__ */ hd.createElement("a", { ref: n.ref, ...n.props }, e);
  if (U7(n))
    return /* @__PURE__ */ hd.createElement("button", { ref: n.ref, type: "button", ...n.props }, e);
  throw new Error("invalid props");
}
o(q7, "ForwardRefFunction");
var vd = V7(q7);
vd.displayName = "ButtonOrLink";
var Zt = $7(vd, { shouldForwardProp: W7 })(
  {
    whiteSpace: "normal",
    display: "inline-flex",
    overflow: "hidden",
    verticalAlign: "top",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    textDecoration: "none",
    "&:empty": {
      display: "none"
    },
    "&[hidden]": {
      display: "none"
    }
  },
  ({ theme: e }) => ({
    padding: "0 15px",
    transition: "color 0.2s linear, border-bottom-color 0.2s linear",
    height: 40,
    lineHeight: "12px",
    cursor: "pointer",
    background: "transparent",
    border: "0 solid transparent",
    borderTop: "3px solid transparent",
    borderBottom: "3px solid transparent",
    fontWeight: "bold",
    fontSize: 13,
    "&:focus": {
      outline: "0 none",
      borderBottomColor: e.barSelectedColor
    }
  }),
  ({ active: e, textColor: t, theme: r }) => e ? {
    color: t || r.barSelectedColor,
    borderBottomColor: r.barSelectedColor
  } : {
    color: t || r.barTextColor,
    borderBottomColor: "transparent",
    "&:hover": {
      color: r.barHoverColor
    }
  }
);
Zt.displayName = "TabButton";

// src/components/components/tabs/EmptyTabContent.tsx
import wo from "react";
import { styled as Ro } from "storybook/theming";
var G7 = Ro.div(({ theme: e }) => ({
  height: "100%",
  display: "flex",
  padding: 30,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: 15,
  background: e.background.content
})), X7 = Ro.div({
  display: "flex",
  flexDirection: "column",
  gap: 4,
  maxWidth: 415
}), Z7 = Ro.div(({ theme: e }) => ({
  fontWeight: e.typography.weight.bold,
  fontSize: e.typography.size.s2 - 1,
  textAlign: "center",
  color: e.textColor
})), Y7 = Ro.div(({ theme: e }) => ({
  fontWeight: e.typography.weight.regular,
  fontSize: e.typography.size.s2 - 1,
  textAlign: "center",
  color: e.textMutedColor
})), xo = /* @__PURE__ */ o(({ title: e, description: t, footer: r }) => /* @__PURE__ */ wo.createElement(G7, null, /* @__PURE__ */ wo.createElement(
X7, null, /* @__PURE__ */ wo.createElement(Z7, null, e), t && /* @__PURE__ */ wo.createElement(Y7, null, t)), r), "EmptyTabContent");

// src/components/components/tabs/tabs.helpers.tsx
import K7, { Children as J7 } from "react";
import { styled as Q7 } from "storybook/theming";
var F0 = Q7.div(
  ({ active: e }) => e ? { display: "block" } : { display: "none" }
), gd = /* @__PURE__ */ o((e) => J7.toArray(e).map(
  // @ts-expect-error (non strict)
  ({
    props: { title: t, id: r, color: n, children: a }
  }) => {
    let i = Array.isArray(
      a
    ) ? a[0] : a;
    return {
      title: t,
      id: r,
      ...n ? { color: n } : {},
      render: typeof i == "function" ? i : ({ active: l }) => /* @__PURE__ */ K7.createElement(F0, { active: l, role: "tabpanel" }, i)
    };
  }
), "childrenToList");

// src/components/components/tabs/tabs.hooks.tsx
import Yt, { useCallback as wd, useLayoutEffect as e3, useRef as bo, useState as V0 } from "react";
import { sanitize as t3 } from "storybook/internal/csf";
import { styled as Rd } from "storybook/theming";
vo();
var r3 = Rd.span(({ theme: e, isActive: t }) => ({
  display: "inline-block",
  width: 0,
  height: 0,
  marginLeft: 8,
  color: t ? e.color.secondary : e.color.mediumdark,
  borderRight: "3px solid transparent",
  borderLeft: "3px solid transparent",
  borderTop: "3px solid",
  transition: "transform .1s ease-out"
})), n3 = Rd(Zt)(({ active: e, theme: t, preActive: r }) => `
    color: ${r || e ? t.barSelectedColor : t.barTextColor};
    .addon-collapsible-icon {
      color: ${r || e ? t.barSelectedColor : t.barTextColor};
    }
    &:hover {
      color: ${t.barHoverColor};
      .addon-collapsible-icon {
        color: ${t.barHoverColor};
      }
    }
  `);
function xd(e) {
  let t = bo(), r = bo(), n = bo(/* @__PURE__ */ new Map()), { width: a = 1 } = Qn({
    // @ts-expect-error (non strict)
    ref: t
  }), [i, c] = V0(e), [l, s] = V0([]), u = bo(e), f = wd(
    ({
      menuName: m,
      actions: g
    }) => {
      let x = l.some(({ active: v }) => v), [p, h] = V0(!1);
      return /* @__PURE__ */ Yt.createElement(Yt.Fragment, null, /* @__PURE__ */ Yt.createElement(
        P0,
        {
          interactive: !0,
          visible: p,
          onVisibleChange: h,
          placement: "bottom",
          delayHide: 100,
          tooltip: /* @__PURE__ */ Yt.createElement(
            O0,
            {
              links: l.map(({ title: v, id: w, color: R, active: y }) => ({
                id: w,
                title: v,
                color: R,
                active: y,
                onClick: /* @__PURE__ */ o((E) => {
                  E.preventDefault(), g.onSelect(w);
                }, "onClick")
              }))
            }
          )
        },
        /* @__PURE__ */ Yt.createElement(
          n3,
          {
            id: "addons-menu-button",
            ref: r,
            active: x,
            preActive: p,
            style: { visibility: l.length ? "visible" : "hidden" },
            "aria-hidden": !l.length,
            className: "tabbutton",
            type: "button",
            role: "tab"
          },
          m,
          /* @__PURE__ */ Yt.createElement(
            r3,
            {
              className: "addon-collapsible-icon",
              isActive: x || p
            }
          )
        )
      ), l.map(({ title: v, id: w, color: R }, y) => {
        let E = `index-${y}`;
        return /* @__PURE__ */ Yt.createElement(
          Zt,
          {
            id: `tabbutton-${t3(w) ?? E}`,
            style: { visibility: "hidden" },
            "aria-hidden": !0,
            tabIndex: -1,
            ref: (b) => {
              n.current.set(w, b);
            },
            className: "tabbutton",
            type: "button",
            key: w,
            textColor: R,
            role: "tab"
          },
          v
        );
      }));
    },
    [l]
  ), d = wd(() => {
    if (!t.current || !r.current)
      return;
    let { x: m, width: g } = t.current.getBoundingClientRect(), { width: x } = r.current.getBoundingClientRect(), p = l.length ? m + g - x :
    m + g, h = [], v = 0, w = e.filter((R) => {
      let { id: y } = R, E = n.current.get(y), { width: b = 0 } = E?.getBoundingClientRect() || {}, C = m + v + b > p;
      return (!C || !E) && h.push(R), v += b, C;
    });
    (h.length !== i.length || u.current !== e) && (c(h), s(w), u.current = e);
  }, [l.length, e, i]);
  return e3(d, [d, a]), {
    tabRefs: n,
    addonsRef: r,
    tabBarRef: t,
    visibleList: i,
    invisibleList: l,
    AddonTab: f
  };
}
o(xd, "useList");

// src/components/components/tabs/tabs.tsx
var l3 = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */", c3 = j0.div(
  ({ theme: e, bordered: t }) => t ? {
    backgroundClip: "padding-box",
    border: `1px solid ${e.appBorderColor}`,
    borderRadius: e.appBorderRadius,
    overflow: "hidden",
    boxSizing: "border-box"
  } : {},
  ({ absolute: e }) => e ? {
    width: "100%",
    height: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column"
  } : {
    display: "block"
  }
), U0 = j0.div({
  overflow: "hidden",
  "&:first-of-type": {
    marginLeft: -3
  },
  whiteSpace: "nowrap",
  flexGrow: 1
});
U0.displayName = "TabBar";
var s3 = j0.div(
  {
    display: "block",
    position: "relative"
  },
  ({ theme: e }) => ({
    fontSize: e.typography.size.s2 - 1,
    background: e.background.content
  }),
  ({ bordered: e, theme: t }) => e ? {
    borderRadius: `0 0 ${t.appBorderRadius - 1}px ${t.appBorderRadius - 1}px`
  } : {},
  ({ absolute: e, bordered: t }) => e ? {
    height: `calc(100% - ${t ? 42 : 40}px)`,
    position: "absolute",
    left: 0 + (t ? 1 : 0),
    right: 0 + (t ? 1 : 0),
    bottom: 0 + (t ? 1 : 0),
    top: 40 + (t ? 1 : 0),
    overflow: "auto",
    [`& > *:first-child${l3}`]: {
      position: "absolute",
      left: 0 + (t ? 1 : 0),
      right: 0 + (t ? 1 : 0),
      bottom: 0 + (t ? 1 : 0),
      top: 0 + (t ? 1 : 0),
      height: `calc(100% - ${t ? 2 : 0}px)`,
      overflow: "auto"
    }
  } : {}
), u3 = /* @__PURE__ */ o(({ active: e, render: t, children: r }) => /* @__PURE__ */ Ne.createElement(F0, { active: e }, t ? t() : r), "TabW\
rapper");
var G0 = class G0 extends bd {
  constructor(t) {
    super(t), this.state = { hasError: !1 };
  }
  static getDerivedStateFromError() {
    return { hasError: !0 };
  }
  componentDidCatch(t, r) {
    console.error("Error rendering addon panel"), console.error(t), console.error(r.componentStack);
  }
  render() {
    return this.state.hasError && this.props.active ? /* @__PURE__ */ Ne.createElement(
      xo,
      {
        title: "This addon has errors",
        description: "Check your browser logs and addon code to pinpoint what went wrong. This issue was not caused by Storybook."
      }
    ) : this.props.children;
  }
};
o(G0, "TabErrorBoundary");
var W0 = G0, q0 = o3(
  ({
    children: e,
    selected: t = null,
    actions: r,
    absolute: n = !1,
    bordered: a = !1,
    tools: i = null,
    backgroundColor: c,
    id: l = null,
    menuName: s = "Tabs",
    emptyState: u,
    showToolsWhenEmpty: f
  }) => {
    let d = a3(
      () => gd(e).map((v, w) => ({
        ...v,
        active: t ? v.id === t : w === 0
      })),
      [e, t]
    ), { visibleList: m, tabBarRef: g, tabRefs: x, AddonTab: p } = xd(d), h = u ?? /* @__PURE__ */ Ne.createElement(xo, { title: "Nothing fo\
und" });
    return !f && d.length === 0 ? h : (
      // @ts-expect-error (non strict)
      /* @__PURE__ */ Ne.createElement(c3, { absolute: n, bordered: a, id: l }, /* @__PURE__ */ Ne.createElement(go, { scrollable: !1, border: !0,
      backgroundColor: c }, /* @__PURE__ */ Ne.createElement(U0, { style: { whiteSpace: "normal" }, ref: g, role: "tablist" }, m.map(({ title: v,
      id: w, active: R, color: y }, E) => {
        let b = `index-${E}`;
        return /* @__PURE__ */ Ne.createElement(
          Zt,
          {
            id: `tabbutton-${i3(w) ?? b}`,
            ref: (C) => {
              x.current.set(w, C);
            },
            className: `tabbutton ${R ? "tabbutton-active" : ""}`,
            type: "button",
            key: w,
            active: R,
            textColor: y,
            onClick: (C) => {
              C.preventDefault(), r.onSelect(w);
            },
            role: "tab"
          },
          typeof v == "function" ? /* @__PURE__ */ Ne.createElement("title", null) : v
        );
      }), /* @__PURE__ */ Ne.createElement(p, { menuName: s, actions: r })), i), /* @__PURE__ */ Ne.createElement(s3, { id: "panel-tab-conte\
nt", bordered: a, absolute: n }, d.length ? d.map(({ id: v, active: w, render: R }) => /* @__PURE__ */ Ne.createElement(W0, { key: v, active: w },
      Ne.createElement(R, { active: w }, null))) : h))
    );
  }
);
q0.displayName = "Tabs";
var yo = class yo extends bd {
  constructor(r) {
    super(r);
    this.handlers = {
      onSelect: /* @__PURE__ */ o((r) => this.setState({ selected: r }), "onSelect")
    };
    this.state = {
      selected: r.initial
    };
  }
  render() {
    let { bordered: r = !1, absolute: n = !1, children: a, backgroundColor: i, menuName: c } = this.props, { selected: l } = this.state;
    return /* @__PURE__ */ Ne.createElement(
      q0,
      {
        bordered: r,
        absolute: n,
        selected: l,
        backgroundColor: i,
        menuName: c,
        actions: this.handlers
      },
      a
    );
  }
};
o(yo, "TabsState"), yo.defaultProps = {
  children: [],
  // @ts-expect-error (non strict)
  initial: null,
  absolute: !1,
  bordered: !1,
  backgroundColor: "",
  // @ts-expect-error (non strict)
  menuName: void 0
};
var $0 = yo;

// src/components/components/bar/separator.tsx
import yd, { Fragment as f3 } from "react";
import { styled as d3 } from "storybook/theming";
var X0 = d3.span(
  ({ theme: e }) => ({
    width: 1,
    height: 20,
    background: e.appBorderColor,
    marginLeft: 2,
    marginRight: 2
  }),
  ({ force: e }) => e ? {} : {
    "& + &": {
      display: "none"
    }
  }
);
X0.displayName = "Separator";
var p3 = /* @__PURE__ */ o((e) => e.reduce(
  (t, r, n) => r ? /* @__PURE__ */ yd.createElement(f3, { key: r.id || r.key || `f-${n}` }, t, n > 0 ? /* @__PURE__ */ yd.createElement(X0, {
  key: `s-${n}` }) : null, r.render() || r) : t,
  null
), "interleaveSeparators");

// src/components/components/addon-panel/addon-panel.tsx
import m3, { useEffect as h3, useRef as v3 } from "react";
var g3 = /* @__PURE__ */ o((e) => {
  let t = v3();
  return h3(() => {
    t.current = e;
  }, [e]), t.current;
}, "usePrevious"), w3 = /* @__PURE__ */ o((e, t) => {
  let r = g3(t);
  return e ? t : r;
}, "useUpdate"), R3 = /* @__PURE__ */ o(({ active: e, children: t }) => (
  // the hidden attribute is an valid html element that's both accessible and works to visually hide content
  /* @__PURE__ */ m3.createElement("div", { hidden: !e }, w3(e, t))
), "AddonPanel");

// src/components/brand/StorybookLogo.tsx
import at from "react";
var x3 = /* @__PURE__ */ o(({ alt: e, ...t }) => /* @__PURE__ */ at.createElement("svg", { width: "200px", height: "40px", viewBox: "0 0 200\
 40", ...t, role: "img" }, e ? /* @__PURE__ */ at.createElement("title", null, e) : null, /* @__PURE__ */ at.createElement("defs", null, /* @__PURE__ */ at.
createElement(
  "path",
  {
    d: "M1.2 36.9L0 3.9c0-1.1.8-2 1.9-2.1l28-1.8a2 2 0 0 1 2.2 1.9 2 2 0 0 1 0 .1v36a2 2 0 0 1-2 2 2 2 0 0 1-.1 0L3.2 38.8a2 2 0 0 1-2-2z",
    id: "a"
  }
)), /* @__PURE__ */ at.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ at.createElement(
  "path",
  {
    d: "M53.3 31.7c-1.7 0-3.4-.3-5-.7-1.5-.5-2.8-1.1-3.9-2l1.6-3.5c2.2 1.5 4.6 2.3 7.3 2.3 1.5 0 2.5-.2 3.3-.7.7-.5 1.1-1 1.1-1.9 0-.7-.3-1.\
3-1-1.7s-2-.8-3.7-1.2c-2-.4-3.6-.9-4.8-1.5-1.1-.5-2-1.2-2.6-2-.5-1-.8-2-.8-3.2 0-1.4.4-2.6 1.2-3.6.7-1.1 1.8-2 3.2-2.6 1.3-.6 2.9-.9 4.7-.9 \
1.6 0 3.1.3 4.6.7 1.5.5 2.7 1.1 3.5 2l-1.6 3.5c-2-1.5-4.2-2.3-6.5-2.3-1.3 0-2.3.2-3 .8-.8.5-1.2 1.1-1.2 2 0 .5.2 1 .5 1.3.2.3.7.6 1.4.9l2.9.\
8c2.9.6 5 1.4 6.2 2.4a5 5 0 0 1 2 4.2 6 6 0 0 1-2.5 5c-1.7 1.2-4 1.9-7 1.9zm21-3.6l1.4-.1-.2 3.5-1.9.1c-2.4 0-4.1-.5-5.2-1.5-1.1-1-1.6-2.7-1\
.6-4.8v-6h-3v-3.6h3V11h4.8v4.6h4v3.6h-4v6c0 1.8.9 2.8 2.6 2.8zm11.1 3.5c-1.6 0-3-.3-4.3-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6.4-3 1-4.\
3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.3-1 1.7 0 3.2.3 4.4 1a7 7 0 0 1 3 2.8c.6 1.2 1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-2.7 1-4.\
4 1zm0-3.6c2.4 0 3.6-1.6 3.6-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.6-1c-2.3 0-3.5 1.4-3.5 4.4 0 3 1.2 4.6 3.5 4.6zm21.7-8.8l-2.7.3c-1.3.2-2\
.3.5-2.8 1.2-.6.6-.9 1.4-.9 2.5v8.2H96V15.7h4.6v2.6c.8-1.8 2.5-2.8 5-3h1.3l.3 4zm14-3.5h4.8L116.4 37h-4.9l3-6.6-6.4-14.8h5l4 10 4-10zm16-.4c\
1.4 0 2.6.3 3.6 1 1 .6 1.9 1.6 2.5 2.8.6 1.2.9 2.7.9 4.3 0 1.6-.3 3-1 4.3a6.9 6.9 0 0 1-2.4 2.9c-1 .7-2.2 1-3.6 1-1 0-2-.2-3-.7-.8-.4-1.5-1-\
2-1.9v2.4h-4.7V8.8h4.8v9c.5-.8 1.2-1.4 2-1.9.9-.4 1.8-.6 3-.6zM135.7 28c1.1 0 2-.4 2.6-1.2.6-.8 1-2 1-3.4 0-1.5-.4-2.5-1-3.3s-1.5-1.1-2.6-1.\
1-2 .3-2.6 1.1c-.6.8-1 2-1 3.3 0 1.5.4 2.6 1 3.4.6.8 1.5 1.2 2.6 1.2zm18.9 3.6c-1.7 0-3.2-.3-4.4-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6\
.4-3 1-4.3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.4-1 1.6 0 3 .3 4.3 1a7 7 0 0 1 3 2.8c.6 1.2 1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-\
2.7 1-4.3 1zm0-3.6c2.3 0 3.5-1.6 3.5-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.5-1c-2.4 0-3.6 1.4-3.6 4.4 0 3 1.2 4.6 3.6 4.6zm18 3.6c-1.7 0-3.\
2-.3-4.4-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6.4-3 1-4.3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.4-1 1.6 0 3 .3 4.4 1a7 7 0 0 1 2.9 2.8c.6 1.2 \
1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-2.7 1-4.3 1zm0-3.6c2.3 0 3.5-1.6 3.5-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.5-1c-2.4 0\
-3.6 1.4-3.6 4.4 0 3 1.2 4.6 3.6 4.6zm27.4 3.4h-6l-6-7v7h-4.8V8.8h4.9v13.6l5.8-6.7h5.7l-6.6 7.5 7 8.2z",
    fill: "currentColor"
  }
), /* @__PURE__ */ at.createElement("mask", { id: "b", fill: "#fff" }, /* @__PURE__ */ at.createElement("use", { xlinkHref: "#a" })), /* @__PURE__ */ at.
createElement("use", { fill: "#FF4785", fillRule: "nonzero", xlinkHref: "#a" }), /* @__PURE__ */ at.createElement(
  "path",
  {
    d: "M23.7 5L24 .2l3.9-.3.1 4.8a.3.3 0 0 1-.5.2L26 3.8l-1.7 1.4a.3.3 0 0 1-.5-.3zm-5 10c0 .9 5.3.5 6 0 0-5.4-2.8-8.2-8-8.2-5.3 0-8.2 2.8-\
8.2 7.1 0 7.4 10 7.6 10 11.6 0 1.2-.5 1.9-1.8 1.9-1.6 0-2.2-.9-2.1-3.6 0-.6-6.1-.8-6.3 0-.5 6.7 3.7 8.6 8.5 8.6 4.6 0 8.3-2.5 8.3-7 0-7.9-10\
.2-7.7-10.2-11.6 0-1.6 1.2-1.8 2-1.8.6 0 2 0 1.9 3z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#b)"
  }
))), "StorybookLogo");

// src/components/brand/StorybookIcon.tsx
import Pr from "react";
var b3 = /* @__PURE__ */ o((e) => /* @__PURE__ */ Pr.createElement("svg", { viewBox: "0 0 64 64", ...e }, /* @__PURE__ */ Pr.createElement("\
title", null, "Storybook icon"), /* @__PURE__ */ Pr.createElement("g", { id: "Artboard", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "\
evenodd" }, /* @__PURE__ */ Pr.createElement(
  "path",
  {
    d: "M8.04798541,58.7875918 L6.07908839,6.32540407 C6.01406344,4.5927838 7.34257463,3.12440831 9.07303814,3.01625434 L53.6958037,0.227331\
489 C55.457209,0.117243658 56.974354,1.45590096 57.0844418,3.21730626 C57.0885895,3.28366922 57.0906648,3.35014546 57.0906648,3.41663791 L57\
.0906648,60.5834697 C57.0906648,62.3483119 55.6599776,63.7789992 53.8951354,63.7789992 C53.847325,63.7789992 53.7995207,63.7779262 53.751758\
5,63.775781 L11.0978899,61.8600599 C9.43669044,61.7854501 8.11034889,60.4492961 8.04798541,58.7875918 Z",
    id: "path-1",
    fill: "#FF4785",
    fillRule: "nonzero"
  }
), /* @__PURE__ */ Pr.createElement(
  "path",
  {
    d: "M35.9095005,24.1768792 C35.9095005,25.420127 44.2838488,24.8242707 45.4080313,23.9509748 C45.4080313,15.4847538 40.8652557,11.035887\
8 32.5466666,11.0358878 C24.2280775,11.0358878 19.5673077,15.553972 19.5673077,22.3311017 C19.5673077,34.1346028 35.4965208,34.3605071 35.49\
65208,40.7987804 C35.4965208,42.606015 34.6115646,43.6790606 32.6646607,43.6790606 C30.127786,43.6790606 29.1248356,42.3834613 29.2428298,37\
.9783269 C29.2428298,37.0226907 19.5673077,36.7247626 19.2723223,37.9783269 C18.5211693,48.6535354 25.1720308,51.7326752 32.7826549,51.73267\
52 C40.1572906,51.7326752 45.939005,47.8018145 45.939005,40.6858282 C45.939005,28.035186 29.7738035,28.3740425 29.7738035,22.1051974 C29.773\
8035,19.5637737 31.6617103,19.2249173 32.7826549,19.2249173 C33.9625966,19.2249173 36.0864917,19.4328883 35.9095005,24.1768792 Z",
    id: "path9_fill-path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }
), /* @__PURE__ */ Pr.createElement(
  "path",
  {
    d: "M44.0461638,0.830433986 L50.1874092,0.446606143 L50.443532,7.7810017 C50.4527198,8.04410717 50.2468789,8.26484453 49.9837734,8.27403\
237 C49.871115,8.27796649 49.7607078,8.24184808 49.6721567,8.17209069 L47.3089847,6.3104681 L44.5110468,8.43287463 C44.3012992,8.591981 44.0\
022839,8.55092814 43.8431776,8.34118051 C43.7762017,8.25288717 43.742082,8.14401677 43.7466857,8.03329059 L44.0461638,0.830433986 Z",
    id: "Path",
    fill: "#FFFFFF"
  }
))), "StorybookIcon");

// src/components/components/Loader/Loader.tsx
import mt from "react";
import { transparentize as E3 } from "polished";
import { keyframes as C3, styled as Kt } from "storybook/theming";

// src/components/components/shared/animation.ts
import { keyframes as y3 } from "storybook/theming";
var Ed = y3`
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`;

// src/components/components/Loader/Loader.tsx
var S3 = Kt.div(({ size: e = 32 }) => ({
  borderRadius: "50%",
  cursor: "progress",
  display: "inline-block",
  overflow: "hidden",
  position: "absolute",
  transition: "all 200ms ease-out",
  verticalAlign: "top",
  top: "50%",
  left: "50%",
  marginTop: -(e / 2),
  marginLeft: -(e / 2),
  height: e,
  width: e,
  zIndex: 4,
  borderWidth: 2,
  borderStyle: "solid",
  borderColor: "rgba(97, 97, 97, 0.29)",
  borderTopColor: "rgb(100,100,100)",
  animation: `${Ed} 0.7s linear infinite`,
  mixBlendMode: "difference"
})), Cd = Kt.div({
  position: "absolute",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%"
}), M3 = Kt.div(({ theme: e }) => ({
  position: "relative",
  width: "80%",
  marginBottom: "0.75rem",
  maxWidth: 300,
  height: 5,
  borderRadius: 5,
  background: E3(0.8, e.color.secondary),
  overflow: "hidden",
  cursor: "progress"
})), L3 = Kt.div(({ theme: e }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  height: "100%",
  background: e.color.secondary
})), Sd = Kt.div(({ theme: e }) => ({
  minHeight: "2em",
  fontSize: `${e.typography.size.s1}px`,
  color: e.textMutedColor
})), A3 = Kt(f5)(({ theme: e }) => ({
  width: 20,
  height: 20,
  marginBottom: "0.5rem",
  color: e.textMutedColor
})), I3 = C3`
  from { content: "..." }
  33% { content: "." }
  66% { content: ".." }
  to { content: "..." }
`, H3 = Kt.span({
  "&::after": {
    content: "'...'",
    animation: `${I3} 1s linear infinite`,
    animationDelay: "1s",
    display: "inline-block",
    width: "1em",
    height: "auto"
  }
}), T3 = /* @__PURE__ */ o(({ progress: e, error: t, size: r, ...n }) => {
  if (t)
    return /* @__PURE__ */ mt.createElement(Cd, { "aria-label": t.toString(), "aria-live": "polite", role: "status", ...n }, /* @__PURE__ */ mt.
    createElement(A3, null), /* @__PURE__ */ mt.createElement(Sd, null, t.message));
  if (e) {
    let { value: a, modules: i } = e, { message: c } = e;
    return i && (c += ` ${i.complete} / ${i.total} modules`), /* @__PURE__ */ mt.createElement(
      Cd,
      {
        "aria-label": "Content is loading...",
        "aria-live": "polite",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": a * 100,
        "aria-valuetext": c,
        role: "progressbar",
        ...n
      },
      /* @__PURE__ */ mt.createElement(M3, null, /* @__PURE__ */ mt.createElement(L3, { style: { width: `${a * 100}%` } })),
      /* @__PURE__ */ mt.createElement(Sd, null, c, a < 1 && /* @__PURE__ */ mt.createElement(H3, { key: c }))
    );
  }
  return /* @__PURE__ */ mt.createElement(
    S3,
    {
      "aria-label": "Content is loading...",
      "aria-live": "polite",
      role: "status",
      size: r,
      ...n
    }
  );
}, "Loader");

// src/components/components/ProgressSpinner/ProgressSpinner.tsx
import Lt from "react";
import { keyframes as z3, styled as Ld } from "storybook/theming";
var Z0 = "http://www.w3.org/2000/svg", P3 = z3({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), Md = Ld.div(({ size: e }) => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  minWidth: e,
  minHeight: e
})), Y0 = Ld.svg(
  ({ size: e, width: t }) => ({
    position: "absolute",
    width: `${e}px!important`,
    height: `${e}px!important`,
    transform: "rotate(-90deg)",
    circle: {
      r: (e - Math.ceil(t)) / 2,
      cx: e / 2,
      cy: e / 2,
      opacity: 0.15,
      fill: "transparent",
      stroke: "currentColor",
      strokeWidth: t,
      strokeLinecap: "round",
      strokeDasharray: Math.PI * (e - Math.ceil(t))
    }
  }),
  ({ progress: e }) => e && {
    circle: {
      opacity: 0.75
    }
  },
  ({ spinner: e }) => e && {
    animation: `${P3} 1s linear infinite`,
    circle: {
      opacity: 0.25
    }
  }
), k3 = /* @__PURE__ */ o(({
  percentage: e = void 0,
  running: t = !0,
  size: r = 24,
  width: n = 1.5,
  children: a = null,
  ...i
}) => typeof e == "number" ? /* @__PURE__ */ Lt.createElement(Md, { size: r, ...i }, a, /* @__PURE__ */ Lt.createElement(Y0, { size: r, width: n,
xmlns: Z0 }, /* @__PURE__ */ Lt.createElement("circle", null)), t && /* @__PURE__ */ Lt.createElement(Y0, { size: r, width: n, xmlns: Z0, spinner: !0 },
/* @__PURE__ */ Lt.createElement("circle", { strokeDashoffset: Math.PI * (r - Math.ceil(n)) * (1 - e / 100) })), /* @__PURE__ */ Lt.createElement(
Y0, { size: r, width: n, xmlns: Z0, progress: !0 }, /* @__PURE__ */ Lt.createElement("circle", { strokeDashoffset: Math.PI * (r - Math.ceil(
n)) * (1 - e / 100) }))) : /* @__PURE__ */ Lt.createElement(Md, { size: r, ...i }, a), "ProgressSpinner");

// src/components/components/utils/getStoryHref.ts
function B3(e) {
  let t = {}, r = e.split("&");
  for (let n = 0; n < r.length; n++) {
    let a = r[n].split("=");
    t[decodeURIComponent(a[0])] = decodeURIComponent(a[1] || "");
  }
  return t;
}
o(B3, "parseQuery");
var O3 = /* @__PURE__ */ o((e, t, r = {}) => {
  let [n, a] = e.split("?"), i = a ? {
    ...B3(a),
    ...r,
    id: t
  } : {
    ...r,
    id: t
  };
  return `${n}?${Object.entries(i).map((c) => `${c[0]}=${c[1]}`).join("&")}`;
}, "getStoryHref");

// src/components/components/clipboard/ClipboardCode.tsx
import N3 from "react";
import { color as D3, styled as _3, typography as Ad } from "storybook/theming";
var F3 = _3.pre`
  line-height: 18px;
  padding: 11px 1rem;
  white-space: pre-wrap;
  background: rgba(0, 0, 0, 0.05);
  color: ${D3.darkest};
  border-radius: 3px;
  margin: 1rem 0;
  width: 100%;
  display: block;
  overflow: hidden;
  font-family: ${Ad.fonts.mono};
  font-size: ${Ad.size.s2 - 1}px;
`, V3 = /* @__PURE__ */ o(({ code: e, ...t }) => /* @__PURE__ */ N3.createElement(F3, { id: "clipboard-code", ...t }, e), "ClipboardCode");

// src/components/index.ts
var uz = ja, j3 = {};
Object.keys(ja).forEach((e) => {
  j3[e] = $3((t, r) => W3(e, { ...t, ref: r }));
});
export {
  So as A,
  ha as ActionBar,
  R3 as AddonPanel,
  Cm as Badge,
  _0 as Bar,
  Mo as Blockquote,
  gr as Button,
  V3 as ClipboardCode,
  Sa as Code,
  Ma as DL,
  La as Div,
  Tm as DocumentWrapper,
  xo as EmptyTabContent,
  Gv as ErrorFormatter,
  go as FlexBar,
  mg as Form,
  Aa as H1,
  Ia as H2,
  Ha as H3,
  Ta as H4,
  za as H5,
  Pa as H6,
  ka as HR,
  Jn as IconButton,
  Ba as Img,
  Oa as LI,
  qa as Link,
  B0 as ListItem,
  T3 as Loader,
  gv as Modal,
  Na as OL,
  Da as P,
  Lv as Placeholder,
  _a as Pre,
  k3 as ProgressSpinner,
  ll as ResetWrapper,
  ur as ScrollArea,
  X0 as Separator,
  yv as Spaced,
  Fa as Span,
  b3 as StorybookIcon,
  x3 as StorybookLogo,
  b5 as SyntaxHighlighter,
  Va as TT,
  U0 as TabBar,
  Zt as TabButton,
  u3 as TabWrapper,
  Wa as Table,
  q0 as Tabs,
  $0 as TabsState,
  O0 as TooltipLinkList,
  x7 as TooltipMessage,
  C7 as TooltipNote,
  $a as UL,
  d7 as WithTooltip,
  m7 as WithTooltipPure,
  Dv as Zoom,
  it as codeCommon,
  uz as components,
  Ea as createCopyToClipboardFunction,
  O3 as getStoryHref,
  p3 as interleaveSeparators,
  K as nameSpaceClassNames,
  j3 as resetComponents,
  N as withReset
};
